import React, { useState, useEffect, useRef, useContext } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Link, useNavigate, Navigate, useLocation } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import axios from 'axios';
import { QuizProvider, useQuiz } from './QuizContext'; // Import the QuizProvider
import Redirector from './Redirector'; // New component for handling redirection
import StepWrapper from './StepWrapper';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';




// Initialize the pixel
ReactPixel.init('1491164071713366');
ReactPixel.pageView();  // This triggers the page view event on website load


// Quiz Steps
const steps = [
  {
    id: 1,
    component: Gender
  },
  {
    id: 2,
    component: SuccessStories
  },
  {
    id: 3,
    component: CurrentBody
  },
  {
    id: 4,
    component: GoalBody
  },
  {
    id: 5,
    component: References
  },
  {
    id: 6,
    component: Challenges
  },
  {
    id: 7,
    component: Exercise
  },
  {
    id: 8,
    component: Chart
  },
  {
    id: 9,
    component: Height
  },
  {
    id: 10,
    component: CurrentWeight
  },
  {
    id: 11,
    component: GoalWeight
  },
  {
    id: 12,
    component: Age
  },
  {
    id: 13,
    component: BodyComposition
  },
  {
    id: 14,
    component: Diets
  },
  {
    id: 15,
    component: ActivityLevel
  },
  {
    id: 16,
    component: CompositionResults
  },
  {
    id: 17,
    component: FatBurning
  },
  {
    id: 18,
    component: GoalChart
  },
  {
    id: 19,
    component: LoadingResults
  },
  {
    id: 20,
    component: Email
  },
  {
    id: 21,
    component: Results
  }

];

// Start Component
function Start() {
  const navigate = useNavigate();
  const location = useLocation();

  // Function to get query params (like sub2)
  const getQueryParam = (param) => {
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get(param);
  };

  useEffect(() => {
    // Capture the sub2 from the URL and store it in localStorage
    const sub2 = getQueryParam('sub2');
    if (sub2) {
      localStorage.setItem('sub2', sub2);  // Store sub2 in localStorage
    } else {
      console.error('No sub2 found in the URL.');
    }
  }, [location]);

  const handleNext = () => {
    // Ensure that sub2 is stored before proceeding to the next step
    const sub2 = localStorage.getItem('sub2');
    if (sub2) {
      navigate(`/step/1?sub2=${sub2}`);  // Pass the sub2 to the next step
    } else {
      console.error('No sub2 found in localStorage.');
      navigate(`/step/1?sub2=${sub2}`);  // Pass the sub2 to the next step
    }
  };

  return (
    <div>
      <section className="intro" id="top">
        <div className="container">
          <div className="row">
            <div className="col-md-7 col-sm-6 col-xs-12">
              <div className="content">
                <div className="logo">
                  <img
                    src={"https://leanformula.co/wp-content/uploads/2024/07/leanformula-logo-purple-dark.svg"}
                    alt="logo"
                    className="logo__img"
                    width="200px"
                  />
                </div>
                <h1>
                  Create the perfect weight loss plan tailored for your needs.
                </h1>
                <div className="text text-big">
                  Weight loss plans to build a toned and sexy body, control your appetite, and improve your life.
                </div>
                <button onClick={handleNext} className="sc-gsnTZi kxBUCB" data-locator="malePulseGenderBtn"><p type="medium-button" color="on-primary" className="sc-jSMfEi dmpIyk">Start Quiz</p></button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <button data-locator="StartLoginButton" className="Gender-module-loginLink--SnkVa">Log in</button> */}
    </div>
  );
}

// OLD Gender Component
function GenderOld() {
  const navigate = useNavigate();
  const location = useLocation();
  const { updateQuizData } = useQuiz();

  // Function to get query params (like sub2)
  const getQueryParam = (param) => {
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get(param);
  };

  useEffect(() => {
    // Capture the sub2 from the URL and store it in localStorage
    const sub2 = getQueryParam('sub2');
    if (sub2) {
      localStorage.setItem('sub2', sub2);  // Store sub2 in localStorage
    } else {
      console.error('No sub2 found in the URL.');
    }
  }, [location]);

  const handleNext = (gender) => {
    updateQuizData({ gender });

    // Retrieve the sub2 from localStorage to pass it to the next step
    const sub2 = localStorage.getItem('sub2');
    if (sub2) {
      navigate(`/step/2?sub2=${sub2}`);  // Pass the sub2 to step 2
    } else {
      console.error('No sub2 found in localStorage.');
      navigate('/step/2');  // Proceed without sub2 if not found (fallback)
    }
  };

  return (
    <div>
      <div id="gender">
        <div className="Gender-module-container--Bgddf Gender-module-pulse--+XAo5 Gender-module-indexPage--shrkP" style={{ minHeight: 392 }}>
          <p type="h4" color="text-secondary" className="sc-jSMfEi gmLanq">Let's Create Your Body Profile</p>
          <p type="large-text" color="text-secondary-subdued" className="sc-jSMfEi kFjGHT">Select your gender:</p>
          <div className="Gender-module-genderChoice--YZO2v">
            <div className="GenderOptionBox-module-optionWrapper---9vyi">
              <div className="GenderOption-module-genderBox--A0WhC">
                <div className="GenderOption-module-genderImageBox--2MuRT">
                  <div style={{ minHeight: 20 }}>
                    <img src={`${process.env.PUBLIC_URL}../assets/images/male-gender.png`} />
                  </div>
                </div>
                <button className="sc-gsnTZi kxBUCB" data-locator="malePulseGenderBtn" onClick={() => handleNext('Male')}><p type="medium-button" color="on-primary" className="sc-jSMfEi dmpIyk">Male</p></button>
              </div>
              <div className="GenderOption-module-genderBox--A0WhC">
                <div className="GenderOption-module-genderImageBox--2MuRT">
                  <div style={{ minHeight: 20 }}>
                    <img src={`${process.env.PUBLIC_URL}../assets/images/female-gender.png`} />
                  </div>
                </div>
                <button className="sc-gsnTZi gAiOLN" data-locator="femalePulseGenderBtn" onClick={() => handleNext('Female')}><p type="medium-button" color="on-primary" className="sc-jSMfEi dmpIyk">Female</p></button>
              </div>
            </div>
          </div>
          <div className="Gender-module-indexFooterContainer--4UjbA">
            <p className="Text-module-default--9nb4F Text-module-caption--MeFDb Text-module-grey--mn9R0 Text-module-transparence---YABR Common-module-centered--f1oqe ">By pressing the “Male” or “Female” button, you confirm and guarantee that you have read, understood, and agreed to our <a href="https://leanformula.co/terms-and-conditions/" className="Common-module-colorBrand--3FTX+" target="_blank" rel="noopener noreferrer" data-locator="termsOfUseLink">Terms of Use</a> and<a href="https://leanformula.co/privacy-policy/" className="Common-module-colorBrand--3FTX+" target="_blank" rel="noopener noreferrer" data-locator="privacyPolicyLink"> Privacy Policy</a>.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

// Gender Component
function Gender() {
  const navigate = useNavigate();
  const location = useLocation();
  const { updateQuizData } = useQuiz();

  // Function to get query params (like sub2)
  const getQueryParam = (param) => {
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get(param);
  };

  useEffect(() => {
    // Capture the sub2 from the URL and store it in localStorage
    const sub2 = getQueryParam('sub2');
    if (sub2) {
      localStorage.setItem('sub2', sub2);  // Store sub2 in localStorage
    } else {
      console.error('No sub2 found in the URL.');
    }
  }, [location]);

  const handleNext = (gender) => {
    updateQuizData({ gender });

    // Retrieve the sub2 from localStorage to pass it to the next step
    const sub2 = localStorage.getItem('sub2');
    if (sub2) {
      navigate(`/step/2?sub2=${sub2}`);  // Pass the sub2 to step 2
    } else {
      console.error('No sub2 found in localStorage.');
      navigate('/step/2');  // Proceed without sub2 if not found (fallback)
    }
  };

  return (
    <div>
      <div id="gender">
        <div className="Gender-module-container--Bgddf Gender-module-pulse--+XAo5 Gender-module-indexPage--shrkP" style={{ minHeight: 392 }}>
          <p type="h4" color="text-secondary" className="sc-jSMfEi gmLanq">Let's Create Your Body Profile</p>
          <p type="large-text" color="text-secondary-subdued" className="sc-jSMfEi kFjGHT">Select your gender:</p>
          <div className="Gender-module-genderChoice--YZO2v">
            <div className="GenderOptionBox-module-optionWrapper---9vyi">
              <div className="GenderOption-module-genderBox--A0WhC">
                <div className="GenderOption-module-genderImageBox--2MuRT">
                  <div style={{ minHeight: 20, minWidth: 150, textAlign: 'center' }}>
                    <svg data-v-3d62f655="" width="150" height="150" viewBox="0 0 54 119" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-3d62f655="" fill-rule="evenodd" clip-rule="evenodd" d="M26.9658 0C26.3914 0.000173559 24.7151 0.0458196 23.3719 1.24564C23.0171 1.56267 22.6834 2.07386 22.6848 2.73414C22.6856 3.14825 22.284 2.98493 21.9052 3.7354C21.5763 4.38712 21.6318 5.47042 21.7767 6.40625C21.8431 6.835 21.959 7.2461 22.0012 7.62758C21.7637 7.52565 21.4464 7.65385 21.4013 8.02503C21.2909 8.93344 21.8419 9.19361 21.8771 9.74206C21.8872 9.89948 21.8348 10.2365 21.932 10.4757C22.0472 10.7591 22.3779 10.7656 22.523 10.6038C22.5877 11.304 22.6184 11.8966 22.6489 12.1769C22.7636 13.2306 23.0244 13.5045 23.4695 14.032C24.1341 14.8194 24.7949 15.305 25.4633 15.7868C25.7148 15.9682 25.8332 16.2655 25.6629 16.1901C25.1421 15.9593 24.1593 15.2826 23.707 14.9526C23.8247 16.1782 23.9552 16.7392 23.2773 17.6204C22.8403 18.2387 20.8023 18.7944 19.1893 19.4945C18.6841 19.7137 17.1972 20.5281 15.9916 20.7004C12.3831 21.2161 11.7329 23.3129 11.7787 26.2394C11.7966 27.3849 11.7665 28.5578 11.612 29.9949C11.4733 31.2833 11.3218 32.7052 11.2613 33.696C11.0426 37.2839 11.2741 38.7819 10.6729 40.9288C10.284 42.3183 9.37104 43.2651 8.8352 45.3044C7.89248 48.8956 7.18495 53.6937 5.35947 56.5682C4.86919 57.2192 3.94625 58.182 3.63212 58.5906C3.369 58.9336 3.21211 59.4534 2.91967 60.0346C2.68853 60.496 2.39199 60.824 1.93462 61.3524C1.70568 61.6175 1.37177 61.8274 0.984668 62.0384C0.292053 62.4165 0.618728 63.0782 1.16087 62.9821C1.461 62.9291 1.96163 62.8548 2.38389 62.6233C2.77053 62.4108 3.16984 61.9421 3.36536 61.7747C3.50912 61.6518 3.50056 61.7953 3.51276 61.7968C3.29325 62.0013 3.19818 62.3325 3.01839 62.7405C2.85253 63.1174 2.6281 63.6311 2.48659 63.8149C1.88228 64.6053 1.6327 64.7801 0.877858 65.6441C0.467332 66.1144 0.622313 66.4117 1.07251 66.5895C1.20777 66.6426 1.43035 66.7944 1.56914 66.9007C1.69035 66.9937 1.86112 67.0655 2.06213 67.0591C2.35463 67.0502 2.56865 66.9902 2.85797 66.9183C3.00353 66.882 3.23652 66.8568 3.369 66.8059C3.57805 66.7256 3.7664 66.6272 3.91965 66.5117C4.41356 66.1378 5.33379 65.2861 5.73888 64.6555C6.14443 64.0249 6.76048 63.1191 6.93709 62.6629C7.7523 60.5721 8.01276 60.0601 8.51749 58.3787C8.84735 57.2814 9.37596 56.2345 9.85993 55.259C9.8841 55.2104 11.5634 52.8299 12.9254 50.0721C13.4984 48.9119 14.3762 46.8208 14.7727 45.7363C15.2253 44.498 15.1639 44.3125 15.2773 43.8113C15.4686 42.9659 16.4481 39.4418 16.9804 34.4964C17.1802 38.0016 17.6958 41.4447 17.6615 42.4771C17.5722 45.1709 17.2098 46.9874 16.8876 48.7665C16.7503 49.5241 16.8713 50.3115 16.7027 51.0349C16.2122 53.1395 15.5223 56.0128 15.2775 57.9541C14.8476 61.3631 14.9421 66.1043 15.1876 70.0726C15.5011 75.1424 15.945 75.6558 16.6414 78.6549C16.896 79.7516 16.8652 81.2283 16.8841 82.3483C16.8998 83.2802 17.1296 84.0185 17.0469 84.9428C16.7823 87.9022 15.7458 90.8114 15.7411 93.2326C15.7359 95.8925 16.1208 97.8203 16.9688 102.889C18.3049 110.876 18.3364 111.595 18.0149 113.804C17.9851 114.009 17.9212 114.529 17.6392 115.065C17.4793 115.369 17.1558 115.824 16.844 116.19C16.552 116.532 15.4028 117.347 15.0828 117.492C14.6516 117.687 14.4587 118.289 14.5853 118.57C14.7485 118.929 15.0054 119 15.5068 119H21.456C22.6385 119 22.7624 118.411 22.7151 117.575C22.6827 116.998 22.4461 116.421 22.3145 115.945C22.1478 115.341 22.1608 115.055 22.0382 114.41C21.9049 113.711 21.721 113.445 21.6498 112.441C21.5268 110.708 21.8778 106.695 22.5507 102.781C22.8915 100.798 24.0789 97.3181 24.3155 95.2872C24.673 92.2179 24.1157 90.8966 23.9037 87.83C23.8065 86.424 24.5281 86.0906 24.7197 84.1532C25.2864 78.4222 25.9307 72.1564 26.8632 63.0544C26.8732 62.9579 26.9115 63.0246 27.0818 63.0246C27.252 63.0246 27.2904 62.9579 27.3003 63.0544C28.2329 72.1564 28.8772 78.4222 29.4438 84.1532C29.6354 86.0906 30.357 86.424 30.2598 87.83C30.0479 90.8966 29.4905 92.2179 29.848 95.2872C30.0846 97.3181 31.272 100.798 31.6129 102.781C32.2858 106.695 32.6367 110.708 32.5137 112.441C32.4426 113.445 32.2587 113.711 32.1252 114.41C32.0027 115.055 32.0158 115.341 31.8491 115.945C31.7175 116.421 31.4809 116.998 31.4485 117.575C31.4011 118.411 31.525 119 32.7075 119H38.6567C39.1582 119 39.4151 118.929 39.5782 118.57C39.7048 118.289 39.512 117.687 39.0807 117.492C38.7607 117.347 37.6116 116.532 37.3195 116.19C37.0077 115.824 36.6843 115.369 36.5245 115.065C36.2423 114.529 36.1784 114.009 36.1486 113.804C35.8271 111.595 35.8586 110.876 37.1947 102.889C38.0427 97.8203 38.4277 95.8925 38.4224 93.2326C38.4176 90.8114 37.3812 87.9022 37.1166 84.9428C37.0339 84.0185 37.2637 83.2802 37.2795 82.3483C37.2983 81.2283 37.2675 79.7516 37.5222 78.6549C38.2186 75.6558 38.6625 75.1424 38.976 70.0726C39.2214 66.1043 39.316 61.3631 38.886 57.9541C38.6412 56.0128 37.9513 53.1395 37.4609 51.0349C37.2922 50.3115 37.4132 49.5241 37.276 48.7665C36.9538 46.9874 36.5913 45.1709 36.502 42.4771C36.4678 41.4447 36.9833 38.0016 37.1831 34.4964C37.7154 39.4418 38.695 42.9659 38.8862 43.8113C38.9996 44.3125 38.9382 44.498 39.3908 45.7363C39.7873 46.8208 40.6651 48.9119 41.2381 50.0721C42.6 52.8299 44.2794 55.2104 44.3036 55.259C44.7876 56.2345 45.3161 57.2814 45.6461 58.3787C46.1507 60.0601 46.4112 60.5721 47.2264 62.6629C47.4031 63.1191 48.0191 64.0249 48.4247 64.6555C48.8298 65.2861 49.7499 66.1378 50.2438 66.5117C50.3971 66.6272 50.5854 66.7256 50.7946 66.8059C50.927 66.8568 51.16 66.882 51.3056 66.9183C51.5949 66.9902 51.8089 67.0502 52.1014 67.0591C52.3024 67.0655 52.4731 66.9937 52.5944 66.9007C52.7331 66.7944 52.9558 66.6426 53.091 66.5895C53.5412 66.4117 53.6962 66.1144 53.2857 65.6441C52.5309 64.7801 52.2812 64.6053 51.6769 63.8149C51.5354 63.6311 51.311 63.1174 51.1452 62.7405C50.9653 62.3325 50.8702 62.0013 50.6508 61.7968C50.6629 61.7953 50.6544 61.6518 50.7981 61.7747C50.9938 61.9421 51.393 62.4108 51.7797 62.6233C52.2019 62.8548 52.7025 62.9291 53.0027 62.9821C53.3232 63.0389 53.5685 62.8308 53.5722 62.573V62.5612C53.5697 62.3859 53.4557 62.1895 53.1789 62.0384C52.7918 61.8274 52.4578 61.6175 52.2289 61.3524C51.7715 60.824 51.475 60.496 51.2438 60.0346C50.9514 59.4534 50.7946 58.9336 50.5314 58.5906C50.2172 58.182 49.2944 57.2192 48.8041 56.5682C46.9785 53.6937 46.2711 48.8956 45.3284 45.3044C44.7925 43.2651 43.8796 42.3183 43.4907 40.9288C42.8894 38.7819 43.1209 37.2839 42.9022 33.696C42.8418 32.7052 42.6901 31.2833 42.5516 29.9949C42.397 28.5578 42.367 27.3849 42.3849 26.2394C42.4306 23.3129 41.7805 21.2161 38.1719 20.7004C36.9663 20.5281 35.4795 19.7137 34.9742 19.4945C33.3612 18.7944 31.3233 18.2387 30.8862 17.6204C30.2083 16.7392 30.3389 16.1782 30.4565 14.9526C30.0042 15.2826 29.0215 15.9593 28.5006 16.1901C28.3304 16.2655 28.4487 15.9682 28.7002 15.7868C29.3686 15.305 30.0294 14.8194 30.694 14.032C31.1391 13.5045 31.4 13.2306 31.5146 12.1769C31.5452 11.8967 31.5758 11.3041 31.6405 10.6041C31.7857 10.7656 32.1161 10.7589 32.2312 10.4757C32.3285 10.2365 32.2761 9.89948 32.2862 9.74206C32.3213 9.19361 32.8723 8.93344 32.7619 8.02503C32.7169 7.65402 32.3999 7.52576 32.1623 7.62741C32.2045 7.24598 32.3204 6.83494 32.3869 6.40625C32.4379 6.07596 32.4653 5.74504 32.471 5.41956C32.7269 5.3705 33.8455 4.9657 33.6055 3.78463C32.3319 4.36843 31.881 2.00507 29.9339 0.758512C28.7326 -0.0107028 27.4222 0.000289265 27.0818 0.000289265C27.0522 0.000289265 27.0154 0 26.9724 0H26.9658Z" fill="#4E00FF"></path></svg>
                  </div>
                </div>
                <button className="sc-gsnTZi kxBUCB" data-locator="malePulseGenderBtn" onClick={() => handleNext('Male')}><p type="medium-button" color="on-primary" className="sc-jSMfEi dmpIyk">Male</p></button>
              </div>
              <div className="GenderOption-module-genderBox--A0WhC">
                <div className="GenderOption-module-genderImageBox--2MuRT">
                  <div style={{ minHeight: 20, minWidth: 150, textAlign: 'center' }}>
                    <svg data-v-3d62f655="" width="150" height="150" viewBox="0 0 51 119" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-3d62f655="" fill-rule="evenodd" clip-rule="evenodd" d="M25.5795 0.0397949C22.7863 0.0397949 21.1059 1.43954 20.4993 2.92515C19.9905 4.17111 20.1725 5.4761 20.2693 6.07986C20.386 6.80682 20.4329 7.2624 20.4285 7.66092C20.1917 7.56096 19.8772 7.68954 19.8323 8.0592C19.7222 8.96701 20.1381 9.22694 20.1731 9.77508C20.1832 9.9324 20.1309 10.2692 20.228 10.5083C20.3268 10.7517 20.5126 10.8137 20.6547 10.7235C20.6821 11.2154 20.7106 11.6186 20.7556 11.8528C20.9454 12.8384 21.3375 13.4024 21.7816 13.9294C22.4447 14.7164 23.2184 15.3344 23.8853 15.8158C24.1363 15.9971 24.2543 16.2941 24.0844 16.2188C23.5647 15.9882 22.8686 15.5804 22.4172 15.2506C22.5347 16.4754 22.2747 17.4639 21.5982 18.3445C21.4807 18.4929 21.3526 18.629 21.2123 18.7486C20.3455 19.4892 18.6777 20.0858 16.7578 20.4105C14.515 20.7897 12.9611 20.8867 12.169 22.2945C11.4814 23.5166 11.2424 26.4939 11.0567 30.0556C10.6668 37.5282 10.7988 38.296 10.0591 40.941C9.67112 42.3297 8.76015 43.2759 8.22556 45.3137C7.28493 48.9026 6.57897 53.6975 4.75755 56.5701C4.26837 57.2206 3.34748 58.1829 3.03405 58.5911C2.77152 58.9339 2.61503 59.4534 2.32319 60.0342C2.09256 60.4953 1.79667 60.8231 1.34032 61.3511C1.11195 61.616 0.778728 61.8258 0.392484 62.0367C-0.298589 62.4145 0.0273582 63.0758 0.568296 62.9797C0.86776 62.9268 1.36727 62.8525 1.78859 62.6211C2.17438 62.4088 2.5728 61.9404 2.76788 61.7731C2.91132 61.6503 2.90278 61.7937 2.91496 61.7952C2.69593 61.9996 2.60107 62.3306 2.42168 62.7383C2.2562 63.115 2.03226 63.6282 1.89107 63.8119C1.28816 64.6018 1.03907 64.7766 0.285912 65.6399C-0.123701 66.1099 0.0309933 66.407 0.480131 66.5848C0.615091 66.6378 0.837179 66.7895 0.975659 66.8958C1.0966 66.9886 1.26704 67.0604 1.46755 67.054C1.7594 67.0451 1.97295 66.9852 2.26162 66.9133C2.40685 66.877 2.63932 66.8519 2.77152 66.8009C2.9801 66.7207 3.16809 66.6224 3.32094 66.507C3.81375 66.1333 4.73193 65.2821 5.13612 64.652C5.54077 64.0218 6.15545 63.1166 6.33167 62.6607C7.14507 60.5714 7.40495 60.0596 7.90855 58.3794C8.23767 57.2829 8.76511 56.2366 9.248 55.2618C9.29387 55.1692 14.2057 45.8037 14.6533 43.8217C14.8694 42.8653 16.0592 39.404 16.3433 33.1081C16.5129 35.0172 16.6591 36.5178 16.7823 37.8323C17.3843 44.2575 16.4257 47.0333 15.8574 48.5568C14.6049 51.9147 13.1623 55.3093 12.928 60.8229C12.7774 64.3669 13.1826 68.6525 14.801 78.849C15.594 83.845 14.3802 85.9951 14.1846 89.6094C14.041 92.2635 14.2651 95.6102 15.4096 102.861C16.6712 110.853 16.7741 111.56 16.4534 113.767C16.4236 113.972 16.3082 114.488 16.1976 115.121C16.1386 115.459 15.9561 116.108 15.6449 116.474C15.3536 116.816 14.8926 117.308 14.5734 117.453C14.143 117.648 13.9506 118.25 14.0769 118.53C14.2397 118.89 14.496 118.96 14.9964 118.96H19.8868C21.0666 118.96 21.1903 118.372 21.143 117.536C21.1107 116.96 20.8746 116.383 20.7434 115.907C20.577 115.304 20.59 115.018 20.4677 114.374C20.3346 113.675 20.1512 113.409 20.0801 112.406C19.9574 110.673 20.1174 106.309 20.666 102.378C21.2645 98.0935 22.1484 93.6315 22.3845 91.602C22.9047 87.1283 22.2134 83.2894 22.5347 79.8076C23.0403 74.3276 24.1771 71.0053 25.282 63.052C25.2953 62.9559 25.3302 63.0222 25.5 63.0222C25.6698 63.0222 25.7047 62.9559 25.7181 63.052C26.8229 71.0053 27.9598 74.3276 28.4654 79.8076C28.7866 83.2894 28.0953 87.1283 28.6155 91.602C28.8515 93.6315 29.7356 98.0935 30.334 102.378C30.8825 106.309 31.0426 110.673 30.9199 112.406C30.8488 113.409 30.6654 113.675 30.5323 114.374C30.41 115.018 30.423 115.304 30.2567 115.907C30.1254 116.383 29.8893 116.96 29.857 117.536C29.8097 118.372 29.9334 118.96 31.1132 118.96H36.0036C36.504 118.96 36.7603 118.89 36.9231 118.53C37.0494 118.25 36.857 117.648 36.4266 117.453C36.1074 117.308 35.6464 116.816 35.3551 116.474C35.0439 116.108 34.8614 115.459 34.8024 115.121C34.6919 114.488 34.5764 113.972 34.5467 113.767C34.2259 111.56 34.3288 110.853 35.5904 102.861C36.7349 95.6102 36.959 92.2635 36.8155 89.6094C36.6199 85.9951 35.4061 83.845 36.1991 78.849C37.8174 68.6525 38.2226 64.3669 38.072 60.8229C37.8377 55.3093 36.3951 51.9147 35.1426 48.5568C34.5743 47.0333 33.6158 44.2575 34.2178 37.8323C34.3409 36.5178 34.4871 35.0172 34.6567 33.1081C34.9408 39.404 36.1307 42.8653 36.3467 43.8217C36.7943 45.8037 41.7062 55.1692 41.752 55.2618C42.235 56.2366 42.7623 57.2829 43.0915 58.3794C43.595 60.0596 43.8549 60.5714 44.6683 62.6607C44.8446 63.1166 45.4592 64.0218 45.8639 64.652C46.2681 65.2821 47.1863 66.1333 47.6791 66.507C47.832 66.6224 48.0199 66.7207 48.2285 66.8009C48.3607 66.8519 48.5932 66.877 48.7384 66.9133C49.0271 66.9852 49.2406 67.0451 49.5325 67.054C49.733 67.0604 49.9034 66.9886 50.0243 66.8958C50.1628 66.7895 50.3849 66.6378 50.5199 66.5848C50.9691 66.407 51.1237 66.1099 50.7141 65.6399C49.9609 64.7766 49.7119 64.6018 49.1089 63.8119C48.9677 63.6282 48.7438 63.115 48.5783 62.7383C48.3989 62.3306 48.304 61.9996 48.0851 61.7952C48.0972 61.7937 48.0887 61.6503 48.2321 61.7731C48.4273 61.9404 48.8256 62.4088 49.2114 62.6211C49.6327 62.8525 50.1322 62.9268 50.4317 62.9797C50.7529 63.0367 50.9983 62.8268 51 62.5676V62.5624C50.9989 62.3864 50.8855 62.1887 50.6075 62.0367C50.2213 61.8258 49.8881 61.616 49.6597 61.3511C49.2033 60.8231 48.9075 60.4953 48.6768 60.0342C48.385 59.4534 48.2285 58.9339 47.966 58.5911C47.6525 58.1829 46.7316 57.2206 46.2425 56.5701C44.421 53.6975 43.7151 48.9026 42.7745 45.3137C42.2399 43.2759 41.3289 42.3297 40.9409 40.941C40.2012 38.296 40.3332 37.5282 39.9433 30.0556C39.7576 26.4939 39.5187 23.5166 38.831 22.2945C38.0389 20.8867 36.485 20.7897 34.2422 20.4105C32.3223 20.0858 30.6546 19.4892 29.7877 18.7486C29.6474 18.629 29.5193 18.4929 29.4019 18.3445C28.7257 17.4639 28.4656 16.4754 28.5831 15.2506C28.1317 15.5804 27.4355 15.9882 26.9159 16.2188C26.7459 16.2941 26.8641 15.9971 27.115 15.8158C27.7818 15.3344 28.5555 14.7164 29.2187 13.9294C29.2994 13.8336 29.3784 13.7366 29.4548 13.6361C31.0538 14.2025 31.3786 14.983 33.0323 15.4564C33.8003 15.6763 34.5047 15.5968 35.1579 15.5172C35.5568 15.4687 35.9365 15.4201 36.3001 15.4396C37.4783 15.5032 38.6975 15.4823 39.8611 14.419C40.3495 13.9728 40.6494 13.7657 41.2592 13.2595C41.9914 12.6516 42.9708 12.306 43.2412 12.1882C43.439 12.1022 43.1472 12.0209 42.5429 12.1038C41.1509 12.2948 39.2595 12.8907 37.4306 12.0789C36.518 11.6738 35.3962 10.8976 34.5387 10.4612C35.8197 10.8665 37.4164 11.6598 39.1753 11.8809C39.8945 11.9712 41.4018 12.067 42.7274 11.3798C43.9444 10.749 44.8057 9.70119 45.0369 8.39002C44.6813 8.76396 44.1498 8.87202 43.8108 8.80345C44.6615 8.43205 45.1084 7.95132 45.1916 7.20869C45.2752 6.46069 44.7535 5.85722 44.512 5.65463C44.266 6.30939 43.1348 7.86888 41.3684 7.91258C40.4709 7.93484 39.4955 7.74608 38.5008 7.06045C37.1379 6.12091 36.7494 5.64943 35.6949 4.99011C34.362 4.15666 33.7718 3.90748 31.9106 2.73118C30.0899 1.58055 28.9591 0.0397949 25.5795 0.0397949Z" fill="#ff964f"></path></svg>
                  </div>
                </div>
                <button className="sc-gsnTZi gAiOLN" data-locator="femalePulseGenderBtn" onClick={() => handleNext('Female')}><p type="medium-button" color="on-primary" className="sc-jSMfEi dmpIyk">Female</p></button>
              </div>
            </div>
          </div>
          <div className="Gender-module-indexFooterContainer--4UjbA">
            <p className="Text-module-default--9nb4F Text-module-caption--MeFDb Text-module-grey--mn9R0 Text-module-transparence---YABR Common-module-centered--f1oqe ">By pressing the “Male” or “Female” button, you confirm and guarantee that you have read, understood, and agreed to our <a href="https://leanformula.co/terms-and-conditions/" className="Common-module-colorBrand--3FTX+" target="_blank" rel="noopener noreferrer" data-locator="termsOfUseLink">Terms of Use</a> and<a href="https://leanformula.co/privacy-policy/" className="Common-module-colorBrand--3FTX+" target="_blank" rel="noopener noreferrer" data-locator="privacyPolicyLink"> Privacy Policy</a>.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

// Success Stories 
function SuccessStories() {
  const navigate = useNavigate();
  const location = useLocation(); // Get current location to access search query

  // Counter state and logic
  const [count, setCount] = useState(5438);

  useEffect(() => {
    const timerId = setInterval(() => {
      setCount(prevCount => {
        // Randomly increase the count by 1 or 2 to make it look organic
        const increment = Math.floor(Math.random() * 1) + 1;
        return prevCount + increment;
      });
    }, 1000);

    return () => clearInterval(timerId); // Clear the interval if the component is unmounted
  }, []);

  // Format the count with a comma
  const formattedCount = count.toLocaleString();

  const handleNext = () => {
    navigate(`/step/3${location.search}`); // Append query string while navigating
  };

  return (
    <div>
      <div className="step">
        <div className="step__container">
          <h2>No one does weight loss <br /><span>better than us</span></h2>
          <h5 style={{ textAlign: 'center' }}>LeanFormula is the <b>#1 rated</b> weight loss system with over <br />{formattedCount} weight loss success stories!</h5>
          <div data-v-718e372c="" class="banner mb32"><h4 data-v-718e372c="">REAL WEIGHT LOSS STORIES*</h4> <div data-v-718e372c="" class="stories">
            <img data-v-718e372c="" src="https://leanformula.co/wp-content/uploads/2024/09/stories.128f960.png" alt="" />
            <img data-v-718e372c="" src="https://leanformula.co/wp-content/uploads/2024/09/stories.128f960.png" alt="" />
            <img data-v-718e372c="" src="https://leanformula.co/wp-content/uploads/2024/09/stories.128f960.png" alt="" /></div>
            <svg data-v-718e372c="" width="153" height="48" viewBox="0 0 153 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path data-v-718e372c="" d="M3.82955 33.0341V30.1364L16.6136 9.90909H18.7159V14.3977H17.2955L7.63636 29.6818V29.9091H24.8523V33.0341H3.82955ZM17.5227 39V32.1534V30.804V9.90909H20.875V39H17.5227ZM29.3082 39.2273C28.6075 39.2273 28.0062 38.9763 27.5043 38.4744C27.0024 37.9725 26.7514 37.3712 26.7514 36.6705C26.7514 35.9697 27.0024 35.3684 27.5043 34.8665C28.0062 34.3646 28.6075 34.1136 29.3082 34.1136C30.009 34.1136 30.6103 34.3646 31.1122 34.8665C31.6141 35.3684 31.8651 35.9697 31.8651 36.6705C31.8651 37.1345 31.7467 37.5606 31.5099 37.9489C31.2827 38.3371 30.9749 38.6496 30.5866 38.8864C30.2079 39.1136 29.7817 39.2273 29.3082 39.2273ZM44.2436 39.3977C42.2929 39.3977 40.5694 39.0521 39.0732 38.3608C37.5864 37.66 36.4264 36.6989 35.593 35.4773C34.7597 34.2462 34.3478 32.8447 34.3572 31.2727C34.3478 30.0417 34.5893 28.9053 35.0817 27.8636C35.5741 26.8125 36.2464 25.9366 37.0987 25.2358C37.9605 24.5256 38.9216 24.0758 39.9822 23.8864V23.7159C38.5902 23.3561 37.4822 22.5748 36.6584 21.3722C35.8345 20.16 35.4273 18.7822 35.4368 17.2386C35.4273 15.7614 35.8014 14.4403 36.5589 13.2756C37.3165 12.1108 38.3582 11.1922 39.6839 10.5199C41.0192 9.84754 42.5391 9.51136 44.2436 9.51136C45.9292 9.51136 47.4349 9.84754 48.7607 10.5199C50.0864 11.1922 51.1281 12.1108 51.8857 13.2756C52.6527 14.4403 53.041 15.7614 53.0504 17.2386C53.041 18.7822 52.6196 20.16 51.7862 21.3722C50.9624 22.5748 49.8686 23.3561 48.505 23.7159V23.8864C49.5561 24.0758 50.5031 24.5256 51.3459 25.2358C52.1887 25.9366 52.861 26.8125 53.3629 27.8636C53.8648 28.9053 54.1205 30.0417 54.13 31.2727C54.1205 32.8447 53.6944 34.2462 52.8516 35.4773C52.0182 36.6989 50.8582 37.66 49.3714 38.3608C47.8942 39.0521 46.1849 39.3977 44.2436 39.3977ZM44.2436 36.2727C45.5599 36.2727 46.6963 36.0597 47.6527 35.6335C48.6091 35.2074 49.3478 34.6061 49.8686 33.8295C50.3894 33.053 50.6546 32.1439 50.6641 31.1023C50.6546 30.0038 50.3705 29.0331 49.8118 28.1903C49.2531 27.3475 48.4908 26.6847 47.5249 26.2017C46.5684 25.7187 45.4747 25.4773 44.2436 25.4773C43.0031 25.4773 41.8951 25.7187 40.9197 26.2017C39.9538 26.6847 39.1915 27.3475 38.6328 28.1903C38.0836 29.0331 37.8137 30.0038 37.8232 31.1023C37.8137 32.1439 38.0646 33.053 38.576 33.8295C39.0968 34.6061 39.8402 35.2074 40.8061 35.6335C41.772 36.0597 42.9179 36.2727 44.2436 36.2727ZM44.2436 22.4659C45.2853 22.4659 46.2086 22.2576 47.0135 21.8409C47.8279 21.4242 48.4671 20.8419 48.9311 20.0938C49.3951 19.3456 49.6319 18.4697 49.6413 17.4659C49.6319 16.4811 49.3999 15.6241 48.9453 14.8949C48.4908 14.1562 47.861 13.5881 47.0561 13.1903C46.2512 12.7831 45.3137 12.5795 44.2436 12.5795C43.1546 12.5795 42.2029 12.7831 41.3885 13.1903C40.5741 13.5881 39.9444 14.1562 39.4993 14.8949C39.0542 15.6241 38.8364 16.4811 38.8459 17.4659C38.8364 18.4697 39.0589 19.3456 39.5135 20.0938C39.9775 20.8419 40.6167 21.4242 41.4311 21.8409C42.2455 22.2576 43.183 22.4659 44.2436 22.4659Z" fill="black"></path> <path data-v-718e372c="" d="M72.1406 11.2422L73.918 14.8789L77.8281 15.4531C78.1562 15.5078 78.4297 15.7266 78.5391 16.0547C78.6484 16.3555 78.5664 16.7109 78.3203 16.9297L75.4766 19.7461L76.1602 23.7383C76.2148 24.0664 76.0781 24.3945 75.8047 24.5859C75.5312 24.8047 75.1758 24.8047 74.875 24.668L71.375 22.7812L67.8477 24.668C67.5742 24.8047 67.2188 24.8047 66.9453 24.5859C66.6719 24.3945 66.5352 24.0664 66.5898 23.7383L67.2461 19.7461L64.4023 16.9297C64.1836 16.7109 64.1016 16.3555 64.1836 16.0547C64.293 15.7266 64.5664 15.5078 64.8945 15.4531L68.832 14.8789L70.582 11.2422C70.7188 10.9414 71.0195 10.75 71.375 10.75C71.7031 10.75 72.0039 10.9414 72.1406 11.2422ZM87.8906 11.2422L89.668 14.8789L93.5781 15.4531C93.9062 15.5078 94.1797 15.7266 94.2891 16.0547C94.3984 16.3555 94.3164 16.7109 94.0703 16.9297L91.2266 19.7461L91.9102 23.7383C91.9648 24.0664 91.8281 24.3945 91.5547 24.5859C91.2812 24.8047 90.9258 24.8047 90.625 24.668L87.125 22.7812L83.5977 24.668C83.3242 24.8047 82.9688 24.8047 82.6953 24.5859C82.4219 24.3945 82.2852 24.0664 82.3398 23.7383L82.9961 19.7461L80.1523 16.9297C79.9336 16.7109 79.8516 16.3555 79.9336 16.0547C80.043 15.7266 80.3164 15.5078 80.6445 15.4531L84.582 14.8789L86.332 11.2422C86.4688 10.9414 86.7695 10.75 87.125 10.75C87.4531 10.75 87.7539 10.9414 87.8906 11.2422ZM103.641 11.2422L105.418 14.8789L109.328 15.4531C109.656 15.5078 109.93 15.7266 110.039 16.0547C110.148 16.3555 110.066 16.7109 109.82 16.9297L106.977 19.7461L107.66 23.7383C107.715 24.0664 107.578 24.3945 107.305 24.5859C107.031 24.8047 106.676 24.8047 106.375 24.668L102.875 22.7812L99.3477 24.668C99.0742 24.8047 98.7188 24.8047 98.4453 24.5859C98.1719 24.3945 98.0352 24.0664 98.0898 23.7383L98.7461 19.7461L95.9023 16.9297C95.6836 16.7109 95.6016 16.3555 95.6836 16.0547C95.793 15.7266 96.0664 15.5078 96.3945 15.4531L100.332 14.8789L102.082 11.2422C102.219 10.9414 102.52 10.75 102.875 10.75C103.203 10.75 103.504 10.9414 103.641 11.2422ZM119.391 11.2422L121.168 14.8789L125.078 15.4531C125.406 15.5078 125.68 15.7266 125.789 16.0547C125.898 16.3555 125.816 16.7109 125.57 16.9297L122.727 19.7461L123.41 23.7383C123.465 24.0664 123.328 24.3945 123.055 24.5859C122.781 24.8047 122.426 24.8047 122.125 24.668L118.625 22.7812L115.098 24.668C114.824 24.8047 114.469 24.8047 114.195 24.5859C113.922 24.3945 113.785 24.0664 113.84 23.7383L114.496 19.7461L111.652 16.9297C111.434 16.7109 111.352 16.3555 111.434 16.0547C111.543 15.7266 111.816 15.5078 112.145 15.4531L116.082 14.8789L117.832 11.2422C117.969 10.9414 118.27 10.75 118.625 10.75C118.953 10.75 119.254 10.9414 119.391 11.2422ZM135.141 11.2422L136.918 14.8789L140.828 15.4531C141.156 15.5078 141.43 15.7266 141.539 16.0547C141.648 16.3555 141.566 16.7109 141.32 16.9297L138.477 19.7461L139.16 23.7383C139.215 24.0664 139.078 24.3945 138.805 24.5859C138.531 24.8047 138.176 24.8047 137.875 24.668L134.375 22.7812L130.848 24.668C130.574 24.8047 130.219 24.8047 129.945 24.5859C129.672 24.3945 129.535 24.0664 129.59 23.7383L130.246 19.7461L127.402 16.9297C127.184 16.7109 127.102 16.3555 127.184 16.0547C127.293 15.7266 127.566 15.5078 127.895 15.4531L131.832 14.8789L133.582 11.2422C133.719 10.9414 134.02 10.75 134.375 10.75C134.703 10.75 135.004 10.9414 135.141 11.2422Z" fill="black"></path> <path data-v-718e372c="" d="M68.1307 42.1193C67.6307 42.1193 67.1804 42.0199 66.7798 41.821C66.3793 41.6222 66.0582 41.3494 65.8168 41.0028C65.5753 40.6562 65.4432 40.2614 65.4205 39.8182H66.4432C66.483 40.2131 66.6619 40.5398 66.9801 40.7983C67.3011 41.054 67.6847 41.1818 68.1307 41.1818C68.4886 41.1818 68.8068 41.098 69.0852 40.9304C69.3665 40.7628 69.5866 40.5327 69.7457 40.2401C69.9077 39.9446 69.9886 39.6108 69.9886 39.2386C69.9886 38.858 69.9048 38.5185 69.7372 38.2202C69.5724 37.919 69.3452 37.6818 69.0554 37.5085C68.7656 37.3352 68.4347 37.2472 68.0625 37.2443C67.7955 37.2415 67.5213 37.2827 67.2401 37.3679C66.9588 37.4503 66.7273 37.5568 66.5455 37.6875L65.5568 37.5682L66.0852 33.2727H70.6193V34.2102H66.9716L66.6648 36.7841H66.7159C66.8949 36.642 67.1193 36.5241 67.3892 36.4304C67.6591 36.3366 67.9403 36.2898 68.233 36.2898C68.767 36.2898 69.2429 36.4176 69.6605 36.6733C70.081 36.9261 70.4105 37.2727 70.6491 37.7131C70.8906 38.1534 71.0114 38.6562 71.0114 39.2216C71.0114 39.7784 70.8864 40.2756 70.6364 40.7131C70.3892 41.1477 70.0483 41.4915 69.6136 41.7443C69.179 41.9943 68.6847 42.1193 68.1307 42.1193ZM73.1261 42.0682C72.9158 42.0682 72.7354 41.9929 72.5849 41.8423C72.4343 41.6918 72.359 41.5114 72.359 41.3011C72.359 41.0909 72.4343 40.9105 72.5849 40.7599C72.7354 40.6094 72.9158 40.5341 73.1261 40.5341C73.3363 40.5341 73.5167 40.6094 73.6673 40.7599C73.8178 40.9105 73.8931 41.0909 73.8931 41.3011C73.8931 41.4403 73.8576 41.5682 73.7866 41.6847C73.7184 41.8011 73.6261 41.8949 73.5096 41.9659C73.396 42.0341 73.2681 42.0682 73.1261 42.0682ZM75.4762 40.2102V39.3409L79.3114 33.2727H79.9421V34.6193H79.516L76.6183 39.2045V39.2727H81.783V40.2102H75.4762ZM79.5842 42V39.946V39.5412V33.2727H80.5898V42H79.5842ZM83.5334 42V33.2727H84.5902V37.6023H84.6925L88.6129 33.2727H89.9936L86.3288 37.2102L89.9936 42H88.7152L85.6811 37.9432L84.5902 39.1705V42H83.5334ZM94.7365 42V33.2727H97.6854C98.3672 33.2727 98.9268 33.3892 99.3643 33.6222C99.8018 33.8523 100.126 34.169 100.336 34.5724C100.546 34.9759 100.651 35.4347 100.651 35.9489C100.651 36.4631 100.546 36.919 100.336 37.3168C100.126 37.7145 99.8033 38.027 99.3686 38.2543C98.9339 38.4787 98.3786 38.5909 97.7024 38.5909H95.3161V37.6364H97.6683C98.1342 37.6364 98.5092 37.5682 98.7933 37.4318C99.0803 37.2955 99.2876 37.1023 99.4155 36.8523C99.5462 36.5994 99.6115 36.2983 99.6115 35.9489C99.6115 35.5994 99.5462 35.294 99.4155 35.0327C99.2848 34.7713 99.076 34.5696 98.7891 34.4276C98.5021 34.2827 98.1229 34.2102 97.6513 34.2102H95.7933V42H94.7365ZM98.8445 38.0795L100.992 42H99.7649L97.6513 38.0795H98.8445ZM102.412 42V33.2727H107.679V34.2102H103.469V37.1591H107.407V38.0966H103.469V41.0625H107.748V42H102.412ZM109.942 33.2727L112.533 40.6193H112.635L115.226 33.2727H116.334L113.13 42H112.039L108.834 33.2727H109.942ZM118.75 33.2727V42H117.694V33.2727H118.75ZM120.869 42V33.2727H126.136V34.2102H121.926V37.1591H125.864V38.0966H121.926V41.0625H126.205V42H120.869ZM129.626 42L127.24 33.2727H128.314L130.138 40.3807H130.223L132.081 33.2727H133.274L135.132 40.3807H135.217L137.041 33.2727H138.115L135.729 42H134.638L132.712 35.0455H132.643L130.717 42H129.626ZM144.205 35.4545C144.153 35.0227 143.946 34.6875 143.582 34.4489C143.219 34.2102 142.773 34.0909 142.244 34.0909C141.858 34.0909 141.52 34.1534 141.23 34.2784C140.943 34.4034 140.719 34.5753 140.557 34.794C140.398 35.0128 140.318 35.2614 140.318 35.5398C140.318 35.7727 140.374 35.973 140.484 36.1406C140.598 36.3054 140.743 36.4432 140.919 36.554C141.095 36.6619 141.28 36.7514 141.473 36.8224C141.666 36.8906 141.844 36.946 142.006 36.9886L142.892 37.2273C143.119 37.2869 143.372 37.3693 143.651 37.4744C143.932 37.5795 144.2 37.723 144.456 37.9048C144.714 38.0838 144.928 38.3139 145.095 38.5952C145.263 38.8764 145.347 39.2216 145.347 39.6307C145.347 40.1023 
            145.223 40.5284 144.976 40.9091C144.732 41.2898 144.374 41.5923 143.902 41.8168C143.433 42.0412 142.864 42.1534 142.193 42.1534C141.568 42.1534 141.027 42.0526 140.57 41.8509C140.115 41.6491 139.757 41.3679 139.496 41.0071C139.237 40.6463 139.091 40.2273 139.057 39.75H140.148C140.176 40.0795 140.287 40.3523 140.48 40.5682C140.676 40.7812 140.923 40.9403 141.222 41.0455C141.523 41.1477 141.847 41.1989 142.193 41.1989C142.597 41.1989 142.959 41.1335 143.28 41.0028C143.601 40.8693 143.855 40.6847 144.043 40.4489C144.23 40.2102 144.324 39.9318 144.324 39.6136C144.324 39.3239 144.243 39.0881 144.081 38.9062C143.919 38.7244 143.706 38.5767 143.442 38.4631C143.178 38.3494 142.892 38.25 142.585 38.1648L141.511 37.858C140.83 37.6619 140.29 37.3821 139.892 37.0185C139.494 36.6548 139.295 36.179 139.295 35.5909C139.295 35.1023 139.428 34.6761 139.692 34.3125C139.959 33.946 140.317 33.6619 140.766 33.4602C141.217 33.2557 141.722 33.1534 142.278 33.1534C142.841 33.1534 143.341 33.2543 143.778 33.456C144.216 33.6548 144.563 33.9276 144.818 34.2741C145.077 34.6207 145.213 35.0142 145.227 35.4545H144.205Z" fill="black"></path>
            </svg>
          </div>
          <div className="fixedButton">
        <div className="fixedButton__container">
          <button id="continueButton" className="fixedButton__button" onClick={handleNext}>Continue</button>
        </div>
      </div>
        </div>
      </div>
    </div>
  );
}

// OLD Success Stories 
function OldSuccessStories() {
  const navigate = useNavigate();
  const location = useLocation(); // Get current location to access search query

  // Counter state and logic
  const [count, setCount] = useState(5838);

  useEffect(() => {
    const timerId = setInterval(() => {
      setCount(prevCount => {
        // Randomly increase the count by 1 or 2 to make it look organic
        const increment = Math.floor(Math.random() * 2) + 1;
        return prevCount + increment;
      });
    }, 1000);

    return () => clearInterval(timerId); // Clear the interval if the component is unmounted
  }, []);

  // Format the count with a comma
  const formattedCount = count.toLocaleString();

  const handleNext = () => {
    navigate(`/step/3${location.search}`); // Append query string while navigating
  };

  return (
    <div>
      <div className="socialProofModule">
        <div className="socialProofModule__title">
          <h1>{`${formattedCount} Weight Loss Success Stories`}</h1>
          <p>Ready to find your perfect weight loss solution?</p>
        </div>
        <div className='socialProofModule__imgWrapper'>
          <img className='socialProofModule__img' src={`${process.env.PUBLIC_URL}../assets/images/ready-graphic.png`} alt='Social proof' />
        </div>
        <div className='socialProofModule__stickyFooter'>
          <button onClick={handleNext} className='socialProofModule__nextBtn'>Next</button>
        </div>
      </div>
    </div>
  );
}

// Current Body Component
function CurrentBody() {
  const navigate = useNavigate();
  const location = useLocation();
  const { quizData, updateQuizData } = useQuiz();

  const handleOptionChange = (value) => {
    updateQuizData({ currentBodyType: value });
    navigate(`/step/4${location.search}`);
  };

  return (
    <div>
      <div className="sc-bczRLJ dyisTO OptionContainer-module-container--Zu4Rp">
        <p type="h5" color="text-main" className="sc-jSMfEi fLSGMF">Choose your current body type</p>
        <div className="sc-dmRaPn iSEuTj">
          <div className="sc-kgflAQ bOaSgr" onClick={() => handleOptionChange('regular')}>
            <input type="checkbox" data-locator="option" className="sc-iIPllB cgDdUM" value="regular" />
            <div className="sc-fLlhyt cLGowB">
              <div className="sc-bBrHrO UjSGr">
                <p type="large-text" color="text-main" className="sc-jSMfEi bskqQx">Regular</p>
              </div>
              <div className="sc-cxabCf cnGAAS">
                <img className="sc-kDDrLX ipwqQP" src={`${process.env.PUBLIC_URL}../assets/images/regular-bodies.png`} />
              </div>
            </div>
          </div>
          <div className="sc-kgflAQ bOaSgr" onClick={() => handleOptionChange('flabby')}>
            <input type="checkbox" data-locator="option" className="sc-iIPllB cgDdUM" value="flabby" />
            <div className="sc-fLlhyt cLGowB">
              <div className="sc-bBrHrO UjSGr">
                <p type="large-text" color="text-main" className="sc-jSMfEi bskqQx">Flabby</p>
              </div>
              <div className="sc-cxabCf cnGAAS">
                <img src={`${process.env.PUBLIC_URL}../assets/images/flabby-bodies.png`} alt="im" className="sc-kDDrLX ipwqQP" />
              </div>
            </div>
          </div>
          <div className="sc-kgflAQ bOaSgr" onClick={() => handleOptionChange('extra')}>
            <input type="checkbox" data-locator="option" className="sc-iIPllB cgDdUM" value="extra" />
            <div className="sc-fLlhyt cLGowB">
              <div className="sc-bBrHrO UjSGr">
                <p type="large-text" color="text-main" className="sc-jSMfEi bskqQx">Extra</p>
              </div>
              <div className="sc-cxabCf cnGAAS">
                <img src={`${process.env.PUBLIC_URL}../assets/images/extra-bodies.png`} alt="im" className="sc-kDDrLX ipwqQP" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Goal Body Component
function GoalBody() {
  const navigate = useNavigate();
  const location = useLocation();
  const { quizData, updateQuizData } = useQuiz();

  const handleOptionChange = (value) => {
    updateQuizData({ targetBodyType: value });
    navigate(`/step/5${location.search}`);
  };

  return (
    <div>
      <div className="sc-bczRLJ dyisTO OptionContainer-module-container--Zu4Rp">
        <p type="h5" color="text-main" className="sc-jSMfEi fLSGMF">Choose the body type you want to have</p>
        <div className="sc-dmRaPn iSEuTj">
          <div className="sc-kgflAQ bOaSgr" onClick={() => handleOptionChange('regular')}>
            <input type="checkbox" data-locator="option" className="sc-iIPllB cgDdUM" value="regular" />
            <div className="sc-fLlhyt cLGowB">
              <div className="sc-bBrHrO UjSGr">
                <p type="large-text" color="text-main" className="sc-jSMfEi bskqQx">Regular</p>
              </div>
              <div className="sc-cxabCf cnGAAS">
                <img src={`${process.env.PUBLIC_URL}/assets/images/regular-bodies.png`} alt="Regular body type" className="sc-kDDrLX ipwqQP" />
              </div>
            </div>
          </div>
          <div className="sc-kgflAQ bOaSgr" onClick={() => handleOptionChange('cut')}>
            <input type="checkbox" data-locator="option" className="sc-iIPllB cgDdUM" value="cut" />
            <div className="sc-fLlhyt cLGowB">
              <div className="sc-bBrHrO UjSGr">
                <p type="large-text" color="text-main" className="sc-jSMfEi bskqQx">Cut</p>
              </div>
              <div className="sc-cxabCf cnGAAS">
                <img src={`${process.env.PUBLIC_URL}/assets/images/cut-bodies.png`} alt="Cut body type" className="sc-kDDrLX ipwqQP" />
              </div>
            </div>
          </div>
          <div className="sc-kgflAQ bOaSgr" onClick={() => handleOptionChange('defined')}>
            <input type="checkbox" data-locator="option" className="sc-iIPllB cgDdUM" value="defined" />
            <div className="sc-fLlhyt cLGowB">
              <div className="sc-bBrHrO UjSGr">
                <p type="large-text" color="text-main" className="sc-jSMfEi bskqQx">Defined</p>
              </div>
              <div className="sc-cxabCf cnGAAS">
                <img src={`${process.env.PUBLIC_URL}/assets/images/defined-bodies.png`} alt="Defined body type" className="sc-kDDrLX ipwqQP" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function References() {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate(`/step/6`);
  };

  return (
    <div>
      <div className="step">
        <div className="step__container">
          <h2>The only weight loss system to use biofeedback</h2>
          <div style={{textAlign: 'center'}}>
           <img src="https://leanformula.co/wp-content/uploads/2024/07/leanformula-main-product-square-800x800-1.png" style={{ width: "60%", marginBottom: 20 }} />
           </div>
          <h5>With data easily accessible via an app or dashboard, you can track their progress, receive personalized feedback, and stay motivated to reach your goals.</h5>
          <div className="fixedButton">
        <div className="fixedButton__container">
          <button id="continueButton" className="fixedButton__button" onClick={handleNext}>Continue</button>
        </div>
      </div>
        </div>
      </div>
    </div>
  );
}

// Old References page with studies
function OldReferences() {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate(`/step/6`);
  };

  return (
    <div>
      <div className="step">
        <div className="step__container">
          <img src="https://leanformula.co/wp-content/uploads/2024/09/study-logo-img-1.png" style={{ width: "100%", marginBottom: 20 }} />
          <h5>The strategies we use to improve your metabolism are <b>so effective</b> they are recommended by <b>Harvard, Mayo Clini, WebMD and the National Institutes of Health</b>.</h5>
          <button class="continueButton" onClick={handleNext}>Continue</button>
        </div>
      </div>
    </div>
  );
}

function Chart() {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate(`/step/9`);
  };

  return (
    <div>
      <div className="step">
        <div className="step__container">
          <h3>LeanFormula is popular because it works!</h3>
          <img src="https://futurhealth.com/new/_nuxt/img/graph.e2e97d4.png" style={{ width: "100%" }} />
          <div className="comparisonChart__key">
            <div className="key__container">
              <div class="key__row">
                <span style={{ width: 12, height: 12, borderRadius: '100%', marginRight: 12, background: 'rgb(68, 65, 217)', display: 'block' }}></span>
                With LeanFormula
              </div>
              <div class="key__row">
                <span style={{ width: 12, height: 12, borderRadius: '100%', marginRight: 12, background: 'rgb(255, 193, 173)', display: 'block' }}></span>
                Weight loss on your own
              </div>
            </div>
          </div>
          <h4>According to our members, LeanFormula users <b>lost an average of 15% of their body weight</b> - <i>with 1 in 3 users </i><b>losing over 20%+</b></h4>
          <div className="fixedButton">
        <div className="fixedButton__container">
          <button id="continueButton" className="fixedButton__button" onClick={handleNext}>Continue</button>
        </div>
      </div>
        </div>
      </div>
    </div>
  );
}

// Height Component
function Height() {
  const navigate = useNavigate();
  const location = useLocation();
  const { quizData, updateQuizData } = useQuiz();
  const [feet, setFeet] = useState('');
  const [inches, setInches] = useState('');
  const [centimeters, setCm] = useState('');
  const [unit, setUnit] = useState('in'); // Default unit set to inches

  const inchesInputRef = useRef(null);

  const handleNext = () => {
    const heightInCm = unit === 'in' ? (parseInt(feet, 10) * 30.48 + parseInt(inches, 10) * 2.54) : parseInt(centimeters, 10);
    updateQuizData({ heightInCm });
    navigate(`/step/10${location.search}`);
  };

  const handleUnitChange = (event) => {
    setUnit(event.target.value);
  };

  const handleFeetChange = (event) => {
    setFeet(event.target.value);
    // Automatically switch focus to inches input field
    inchesInputRef.current.focus();
  };

  const validateInches = () => {
    const feetNum = parseInt(feet, 10) || 0;
    const inchesNum = parseInt(inches, 10) || 0;
    return feetNum >= 4 && feetNum <= 7 && inchesNum >= 0 && inchesNum <= 11 && feet !== '' && inches !== '';
  };

  const validateCentimeters = () => {
    const cmNum = parseInt(centimeters, 10) || 0;
    return cmNum >= 40 && cmNum <= 250;
  };

  // Instead of manipulating DOM, let's derive the state in a more React way
  const isButtonEnabled = unit === 'in' ? validateInches() : validateCentimeters();

  return (
    <div>
      <div className="sc-bczRLJ dyisTO OptionContainer-module-container--Zu4Rp">
        <p type="h5" color="text-main" className="sc-jSMfEi fLSGMF">How tall are you?</p>
        <div className="sc-ikZpkk fbYsNG">
          <label htmlFor="checkbox_in" data-locator="inButton" className="sc-jIZahH ctOqxH">
            <input
              id="checkbox_in"
              type="radio"
              name="control"
              data-locator="controlImperial"
              className="sc-gXmSlM loxZGu"
              value="in"
              checked={unit === 'in'}
              onChange={handleUnitChange}
            />
            <p className="sc-himrzO eZLRYw">in</p>
          </label>
          <label htmlFor="checkbox_cm" data-locator="cmButton" className="sc-jIZahH ctOqxH">
            <input
              id="checkbox_cm"
              type="radio"
              name="control"
              data-locator="controlMetric"
              className="sc-gXmSlM loxZGu"
              value="cm"
              checked={unit === 'cm'}
              onChange={handleUnitChange}
            />
            <p className="sc-himrzO eZLRYw">cm</p>
          </label>
        </div>
        <div className={`TallContainer-module-inputWrapper--nmVX6 TallContainer-module-inputMultiWrapper--RsUp0 ${unit === 'cm' ? 'hidden' : ''}`}>
          <div className="sc-idiyUo dKwJgB">
            <div className="sc-fEOsli bpSLXp">
              <label>
                <input
                  type="number"
                  pattern="[0-9]*"
                  max="9"
                  min="0"
                  maxLength="1"
                  name="ft"
                  data-key="ft"
                  placeholder="0"
                  data-locator="numberInput"
                  className="sc-bjUoiL dAUrxE"
                  value={feet}
                  onChange={handleFeetChange}
                />
                <span className="sc-fnykZs lignQJ">ft</span>
              </label>
            </div>
            <div className="sc-fEOsli bpSLXp">
              <label>
                <input
                  ref={inchesInputRef}
                  type="number"
                  pattern="[0-9]*"
                  max="11"
                  min="0"
                  maxLength="2"
                  name="in"
                  data-key="in"
                  placeholder="0"
                  data-locator="numberInput"
                  className="sc-bjUoiL dAUrxE"
                  value={inches}
                  onChange={(e) => setInches(e.target.value)}
                />
                <span className="sc-fnykZs lignQJ">in</span>
              </label>
            </div>
            <div className="sc-dIouRR hceQGH">
              <p
                type="caption"
                className={`sc-jSMfEi gKDiXa ${!validateInches() ? 'showNote' : ''}`}
              >
                Enter a value from 4ft 1in to 7ft 11in
              </p>
            </div>
          </div>
        </div>
        <div className={`TallContainer-module-inputWrapper--nmVX6 inputSingleWrapper ${unit === 'in' ? 'hidden' : ''}`}>
          <div className="sc-breuTD ievZUR">
            <label>
              <input
                type="number"
                pattern="[0-9]*"
                max="300"
                min="0"
                maxLength="3"
                placeholder="0"
                data-locator="numberInput"
                className="sc-ksZaOG cwhRdA"
                value={centimeters}
                onChange={(e) => setCm(e.target.value)}
              />
              <span className="sc-evZas fbQbbV">cm</span>
            </label>
            <div className="sc-hAZoDl lhLSYA">
              <p
                type="caption"
                className={`sc-jSMfEi gKDiXa ${!validateCentimeters() ? 'showNote' : ''}`}
              >
                Enter a value from 40 to 250 cm
              </p>
            </div>
          </div>
        </div>
        <div className="TallContainer-module-feedbackWrapper--JdXvS">
          <div className="PersonalFeedback-module-container--yv4uS PersonalFeedback-module-bgDefault--j9wWR">
            <div className="PersonalFeedback-module-imageWrapper--xkwWK">
              <div style={{ minHeight: 20 }}>
                <div className="lazyload-wrapper " style={{ minHeight: 20 }}>
                  <img src="data:image/png;base64,UklGRgYFAABXRUJQVlA4WAoAAAAQAAAAJwAAKAAAQUxQSCQBAAABkIJt2/ln72xvSWlr9pLb4prddiwq2badbHtLtm17n/17wnsc/+f5/ugRMQFMhvpOr6TJiYP5JwCIFocQAIAhcUjiNsQhW2yyuHVxyOFWxKGAmxOHcrGp4xbFoVks1IzUWQu3QSdvaqnB/A4/vzT2cvs0cowZtn7+9xz4AgDwlzuhMK5YmQ0pAAD4BSJeUgwBALxyIt8SaH3l8K/yOO0/NH80cMrfaMAMJ/dE5EVwRxSGU3wnisEpfyOqxil8IRKcUeyZCDpwh1SPcqgpqu8qqBqqW3lULNUcQ3tTFeM0fxJ54dgYzY4qQSBNJCNUOKJYUKNgbv9wr3aMNugf5nsIo/a5F+1rFKM3KLz/JwgAIAjfhlzZf1W1D4zPqyhN8LeQZ6IDVlA4ILwDAAAwFwCdASooACkAAAAAJbAC7OUFWfcF2AfsB/VecM3C7h/rN/M8Pd+MHYA8QD7Zu0B5gP0r/zP9V9k/9VfcB5EHWwegB+wHpkfrN8FP7O/tV7Id2xfXPpV7AbvZ695K96xmS/yX2QHfE/x/5R+TjIFf0/8ufbPiCP6//jPyA/s3xlf0fl9+dP9f7gn8i/m/90/MnuX/rl7AH6UHZrcTTh/ho/E14r/rkIuZSqUGszKBvsDA/53yY+jx8dGQk42IbzDMAAD+///FEob//+tvsqMXRA5ZE4LpqhP6nRCqH+U5Onkq53eFD/X2uXrRHF2cNK+m8+zSbv0xN9n5oJUlF8P//8MnT5qbkHj8AhqwXwNyRVx2RdubgYezQ9JwY0XRRr7v1PXMb9Y+H/SsYiOHe9T2hMtDvKJROMl0ngJrmyP/5vB/CZ+Kqi8Kv/RKv/zQWG3pM1zJIXILXsJ/GxH/5yw33vfrUplN2YK96T/6wHzt/1zEX1Wmtp/4ytFfup0cTa3jXZeotVB/8P7c0Oc2DPe9f//wIM2rjTQP/+Opx80ZAxDeg2MK4Wmda/11CFkuInphvI1+mN5zhtEbyrXaMYQOCWpxmFgRgmmk0c2ZwGiJ7/9xQT8VUG1WWU0wh77LoxY6hujIxxYBz8HLYSDbnXp99IhCk7YMkKIbMjJ6qkmLJ4Rutla+M5sKtL9nYJh+2NS+i2RbWRSlkQHwmchG//HG35v86spbq7egL9JpkP4EEFxwtvb5lgRuJetYHK9rNC0/lbscG0OGnidMpIKjjIZTwgJmjHpw/qARUHjMse4gPFReIjFd7SsEZx3jw4nXcy3pQ91cShCGvY9ddlgKsMIVQ9023noqlH/8LV9i9eoBojZogJTTf5gttdnr8ZKIijpkXCV2XdWqJq0HrIMoiF62GHis6e9Az31CD8jnd8fVo2jYaqlKzMWbwkBa6dgGBnW/TJ/Sjw+/h6mApaUgBHTlVhPDoo4BF17Cvz/TBSti1S5z8NGI+epHorsU0qlXrPyFuMk1Y/6raRCYNtWmtyQn2sBaa+z7FM36gPjwOy2Ki1p8ekqk93Um4PC8JK1ZqV8f/wYiK/9C+w9Tt1TkS1uOgyemrjMrzaDmz5DOFIM2iNvzRN5fV7+VVlSrpYGzAGc7fBq6sFzv8A/MKVcNCtW7clRSe8ewd/tNbInFLeGb81aoNxf0tLGrQPaRp//9+Gy///+jJhlZz2+Nt8ULhe7d7gu+zyK56/Ugx+2MVyWhruMl6aX7jlGc8J2aAA==" alt="feedback icon" className="LazyImage-module-image--pi4ov" />
                </div>
              </div>
            </div>
            <div>
              <p type="caption" color="text-main" className="sc-jSMfEi hBAgNn">Calculating your body mass index</p>
              <p type="caption" color="text-main" className="sc-jSMfEi cgynBM">BMI is widely used as a risk factor for the development or prevalence of several health issues.</p>
            </div>
          </div>
        </div>
        <button
          id="continueButton"
          className="sc-gsnTZi eRtgxg"
          onClick={handleNext}
          data-locator="obNextStep"
          disabled={!isButtonEnabled}  // Set disabled attribute based on our derived state
        >
          Continue
        </button>
      </div>
    </div>
  );
}

// Utility function to calculate BMI and round up to the nearest digit
function calculateBMI(heightInCm, weight, unit = 'kg') {
  let weightInKg;

  // Convert pounds to kilograms if the unit is 'lb'
  if (unit === 'lb') {
    weightInKg = weight / 2.20462;
  } else {
    weightInKg = weight; // Already in kilograms
  }

  const heightInMeters = heightInCm / 100;
  const bmi = weightInKg / (heightInMeters * heightInMeters);
  return Math.ceil(bmi); // Round up to the nearest digit
}


// Current Weight Component
function CurrentWeight() {
  const navigate = useNavigate();
  const location = useLocation();
  const { quizData, updateQuizData } = useQuiz();
  const { heightInCm } = quizData;
  const [weight, setWeight] = useState('');
  const [unit, setUnit] = useState('lb'); // Default unit is pounds
  const [bmiMessage, setBmiMessage] = useState('');
  const [bmiBackgroundColor, setBmiBackgroundColor] = useState('');

  // Handle Next: Store weight and unit in the database
  const handleNext = () => {
    const weightInKg = unit === 'lb' ? parseFloat(weight) / 2.20462 : parseFloat(weight);
    const bmi = calculateBMI(heightInCm, weightInKg); // Calculate BMI in kg

    updateQuizData({ weightInKg, unit, bmi }); // Save weight in kilograms and unit
    navigate(`/step/11${location.search}`);
  };

  // Handle weight unit change
  const handleUnitChange = (event) => {
    setUnit(event.target.value);
  };

  // Handle weight input change
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };

  // Validate pounds
  const validatePounds = () => {
    const weightNum = parseFloat(weight) || 0;
    return weightNum >= 50 && weightNum <= 800;
  };

  // Validate kilograms
  const validateKilograms = () => {
    const weightNum = parseFloat(weight) || 0;
    return weightNum >= 25 && weightNum <= 400;
  };

  // Enable/disable the Continue button
  useEffect(() => {
    const enableButton = unit === 'lb' ? validatePounds() : validateKilograms();
    const button = document.getElementById('continueButton');
    if (button) {
      button.disabled = !enableButton;
    }
  }, [weight, unit]);

  // Update BMI message and color
  useEffect(() => {
    const weightInKg = unit === 'lb' ? parseFloat(weight) / 2.20462 : parseFloat(weight);
    const bmi = calculateBMI(heightInCm, weightInKg);

    let message;
    let bgColor;
    if (bmi <= 18.4) {
      message = `Your BMI is ${bmi}, considered underweight.`;
      bgColor = "#FFFFE0"; // Light yellow
    } else if (bmi >= 18.5 && bmi <= 24.9) {
      message = `Your BMI is ${bmi}, considered normal.`;
      bgColor = "#F7F7F7"; // Light gray
    } else if (bmi >= 25 && bmi <= 29.9) {
      message = `❗ Your BMI is ${bmi}, considered overweight.`;
      bgColor = "#FFF3E8"; // Light orange
    } else {
      message = `❗ Your BMI is ${bmi}, considered obese.`;
      bgColor = "#FFE4E4"; // Light red
    }

    setBmiMessage(message);
    setBmiBackgroundColor(bgColor);
  }, [heightInCm, weight, unit]);

  return (
    <div>
      <div className="sc-bczRLJ dyisTO OptionContainer-module-container--Zu4Rp">
        <p type="h5" color="text-main" className="sc-jSMfEi fLSGMF">What is your weight?</p>
        <div className="sc-ikZpkk fbYsNG">
          <label htmlFor="checkbox_lb" data-locator="lbButton" className="sc-jIZahH ctOqxH">
            <input
              id="checkbox_lb"
              type="radio"
              name="weightUnit"
              className="sc-gXmSlM loxZGu"
              value="lb"
              checked={unit === 'lb'}
              onChange={handleUnitChange}
            />
            <p className="sc-himrzO eZLRYw">lb</p>
          </label>
          <label htmlFor="checkbox_kg" data-locator="kgButton" className="sc-jIZahH ctOqxH">
            <input
              id="checkbox_kg"
              type="radio"
              name="weightUnit"
              className="sc-gXmSlM loxZGu"
              value="kg"
              checked={unit === 'kg'}
              onChange={handleUnitChange}
            />
            <p className="sc-himrzO eZLRYw">kg</p>
          </label>
        </div>
        <div className="TallContainer-module-inputWrapper--nmVX6 inputSingleWrapper">
          <div className="sc-breuTD ievZUR">
            <label>
              <input
                type="number"
                pattern="[0-9]*"
                max={unit === 'lb' ? '800' : '400'}
                min={unit === 'lb' ? '50' : '25'}
                placeholder="0"
                className="sc-ksZaOG cwhRdA"
                value={weight}
                onChange={handleWeightChange}
              />
              <span className="sc-evZas fbQbbV">{unit}</span>
            </label>
            <div className="sc-hAZoDl lhLSYA">
              <p
                type="caption"
                className={`sc-jSMfEi gKDiXa ${unit === 'lb' ? (!validatePounds() ? 'showNote' : '') : (!validateKilograms() ? 'showNote' : '')}`}
              >
                {unit === 'lb' ? 'Enter a value from 50 to 800 lb' : 'Enter a value from 25 to 400 kg'}
              </p>
            </div>
          </div>
        </div>
        {weight && (
          <div className="bmiMessage" style={{ backgroundColor: bmiBackgroundColor }}>
            <p>{bmiMessage}</p>
          </div>
        )}
        <button
          id="continueButton"
          className="sc-gsnTZi eRtgxg"
          onClick={handleNext}
          data-locator="obNextStep"
        >
          Continue
        </button>
      </div>
    </div>
  );
}

// GoalWeight Component
function GoalWeight() {
  const navigate = useNavigate();
  const { quizData, updateQuizData } = useQuiz();
  const { heightInCm, weightInKg, bmi } = quizData; // Ensure weightInKg is correctly pulled from quizData
  const [perfectWeight, setPerfectWeight] = useState('');
  const [weightUnit, setWeightUnit] = useState('lb'); // Default unit set to pounds
  const [weightMessage, setWeightMessage] = useState('');

  const handleNext = () => {
    const perfectWeightInKg = weightUnit === 'lb'
      ? parseFloat(perfectWeight) / 2.2046226218487757
      : parseFloat(perfectWeight);

    if (!isNaN(perfectWeightInKg) && perfectWeightInKg > 0) {
      updateQuizData({ perfectWeight: perfectWeightInKg, weightUnit }); // Save perfect weight and unit in quizData
      navigate(`/step/12`);
    } else {
      // Handle error if perfect weight is invalid
      setWeightMessage("Please enter a valid weight.");
    }
  };

  const handleWeightUnitChange = (event) => {
    setWeightUnit(event.target.value);
  };

  const handlePerfectWeightChange = (event) => {
    setPerfectWeight(event.target.value);
  };

  const validatePounds = () => {
    const perfectWeightNum = parseFloat(perfectWeight) || 0;
    return perfectWeightNum >= 50 && perfectWeightNum <= 500;
  };

  const validateKilograms = () => {
    const perfectWeightNum = parseFloat(perfectWeight) || 0;
    return perfectWeightNum >= 25 && perfectWeightNum <= 250;
  };

  // Check if perfect weight is valid to enable the button
  useEffect(() => {
    const enableButton = weightUnit === 'lb' ? validatePounds() : validateKilograms();
    const button = document.getElementById('continueButton');
    if (button) {
      button.disabled = !enableButton;
    }
  }, [perfectWeight, weightUnit]);

  // Calculate percentage of weight to lose and update the weight message
  useEffect(() => {
    // Only proceed if weightInKg is defined and valid
    if (!weightInKg || isNaN(weightInKg) || weightInKg <= 0) {
      setWeightMessage('Invalid current weight. Please enter a valid current weight.');
      return;
    }

    const perfectWeightInKg =
      weightUnit === 'lb' ? parseFloat(perfectWeight) / 2.2046226218487757 : parseFloat(perfectWeight) || 0;

    if (perfectWeightInKg > 0) {
      const weightToLose = weightInKg - perfectWeightInKg;
      if (weightToLose >= 0) {
        const percentageToLose = Math.ceil((weightToLose / weightInKg) * 100);
        setWeightMessage(`You need to lose ${percentageToLose}% of your current weight.`);
      } else {
        setWeightMessage(`Your goal weight is higher than your current weight.`);
      }
    } else {
      setWeightMessage('');
    }
  }, [perfectWeight, weightUnit, weightInKg]);

  return (
    <div>
      <div className="sc-bczRLJ dyisTO OptionContainer-module-container--Zu4Rp">
        <p type="h5" color="text-main" className="sc-jSMfEi fLSGMF">What is your perfect weight?</p>
        <div className="sc-ikZpkk fbYsNG">
          <label htmlFor="checkbox_lb" data-locator="lbButton" className="sc-jIZahH ctOqxH">
            <input
              id="checkbox_lb"
              type="radio"
              name="weightUnit"
              data-locator="controlImperial"
              className="sc-gXmSlM loxZGu"
              value="lb"
              checked={weightUnit === 'lb'}
              onChange={handleWeightUnitChange}
            />
            <p className="sc-himrzO eZLRYw">lb</p>
          </label>
          <label htmlFor="checkbox_kg" data-locator="kgButton" className="sc-jIZahH ctOqxH">
            <input
              id="checkbox_kg"
              type="radio"
              name="weightUnit"
              data-locator="controlMetric"
              className="sc-gXmSlM loxZGu"
              value="kg"
              checked={weightUnit === 'kg'}
              onChange={handleWeightUnitChange}
            />
            <p className="sc-himrzO eZLRYw">kg</p>
          </label>
        </div>
        <div className="TallContainer-module-inputWrapper--nmVX6 inputSingleWrapper">
          <div className="sc-breuTD ievZUR">
            <label>
              <input
                type="number"
                pattern="[0-9]*"
                max={weightUnit === 'lb' ? '500' : '250'}
                min={weightUnit === 'lb' ? '50' : '25'}
                maxLength="3"
                placeholder="0"
                data-locator="numberInput"
                className="sc-ksZaOG cwhRdA"
                value={perfectWeight}
                onChange={handlePerfectWeightChange}
              />
              <span className="sc-evZas fbQbbV">{weightUnit}</span>
            </label>
            <div className="sc-hAZoDl lhLSYA">
              <p
                type="caption"
                className={`sc-jSMfEi gKDiXa ${weightUnit === 'lb' ? (!validatePounds() ? 'showNote' : '') : (!validateKilograms() ? 'showNote' : '')}`}
              >
                {weightUnit === 'lb' ? 'Enter a value from 50 to 500 lb' : 'Enter a value from 25 to 250 kg'}
              </p>
            </div>
          </div>
        </div>
        {weightMessage && (
          <div className="goalMessage">
            <h6>{weightMessage}</h6>
            <p>In a new study by Mayo Clinic, overweight people who lose more than 20% of their body weight are almost 2½ times more likely to have good metabolic health as those who lose 5-10%.</p>
          </div>
        )}
        <button
          id="continueButton"
          className="sc-gsnTZi eRtgxg"
          onClick={handleNext}
          data-locator="obNextStep"
        >
          Continue
        </button>
      </div>
    </div>
  );
}




// Age Component
function Age() {
  const navigate = useNavigate();
  const location = useLocation(); // Get current location to access search query
  const { bmi } = location.state || { bmi: 'Overweight' };
  const [age, setAge] = useState('');
  const { updateQuizData } = useQuiz();

  const handleNext = () => {
    // You can perform any necessary validation here before proceeding to the next step
    updateQuizData({ age });
    navigate(`/step/13${location.search}`);
  };

  const validateAge = () => {
    const ageNum = parseInt(age, 10) || 0;
    return ageNum >= 16 && ageNum <= 99;
  };

  // Check if age is filled and within the valid range to enable the button
  useEffect(() => {
    const enableButton = validateAge();
    const button = document.getElementById('continueButton');
    if (button) {
      button.disabled = !enableButton;
    }
  }, [age]);

  return (
    <div>
      <div className="sc-bczRLJ dyisTO OptionContainer-module-container--Zu4Rp">
        <p type="h5" color="text-main" className="sc-jSMfEi fLSGMF">How old are you?</p>
        <div className="TallContainer-module-inputWrapper--nmVX6 inputSingleWrapper">
          <div className="sc-breuTD ievZUR">
            <label>
              <input
                type="number"
                pattern="[0-9]*"
                max="99"
                min="16"
                maxLength="2"
                placeholder="0"
                data-locator="numberInput"
                className="sc-ksZaOG cwhRdA"
                value={age}
                onChange={(e) => setAge(e.target.value)}
              />
            </label>
            <div className="sc-hAZoDl lhLSYA">
              <p
                type="caption"
                className={`sc-jSMfEi gKDiXa ${!validateAge() ? 'showNote' : ''}`}
              >
                Enter an age from 16 to 99
              </p>
            </div>
          </div>
        </div>
        <div className="TallContainer-module-feedbackWrapper--JdXvS">
          <div className="PersonalFeedback-module-container--yv4uS PersonalFeedback-module-bgDefault--j9wWR">
            <div className="PersonalFeedback-module-imageWrapper--xkwWK">
              <div style={{ minHeight: 20 }}>
                <div className="lazyload-wrapper " style={{ minHeight: 20 }}>
                  <img src="data:image/png;base64,UklGRgYFAABXRUJQVlA4WAoAAAAQAAAAJwAAKAAAQUxQSCQBAAABkIJt2/ln72xvSWlr9pLb4prddiwq2badbHtLtm17n/17wnsc/+f5/ugRMQFMhvpOr6TJiYP5JwCIFocQAIAhcUjiNsQhW2yyuHVxyOFWxKGAmxOHcrGp4xbFoVks1IzUWQu3QSdvaqnB/A4/vzT2cvs0cowZtn7+9xz4AgDwlzuhMK5YmQ0pAAD4BSJeUgwBALxyIt8SaH3l8K/yOO0/NH80cMrfaMAMJ/dE5EVwRxSGU3wnisEpfyOqxil8IRKcUeyZCDpwh1SPcqgpqu8qqBqqW3lULNUcQ3tTFeM0fxJ54dgYzY4qQSBNJCNUOKJYUKNgbv9wr3aMNugf5nsIo/a5F+1rFKM3KLz/JwgAIAjfhlzZf1W1D4zPqyhN8LeQZ6IDVlA4ILwDAAAwFwCdASooACkAAAAAJbAC7OUFWfcF2AfsB/VecM3C7h/rN/M8Pd+MHYA8QD7Zu0B5gP0r/zP9V9k/9VfcB5EHWwegB+wHpkfrN8FP7O/tV7Id2xfXPpV7AbvZ695K96xmS/yX2QHfE/x/5R+TjIFf0/8ufbPiCP6//jPyA/s3xlf0fl9+dP9f7gn8i/m/90/MnuX/rl7AH6UHZrcTTh/ho/E14r/rkIuZSqUGszKBvsDA/53yY+jx8dGQk42IbzDMAAD+///FEob//+tvsqMXRA5ZE4LpqhP6nRCqH+U5Onkq53eFD/X2uXrRHF2cNK+m8+zSbv0xN9n5oJUlF8P//8MnT5qbkHj8AhqwXwNyRVx2RdubgYezQ9JwY0XRRr7v1PXMb9Y+H/SsYiOHe9T2hMtDvKJROMl0ngJrmyP/5vB/CZ+Kqi8Kv/RKv/zQWG3pM1zJIXILXsJ/GxH/5yw33vfrUplN2YK96T/6wHzt/1zEX1Wmtp/4ytFfup0cTa3jXZeotVB/8P7c0Oc2DPe9f//wIM2rjTQP/+Opx80ZAxDeg2MK4Wmda/11CFkuInphvI1+mN5zhtEbyrXaMYQOCWpxmFgRgmmk0c2ZwGiJ7/9xQT8VUG1WWU0wh77LoxY6hujIxxYBz8HLYSDbnXp99IhCk7YMkKIbMjJ6qkmLJ4Rutla+M5sKtL9nYJh+2NS+i2RbWRSlkQHwmchG//HG35v86spbq7egL9JpkP4EEFxwtvb5lgRuJetYHK9rNC0/lbscG0OGnidMpIKjjIZTwgJmjHpw/qARUHjMse4gPFReIjFd7SsEZx3jw4nXcy3pQ91cShCGvY9ddlgKsMIVQ9023noqlH/8LV9i9eoBojZogJTTf5gttdnr8ZKIijpkXCV2XdWqJq0HrIMoiF62GHis6e9Az31CD8jnd8fVo2jYaqlKzMWbwkBa6dgGBnW/TJ/Sjw+/h6mApaUgBHTlVhPDoo4BF17Cvz/TBSti1S5z8NGI+epHorsU0qlXrPyFuMk1Y/6raRCYNtWmtyQn2sBaa+z7FM36gPjwOy2Ki1p8ekqk93Um4PC8JK1ZqV8f/wYiK/9C+w9Tt1TkS1uOgyemrjMrzaDmz5DOFIM2iNvzRN5fV7+VVlSrpYGzAGc7fBq6sFzv8A/MKVcNCtW7clRSe8ewd/tNbInFLeGb81aoNxf0tLGrQPaRp//9+Gy///+jJhlZz2+Nt8ULhe7d7gu+zyK56/Ugx+2MVyWhruMl6aX7jlGc8J2aAA==" alt="feedback icon" className="LazyImage-module-image--pi4ov" />
                </div>
              </div>
            </div>
            <div>
              <p type="caption" color="text-main" className="sc-jSMfEi hBAgNn">We ask your age to create your personal plan</p>
              <p type="caption" color="text-main" className="sc-jSMfEi cgynBM">Older people tend to have more body fat than younger people with the same BMI.</p>
            </div>
          </div>
        </div>
        <button
          id="continueButton"
          className="sc-gsnTZi eRtgxg"
          onClick={handleNext}
          data-locator="obNextStep"
        >
          Continue
        </button>
      </div>
    </div>
  );
}

// Component Analyzing Body Composition
function BodyComposition() {
  const navigate = useNavigate();
  const { quizData } = useQuiz(); // Retrieve quiz data (including weight and unit)
  const { heightInCm, weight, unit } = quizData; // Extract weight and unit from quizData
  const [progress, setProgress] = useState(0);

  // Function to handle navigation after the progress bar completes
  const handleNext = () => {
    navigate(`/step/14`);
  };

  // UseEffect to simulate the progress bar filling over 8 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval);
          handleNext(); // Navigate to next step once progress reaches 100%
        }
        return prevProgress + 1; // Increase progress by ~1.25% every 100ms (8 seconds total)
      });
    }, 100); // 100ms interval for progress update

    return () => clearInterval(interval); // Cleanup the interval on unmount
  }, []);

  return (
    <div>
      <div className="step">
        <div className="step__container">
          <h2>Your metabolic rate = weight loss results</h2>
          <img
            src="https://futurhealth.com/new/_nuxt/img/graph3.f774067.png"
            style={{ width: '100%', marginBottom: 20 }}
            alt="Metabolic Graph"
          />
          <h4>
            LeanFormula <b>improves your metabolism</b> and <b>boosts energy</b> - making weight loss <b>much easier</b> and <b>sustainable</b>.
          </h4>
          <div className="loadingBar">
            <div className="loadingBar__bar">
              <span className="loadingBar__percent">{Math.round(progress)}%</span>
              <div
                className="loadingBar__fill"
                style={{ width: `${progress}%`, transition: 'width 0.1s linear' }}
              ></div>
            </div>
          </div>
          <h5 style={{ marginTop: 10, textAlign: 'center', fontWeight: 500 }}>Analyzing your body composition</h5>
        </div>
      </div>
    </div>
  );
}

// Diets Component
function Diets() {
  const navigate = useNavigate();
  const location = useLocation();
  const { bmi } = location.state || { bmi: 'Overweight' };

  const handleDietChange = (event) => {
    const selectedDiet = event.target.value;
    navigate(`/step/15${location.search}`, { state: { bmi, selectedDiet } });
  };

  return (
    <div>
      <div className="sc-bczRLJ dyisTO OptionContainer-module-container--Zu4Rp">
        <p type="h5" color="text-main" className="sc-jSMfEi fLSGMF">Do you follow any of these diets?</p>
        <div className="sc-dmRaPn iSEuTj">
          <div className="sc-kgflAQ bOaSgr" onClick={handleDietChange}>
            <input
              type="checkbox"
              data-locator="option"
              className="sc-iIPllB cgDdUM"
              value="Vegetarian"
            />
            <div className="sc-fLlhyt dgheGf">
              <div className="sc-bBrHrO UjSGr">
                <p type="medium-text" color="text-main" className="sc-jSMfEi fGeCMc">Vegetarian</p>
                <p type="small-text" color="text-secondary" className="sc-jSMfEi jUrtDM">Excludes meat</p>
              </div>
              <div className="sc-ivTmOn clONfs">
                <div className="lazyload-wrapper ">
                  <img
                    src="data:image/png;base64,UklGRpoEAABXRUJQVlA4WAoAAAAQAAAAMAAAMQAAQUxQSJEBAAABkGLbtiJJT335XVG49JE6Za7QqUPlWqGLwhXXAKCZJA2AwjczWGZmZo74V8T79HoCETEB9P+nZZmPMIrUtoMZ1xkM0mwuHwmRfwTwtCDKLl3qjRjUi4sHTx089Qnso8Iv+wj2xC0DfNxj4N/zUTfhaIxBiIM+KdwQ9KpP7hT6qvIoBPzsecwJQOGmLonLIU09EpE59RD96rYTq8ppMd7PmycUueq7AYwPgI7TGgLWATKXPgIaRNG3QgRNbbqC0BFbCalzlu5HMW9GuL0Qe0sxyUc5e4gt8VtMxVWQe5TRLwSVTALBI0xf0E/FDJx+RzpAbO4U+WlHXKm4vpwHDzapVlcOcItJfst5k1Jbv5dTEfdCzK2USxopH0eIXwaABmhi/SyIT160BF7JyLoLfBNpVZF1EiI/riqyTjYCvuwpRsie19HeVGVKzkPUaBgT4GM5MjJC3voseAOYP3/ev3nz+/7lU5euXLlydFtKYYd1yxiY43P9RGutFcVertE+3lUkdrIGnuYkWQ2fPu2S8ESTYABWUDgg4gIAANAQAJ0BKjEAMgA+kTqXR6WjIiEuGSxwsBIJZADBFcDW3oF+Q5H7o34r6jtq+o3bbeYz9M/XU9Ge8k+gB0wvn6Vaxr76yxaGHMQ+tAst4RViJWKUEH9h9lEPB9JFrt77zEEwyBHRYo8XOpydg3EkG/2PaJ+1RuaWugDZal2/8Dx8iHmIn1dFXxqESvzwqOqwAP7+9lfGUGEQ/TJTi4vYbNyJThZI9+w3K/V0JatNtw5+5a373E0yBH3jno1ZkF8stPYzXdMMKj+v2L3SfHONs/Z/GkW/pWDoeuYcqbBds4gnVsc2QwgKaUS55EjPlIil48L3pCewcXfWnKULDC1gBloirgI4zerapk1DQWATRqDGQc4OugqMWkhilXRgrsxGKijbj8CX5SW+vBsgAm7R5nisIG28KEYhcOKxjPs9q1CW/98kirL/98kW0yuFjTglcLHeVCKJi1pq1uMsOStN5E4foTJJ1ssNZzEK7aZQQRIEbVC1e3HOCyzDfuMqrM78xpfkiNwdPHpFHMV4o7ikze5AV/s3r78fadGo8QFv21U3ZyzyVx+NLK/lOMPOG6iUq2E3pGzyiFFCEnGcipF7eKiTw3f5PrrMULJB1fP1XWpdH+1C+1OziQfNb1tKRXjiFyCwjVW+iZ0QVG5keBEjoOke6TWWTg+NyJ3a1+pm9/Jj+TDLbVI6j8XDeV3wQA6qVbJ8zpo/8osXUAqrcjkwldcV9rEPXnBayzki+cO/6uVVwFzzqsAHaP5cMkf35wUf+fkIl4Euslu52NAuoKOU5p23F/kqzRcY2ppRnMBYKvDOj+IEIeQsFEmZsSAS1E20OALG9qTh3hznzsbJpDtRtFwKOQC1jGIyC+eN5DTmjEYMsCI2G45OfrNujuI+ygIUa5HT1/0sR//93jKk9QH7pwuVao+Yom8J+iuK0yUabV/+vh7Xl8BgaZ7VlqXnpWXfoJ47QUsCa/aCWh4ACmtAWtQAAA==" alt="ic" className="sc-kDDrLX ipwqQP" />
                </div>
              </div>
            </div>
          </div>
          <div className="sc-kgflAQ bOaSgr" onClick={handleDietChange}>
            <input
              type="checkbox"
              data-locator="option"
              className="sc-iIPllB cgDdUM"
              value="Vegan"
            />
            <div className="sc-fLlhyt dgheGf">
              <div className="sc-bBrHrO UjSGr">
                <p type="medium-text" color="text-main" className="sc-jSMfEi fGeCMc">Vegan</p>
                <p type="small-text" color="text-secondary" className="sc-jSMfEi jUrtDM">Excludes all animal products</p>
              </div>
              <div className="sc-ivTmOn clONfs">
                <div className="lazyload-wrapper ">
                  <img
                    src="data:image/png;base64,UklGRuADAABXRUJQVlA4WAoAAAAQAAAAMAAAMQAAQUxQSM0BAAABkDNre2K3i3obw5qtznaYk50w96byVmGsuTPUYU6q1MxQMTNuaXaYY4Ydo+4bkjSfJhExARDNmwjPN3zuO5kFIDMTE+duzZy7ZG6m0GKSOgRWNpzY8bW393pXV9d2oYl9JEuzpg4PD9NYkymSt+EkyZ6657R9mSIytfEJnfVWiIZ9dNXvt6bIYF3sUnt4JKQ32GmSL7OEVt7pNvT28Z/nUoSmxiQ1Ge9+QJKanytHCmFDHxmTPx6Q1Pz7uBS28ccbWvcuFwv7DvaRTBp6K0eKLT52py7JJI0fsyB+8Erczh5tqB0JwWDpnqtX9yS+x+0f74alu5+c3H3nwbICCK5/z7+H9MfDh7MApGQhJQWS62l+eDQFPo57Y8FbyouI1tt9qKa9Hi03rtWB5XJH6FtJn4sOpca9oestCAcRXWsKpKrp+mY6hEtaXd5Mh3AQ0bFZQbqEjs3TIT2j1aFlOqTVG9p3L4L4Edo3JyBe0mfXsgjiQUTrlkWQ30HrFwryM/qsmkdDXkW0fTEeHu6g7SUFDwu+2rxQ8PEIzfqkgo/qjak7EcDLpTS2JOBnykPDpfHwtJj/bKkI4Ov5v/TJ6fD3Edl9cjx8nnG8Yjr+6wBWUDgg7AEAALALAJ0BKjEAMgA+iUKZSSWkIiEqGZrosBIJagDLocD+gXKbyv6AMpE5L9IHoA2wHmAx0TeSCIx3YzBw35XgyvHb8G/4z+jybFr2HBVhCfIHTxqrm5m6uWAW2C5HvEiZDZZHYNNTQAD+/TZ5VtLRlJOQq1+YjoP9/0yq1gzla/1uM77tE58brOBz5S0z4d+rXS+o0u4RVcup9IU3QJQDHdSv7yN7Vz7/uv9NtdbDp5Z6xB3Rd2C5+rlSkGlaBams9SWKKjqe2v4ME4L87ndffSFh8m2so2RP2lEH3fDYXLlP0Jx0SvynQXcPetUSlVy+j/337ygLD/sPvIAyYBHE4a49OKX10zWz47f4WOfpKR49/7JVySPaiPZ3CSWcfTyBh1Yjv0cm3UMMLGRoyzzmI/Y6mcIR6bIV2Wy+ry/nbBvyqk5PM+Bn1uYQ3l+AFfEpD98Q5CcJqbjmH9ZJnnaTvmJ19YczT0BmGEqmpkdauWzeu7qlNDZCvFQP13XROITvkYih7/8uBZjKyD6hiVMDcpgm+4azaqXVZbnxspUuMy12CjCbbEdjN5+XNok2sKKfMcf8/Usd3mhc+DpEK/2eiyICGPgi/t8EX91G/pqyGll/1w///TVT7ER9Rv+C9o1p++RHI/fI9CF+QgAAAA=="
                    alt="ic"
                    className="sc-kDDrLX ipwqQP"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="sc-kgflAQ bOaSgr" onClick={handleDietChange}>
            <input
              type="checkbox"
              data-locator="option"
              className="sc-iIPllB cgDdUM"
              value="Keto"
            />
            <div className="sc-fLlhyt dgheGf">
              <div className="sc-bBrHrO UjSGr">
                <p type="medium-text" color="text-main" className="sc-jSMfEi fGeCMc">Keto</p>
                <p type="small-text" color="text-secondary" className="sc-jSMfEi jUrtDM">Low carbs and high fat</p>
              </div>
              <div className="sc-ivTmOn clONfs">
                <div className="lazyload-wrapper ">
                  <img
                    src="data:image/png;base64,UklGRpQDAABXRUJQVlA4WAoAAAAQAAAAMAAAMQAAQUxQSGIBAAABkFvb1hpnrwMtpQOxIpMKmNiceqkEhQMVeE3o0A180VRgZvqZMWSGocjw6bs/fZ/eexVExASQyiiZmEgiUpvkG/2Rta7/pBmpqPRGDv6LilzUHCP8dUVq4hlK50L5GOUfiFQMOF0s0PgAnoyvacFsuKINsO8wzX8A/22WCQNJjoqB7E655gcIWgDdMvPPIL4cFhkH8cs4KHkGWfvPDoXmI2jMQpoOGm9TYNNCZRbQtFC5Q/7GCDqnfJVn0GnI33M6Luu+Rt/qMOTfcFB5OeVrwOq4Tf4NKO36koHTcbnsy6F0UPf1NDgAO+T/puHfji9SM6XuKQU+UdIJWddxWQ+Z17FDodETFVkQ5RqeUskLwAldLpdJ+5DeodIrfaHBVDla6ct0iXP2WsIQb7p/zWaIfe2L5TExH6WbtigAFEFvMpJN1744Z21ReN50YhKPZ1c3v1hbFMXX49VZUltP07QeEztWUDggDAIAALALAJ0BKjEAMgA+iTiVR6UjoiEwGf34oBEJZgYoAPpndCPdVW7Vd5YIlJIbM9INXfbnOJLBs5Ql7leonJcXWRBHmMfJ0Z55hYZYt8mVGUJwcMp2GPWXu9qAK51aP9iAeEOeVGio0AD++Vg//3zX/++P3//ezNfl51Kx++FHi6c9ISRP7hLPJDL1A2EkUNHd/UYaXFARuw7Vd763Occ1ue6B2ydYOtN/DTS3pAp7keax9E1OAQxiQzjeEe0sOFHIdfavQVyAq0Huo+pKU5Aaa/Dc7ex5e/qeUqqpOyh3NALqCARJeK3vyQnn//T5Mz5upLyjhqp12vsAm/G9dzbZ8dNxSOThjMrYr14nXSo/x7KM2/GBIfNLFy97YyKraaDQ/znItMnRtgpD8KA0NXFNsGotLGaTYG4DWv2g8S8b0BwsJTs0NFqmaZoQPoDdVAK7ejVDqmDJUOxzNHA9PKMw4WmOqT/QG7KK3WKTtPNIr6LegpS8jqHXmUejPqCAR/XnljdSTBoWgT8dJGigNs1j5dRm2Ho0OuQkAgCuztxH+2VYigzxbic9P4I00YL8jTQ1OjKU6pOtwfFazPN0VrraL38XEC1b5LHDps3X4G6jDnfdO31uwurjAAXoHscHQjzsjyHkVhwApwPqfE3ITxsf/+/occ3bn/nb4UzFR4qeE9jklD4h3mxJtGUFBgAA"
                    alt="ic"
                    className="sc-kDDrLX ipwqQP"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="sc-kgflAQ bOaSgr" onClick={handleDietChange}>
            <input
              type="checkbox"
              data-locator="option"
              className="sc-iIPllB cgDdUM"
              value="None"
            />
            <div className="sc-fLlhyt dgheGf">
              <div className="sc-bBrHrO UjSGr">
                <p type="medium-text" color="text-main" className="sc-jSMfEi fGeCMc">None</p>
                <p type="small-text" color="text-secondary" className="sc-jSMfEi jUrtDM">No special diet followed</p>
              </div>
              <div className="sc-ivTmOn clONfs">
                <div className="lazyload-wrapper ">
                  <img
                    src="data:image/png;base64,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"
                    alt="ic"
                    className="sc-kDDrLX ipwqQP"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Activity Level Component
function ActivityLevel() {
  const navigate = useNavigate();
  const { quizData, updateQuizData } = useQuiz();

  const handleActivityChange = (level) => {
    updateQuizData({ activityLevel: level });
    navigate(`/step/16`);
  };

  return (
    <div>
      <div className="sc-bczRLJ dyisTO OptionContainer-module-container--Zu4Rp">
        <p type="h5" color="text-main" className="sc-jSMfEi fLSGMF">
          What is your activity level?
        </p>
        <div className="sc-dmRaPn iSEuTj">
          <div className="sc-kgflAQ bOaSgr" onClick={() => handleActivityChange('Sedentary')}>
            <input type="checkbox" data-locator="option" className="sc-iIPllB cgDdUM" value="Sedentary" />
            <div className="sc-fLlhyt dgheGf">
              <div className="sc-bBrHrO UjSGr">
                <p type="medium-text" color="text-main" className="sc-jSMfEi fGeCMc">Sedentary</p>
                <p type="small-text" color="text-secondary" className="sc-jSMfEi jUrtDM">Little to no exercise</p>
              </div>
              <div className="sc-ivTmOn clONfs">
                <div className="lazyload-wrapper ">
                  <img
                    src="data:image/png;base64,UklGRtQBAABXRUJQVlA4WAoAAAAQAAAAPwAAPwAAQUxQSJAAAAABcBPZttvcSs45x9e96nWfwIdiKIYjFoJgCILi9G6lrCoiJgA93ETtX4+FkUDnRVG26VRG6kpSGAu+FiUJvFuZy/91U5hNoPOiXJkURVq6tTsvjgRfCxN40qmsoyuFkfztx6I83jQtXNbWRJYCxoAj2wDMgCtbMzxf+X8mwEjN3QAQc48A5mr/OgIg5h7RDwVWUDggHgEAALAIAJ0BKkAAQAA+jTyXR6ejoiEz9NlY8BGJZghwAYpigv4DWKuzb1IZf9TbNpnvn4AcDB6o/oAdKx/jwirw6DnRFQhSWslR6b+GzrCHAAD+0cYKuLmP//m3Zmm0TPCXhmbEyq5CsADb/t+YN4N0we8CPYVjveW1sb3N6xZ7hXtD2DrYwuh+DKbmMuoxh3Gpv/AoAKFobxD5oD+xi5j//5t0RKe8TaZ2wo9tfRdvItlDIxUh2RZ/z/wH633IeFlom/ZK4H4xvIN2y+61x3Tj2K1wFFlA0GUeEEajMt+uNQPiRJfgh/hyjLr/qN/20i1fLp6rWTd48oCMamr2QDae1VpnYdavADgBk5sm0AGMr8mSqJ70OPDgTwpBIVgSwAA="
                    alt="ic"
                    className="sc-kDDrLX ipwqQP"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="sc-kgflAQ bOaSgr" onClick={() => handleActivityChange('Normal')}>
            <input type="checkbox" data-locator="option" className="sc-iIPllB cgDdUM" value="Normal" />
            <div className="sc-fLlhyt dgheGf">
              <div className="sc-bBrHrO UjSGr">
                <p type="medium-text" color="text-main" className="sc-jSMfEi fGeCMc">Normal</p>
                <p type="small-text" color="text-secondary" className="sc-jSMfEi jUrtDM">You get up and move daily</p>
              </div>
              <div className="sc-ivTmOn clONfs">
                <div className="lazyload-wrapper ">
                  <img
                    src="data:image/png;base64,UklGRs4BAABXRUJQVlA4WAoAAAAQAAAAPwAAPwAAQUxQSJUAAAABcJNtb9z8U69RBLRp8mYChlAIhlAIgRAGDoQyCIRAMJRcyn1niogJwA33IaYtvBi2nZ+lSBddKh9R+bEYY3VZysN2XysutFO/GF92uqWkXWEp2Unn1S8tJpR6sZiymy8VciovhmOpu6X4svO/uPyscV0BiF2EX5cHugzAIyApYjtnwOZR9QBlUU0AkJi2fACwUQn3UABWUDggEgEAANAHAJ0BKkAAQAA+kTyWR6WjoiEz8aqosBIJZADN+Wz/Aa572bj5NWSE+EA54X8ZtY79ADpXgkkBobpOxSmt7kN4jAEWDqDwAP78rRCF+Rbv//m3W8ZuT04TDPw0Wx9+LXlbwAMf++VResR7OyXfGy8cGpMZfcnx+sZU6Qf6lNUKPLGq3XTtYvq+rQeXJYV76yN0Z/rvf//8258y/hE4WKJZGgLjbyL3lqWiyJWQpmE5/l8KTZsQDKY6fFtF1rrZcMZYQ9i0RcioniBoMo8IIz1B+j+poPdxwGCUuDP/7/t16whiuYr8fzsXn5NrRySMMG6t/kNZkdRs6uhJxPUrR2zz2/ZgiIr5uunVnx3lbwUPgAA="
                    alt="ic"
                    className="sc-kDDrLX ipwqQP"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="sc-kgflAQ bOaSgr" onClick={() => handleActivityChange('Active')}>
            <input type="checkbox" data-locator="option" className="sc-iIPllB cgDdUM" value="Active" />
            <div className="sc-fLlhyt dgheGf">
              <div className="sc-bBrHrO UjSGr">
                <p type="medium-text" color="text-main" className="sc-jSMfEi fGeCMc">Active</p>
                <p type="small-text" color="text-secondary" className="sc-jSMfEi jUrtDM">You exercise weekly</p>
              </div>
              <div className="sc-ivTmOn clONfs">
                <div className="lazyload-wrapper ">
                  <img
                    src="data:image/png;base64,UklGRsIBAABXRUJQVlA4WAoAAAAQAAAAPwAAPwAAQUxQSI0AAAABYI1tb50foQZRKEIRihCEIQxhCEGYQRCKEIQhHJOrnXcVEROAHy6p7Vt/GJnDchSN+FPJo+6FDmOzr0ehOf5WiuwHPgzPYTnKEMlR5KVjt6bDyOy3w8wxfSqpuHQYstkvR+E5HA+nb02JBLAooYsYaQoMGKIaoW+2VwKymstAEnN7ALXZXjOQxNwO/1AAVlA4IA4BAAAwCACdASpAAEAAPpE8lkelo6IhM/GqqLASCWQIcAGHRRv+A1hTte8ZEJ8IBzvf4gcCr6qHoAdK4EkgNDdJ2KU1vchvEYAiw7QFAAD+0cYErP7P//zbqCssq+MMLw1dBhWDLydAAq/8T0ULj4ASa1wL8M0P3U0yYFiPDbYtORy/FyetNw0uZT1bO0Kpn0J9S8/CxdqgwJDKTT7k0///NuaeimHcAaHPr4UzfEGRZ9MNVEh2QuIU/5fCtWasusA/O536W6095mjeFhZIHszE8aPBK6OhEmd+g9CpttP+wN1XnnomYL3tzuTdkRE8zDvHZLhvPgEigAUMCcJKdB0OZwrwSwY/F1G4TZPu4KDQAAA="
                    alt="ic"
                    className="sc-kDDrLX ipwqQP"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


// Composition Results Component
function CompositionResults() {
  const navigate = useNavigate();
  const { quizData } = useQuiz();
  const { bmi, activityLevel } = quizData;

  const handleNext = () => {
    navigate(`/step/17`);
  };

  // Calculate dynamic left position for the dot based on BMI
  const calculateLeftPosition = (bmi) => {
    if (bmi <= 18.5) return '0%'; // Below Normal
    if (bmi >= 35) return '100%'; // Obese
    return `${((bmi - 18.5) / (35 - 18.5)) * 100}%`; // Scale from 0% to 100%
  };

  // Determine body type based on BMI
  const getBodyType = (bmi) => {
    if (bmi < 18.5) return 'Underweight';
    if (bmi >= 18.5 && bmi < 24.9) return 'Normal';
    if (bmi >= 25 && bmi < 30) return 'Overweight';
    if (bmi >= 30) return 'Obese';
  };

  // Determine image based on BMI
  const getImageSrc = (bmi) => {
    if (bmi >= 18.5 && bmi < 24.9) return `${process.env.PUBLIC_URL}../assets/images/normal-man-woman.png`;
    if (bmi >= 25 && bmi < 30) return `${process.env.PUBLIC_URL}../assets/images/overweight-man-woman.png`;
    if (bmi >= 30) return `${process.env.PUBLIC_URL}../assets/images/obese-man-woman.png`;
  };

  return (
    <div>
      <div className="FeedbackSummaryContainer-module-container--+pMXq">
        <h1 className="Title-module-default--X8sDL Title-module-h2--T8W2Z Common-module-centered--f1oqe Common-module-mb-xs2--dyDYl">
          Your body composition analysis
        </h1>
        <div className="FeedbackSummaryContainer-module-bmiWrapper--g05O-">
          <div>
            <div className="FeedbackSummaryContainer-module-bmiHeader--aVAkG">
              <p className="Text-module-default--9nb4F Text-module-mediumSmall--JWE3s Text-module-bold--DRNtQ ">
                Body Mass Index (BMI)
              </p>
              <p className="Text-module-default--9nb4F Text-module-caption--MeFDb Text-module-grey--mn9R0 ">
                Normal - 21.5
              </p>
            </div>
          </div>
          <div className="FeedbackSummaryContainer-module-bmiChartWrapper--fkLxi">
            <svg width="100%" height="76" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 66h343M0 50h343M0 34h343M0 17h343M221.172 75.5V.5M170.977 75.5V.5M271.367 75.5V.5M321.562 75.5V.5M121.828 75.5v-74M71.633 75.5v-74M21.437 75.5v-74" stroke="#E9ECEF" strokeDasharray="3 2"></path>
            </svg>
            <div className="FeedbackSummaryContainer-module-bmiChart--S63zJ">
              <svg width="100%" height="9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="0.5" width="100%" height="8" rx="4" fill="url(#graph_svg__paint0_linear_1894_3495)"></rect>
                <defs>
                  <linearGradient
                    id="graph_svg__paint0_linear_1894_3495"
                    x1="0"
                    y1="4.5"
                    x2="301"
                    y2="4.5"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.1" stopColor="#93D054"></stop>
                    <stop offset="0.4" stopColor="#F7D147"></stop>
                    <stop offset="0.7" stopColor="#EA0A0A"></stop>
                  </linearGradient>
                </defs>
              </svg>
              <div className="FeedbackSummaryContainer-module-dotWrapper--CfNHs" style={{ left: calculateLeftPosition(bmi) }}>
                <div className="FeedbackSummaryContainer-module-bmiTooltip--uTHrx">
                  <p className="Text-module-default--9nb4F Text-module-extraSmall--EPJug Text-module-normal--evGFf Text-module-white--2Bq0+ ">
                    You - {bmi}
                  </p>
                </div>
                <div className="FeedbackSummaryContainer-module-bmiDot--0eCby"></div>
              </div>
            </div>
            <div className="FeedbackSummaryContainer-module-bmiTitles--1C30n">
              <p className="Text-module-default--9nb4F Text-module-caption--MeFDb Text-module-grey--mn9R0 Text-module-bold--DRNtQ Text-module-uppercase--Dcjqx Text-module-letterSpacing1--2438o ">
                Normal
              </p>
              <p className="Text-module-default--9nb4F Text-module-caption--MeFDb Text-module-grey--mn9R0 Text-module-bold--DRNtQ Text-module-uppercase--Dcjqx Text-module-letterSpacing1--2438o ">
                Overweight
              </p>
              <p className="Text-module-default--9nb4F Text-module-caption--MeFDb Text-module-bold--DRNtQ Text-module-uppercase--Dcjqx Text-module-letterSpacing1--2438o ">
                Obese
              </p>
            </div>
          </div>
        </div>

        {/* Body Type and Activity Level */}
        <div className="FeedbackSummaryContainer-module-bodyWrapper--5+-VY">
          <div>
            <div className="FeedbackSummaryContainer-module-bmiField--Wsqp7">
              <div className="FeedbackSummaryContainer-module-iconBox--0X-9t">
                <svg width="25" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.875 3.5h11.25A3.374 3.374 0 0121.5 6.875v11.25a3.374 3.374 0 01-3.375 3.375H6.875A3.374 3.374 0 013.5 18.125V6.875A3.374 3.374 0 016.875 3.5zm8.834 9c.342 0 .665-.155.879-.422l2.118-2.647c.32-.401.325-.965-.05-1.316-.938-.88-2.99-2.365-6.156-2.365-3.166 0-5.218 1.485-6.157 2.365-.374.351-.37.915-.049 1.316l2.118 2.647c.214.267.537.422.879.422h6.418z"
                    fill="#4A5056"
                  ></path>
                  <path d="M14.912 8.85L14 12.5h-3l3.745-3.745c.071-.071.192-.003.167.095z" fill="#4A5056"></path>
                </svg>
              </div>
              <div>
                <p className="Text-module-default--9nb4F Text-module-caption--MeFDb Text-module-grey--mn9R0 ">
                  Body type
                </p>
                <p className="Text-module-default--9nb4F Text-module-small2--4iHU9 ">{getBodyType(bmi)}</p>
              </div>
            </div>

            {/* Activity level */}
            <div className="FeedbackSummaryContainer-module-bmiField--Wsqp7">
              <div className="FeedbackSummaryContainer-module-iconBox--0X-9t">
                <svg width="25" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.93 1.784h.001a.976.976 0 01-.182 1.369l.182-1.369zm0 0a.976.976 0 00-1.367-.182 6.174 6.174 0 00-2.058 2.742 6.592 6.592 0 00-.42 2.313v.001m3.846-4.874L9.085 6.658m6.358 4.263a.818.818 0 00.045-.612 1.75 1.75 0 00-.217-.451 5.617 5.617 0 00-.693-.833 12.27 12.27 0 00-1.412-1.235l-.002-.001-.04-.028-.012-.008-.101-.069-.122-.014c-.446-.053-.849-.158-1.174-.358-.313-.192-.579-.486-.74-.97-.09-.268-.185-.696-.007-1.165l4.475 5.744zm0 0a2.43 2.43 0 01-.586.716l-.001.001c-.478.407-1.135.73-2.014 1.016h0a.977.977 0 01-.333.048c.111.15.187.324.221.511h0l.496 2.74h0a1.23 1.23 0 01-.99 1.428m3.207-6.46L5.197 17.232c.606.315 1.353.08 1.668-.526 0 0 0 0 0 0l1.885-3.627 1.655 1.09.402 2.222h0a1.23 1.23 0 001.209 1.01h0c.073 0 .146-.006.22-.02m0 0l-.09-.491.09.491s0 0 0 0zM9.086 6.658c0 .15.005.281.012.39L4.67 15.565h0m4.414-8.907l-4.414 8.907m0 0a1.236 1.236 0 00.526 1.667l-.526-1.666zm6.686-3.712l1.107-2.13a40.268 40.268 0 01.73.658 6.872 6.872 0 01-.955.416.976.976 0 00-.63 1.221l-.252-.165zm-.39-6.676c.104-.271.334-.617.664-.99a8.183 8.183 0 011.118-1.034l-1.781 2.024z"
                    stroke="#4A5056"
                  ></path>
                  <path
                    d="M14.439 6.655a1.84 1.84 0 10-3.265-1.697 1.84 1.84 0 003.265 1.697z"
                    stroke="#4A5056"
                  ></path>
                </svg>
              </div>
              <div>
                <p className="Text-module-default--9nb4F Text-module-caption--MeFDb Text-module-grey--mn9R0 ">
                  Activity level
                </p>
                <p className="Text-module-default--9nb4F Text-module-small2--4iHU9 ">{activityLevel}</p>
              </div>
            </div>

            {/* Fat loss potential */}
            <div className="FeedbackSummaryContainer-module-bmiField--Wsqp7">
              <div className="FeedbackSummaryContainer-module-iconBox--0X-9t">
                <svg width="25" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.3 7.5h2v9h-2v-9z" fill="#4A5056" stroke="#4A5056"></path>
                  <path fillRule="evenodd" clipRule="evenodd" d="M2 13.25h3V17H2v-3.75z" fill="#4A5056"></path>
                  <path d="M6.9 16.5v-5.875h2V16.5h-2z" fill="#4A5056" stroke="#4A5056"></path>
                  <path fill="#4A5056" d="M15.5 3h3v14h-3z"></path>
                </svg>
              </div>
              <div>
                <p className="Text-module-default--9nb4F Text-module-caption--MeFDb Text-module-grey--mn9R0 ">
                  Fat loss potential
                </p>
                <p className="Text-module-default--9nb4F Text-module-small2--4iHU9 ">Excellent</p>
              </div>
            </div>


          </div>
                      {/* Image Based on BMI */}
                      <div className="FeedbackSummaryContainer-module-modelWrapper--Xyl49">
              <div style={{ minHeight: 20 }}>
                <div className="lazyload-wrapper " style={{ minHeight: 20 }}>
                  <img
                    src={getImageSrc(bmi)}
                    alt="body"
                    className="LazyImage-module-image--pi4ov"
                  />
                </div>
              </div>
            </div>
        </div>

        <div className="FeedbackSummaryContainer-module-messageWrapper--Ww+-x FeedbackSummaryContainer-module-red--HWiXL">
          <span aria-label="" role="img" className="FeedbackSummaryContainer-module-emojiPart--EZYMQ">
            🤔
          </span>
          <div>
            <p className="Text-module-default--9nb4F Text-module-caption--MeFDb Text-module-bold--DRNtQ ">
              Risks for an unhealthy BMI
            </p>
            <p className="Text-module-default--9nb4F Text-module-caption--MeFDb ">
              High blood pressure, heart disease, stroke, type 2 diabetes, some types of cancer, osteoarthritis, back pain, all case mortality
            </p>
          </div>
        </div>

        <div className="FixedWrapper-module-fixedWrapperContainer--JAz+c">
          <div className="FixedWrapper-module-innerContainer--9r6Kl">
            <button
              id="continueButton"
              className="sc-gsnTZi eRtgxg"
              onClick={handleNext}
              data-locator="obNextStep"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}



// Goal Chart Component
function GoalChart() {
  const navigate = useNavigate();
  const { quizData } = useQuiz();
  const { weightInKg, perfectWeight, weightUnit } = quizData;

  const handleNext = () => {
    navigate(`/step/19`);
  };

  // Convert current and perfect weights to the selected unit
  const currentWeight = weightUnit === 'lb' ? Math.round(weightInKg * 2.20462) : weightInKg;
  const perfectWeightInUnit = weightUnit === 'lb' ? Math.round(perfectWeight * 2.20462) : perfectWeight;

  // Calculate weight milestones (50% and 75% towards the goal)
  const milestone50 = Math.round(currentWeight - (currentWeight - perfectWeightInUnit) * 0.5);
  const milestone75 = Math.round(currentWeight - (currentWeight - perfectWeightInUnit) * 0.75);

  // Calculate goal date, assuming the user will reach the goal in 3 months
  const today = new Date();
  const goalDate = new Date(today.setMonth(today.getMonth() + 3));
  const formattedGoalDate = goalDate.toLocaleString('default', { month: 'long', day: 'numeric', year: 'numeric' });

  return (
    <div>
      <div className="_container_113ff_1">
        <div className="_contentWrapper_113ff_58">
          <p type="h5" color="text-main" className="sc-iGgWBj dFJukc">
            The one and only plan you’ll ever need to <span className="_titleHighlight_113ff_7">lose weight</span>
          </p>
          <p type="small-text" color="text-secondary" className="sc-iGgWBj dWbqTF">
            According to the information you have provided us, you’ll achieve your goal weight of {perfectWeightInUnit}&nbsp;{weightUnit} after
          </p>
          <p type="h6" color="text-main" className="sc-iGgWBj fsnLlE _underline_113ff_11">
            3 LeanFormula phases.
          </p>
          <div className="sc-aXZVg kfVqAo _graphicWrapper_113ff_15">
            <div className="_container_1h2ox_1">
              <div className="_graphicAnimationWrapper_1h2ox_7">
                <div className="lazyload-wrapper ">
                  <img
                    src={`${process.env.PUBLIC_URL}../assets/images/goal-chart.webp`}
                    alt="graph"
                    className="sc-kpDqfm gzDPPi _image_1h2ox_13"
                  />
                </div>
              </div>

              {/* Current Weight Marker */}
              <div className="_tipWrapper_1h2ox_23 _tipWrapperStart_1h2ox_33">
                <div className="_tip_2dkun_1">
                  <p type="caption" color="on-primary" className="sc-iGgWBj mZkjN">
                    {currentWeight}
                  </p>
                  <p type="caption" color="on-primary" className="sc-iGgWBj mZkjN _unit_2dkun_21">
                    {weightUnit}
                  </p>
                  <div className="_substractWrapper_2dkun_10">
                    <svg width="16" height="5" viewBox="0 0 16 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 0C0.778772 0 1.16816 0 1.53321 0.0860943C1.85681 0.162413 2.16529 0.288211 2.44665 0.458594C2.76405 0.650801 3.03288 0.919222 3.57054 1.45606L5.61964 3.50204C6.449 4.33013 6.86368 4.74417 7.34626 4.89835C7.77048 5.03388 8.22952 5.03388 8.65374 4.89835C9.13632 4.74417 9.551 4.33013 10.3804 3.50203L12.4295 1.45606C12.9671 0.919222 13.236 0.650801 13.5533 0.458595C13.8347 0.288211 14.1432 0.162413 14.4668 0.0860943C14.8318 0 15.2212 0 16 0H0Z"
                        fill="#252D48"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="_buttonMain_1h2ox_120 _buttonStart_1h2ox_127"></div>
              </div>

              {/* 50% Milestone Marker */}
              <div className="_tipWrapper_1h2ox_23 _tipWrapperSecond_1h2ox_51">
                <div className="_tip_2dkun_1">
                  <p type="caption" color="on-primary" className="sc-iGgWBj mZkjN">
                    {milestone50}
                  </p>
                  <p type="caption" color="on-primary" className="sc-iGgWBj mZkjN _unit_2dkun_21">
                    {weightUnit}
                  </p>
                  <div className="_substractWrapper_2dkun_10">
                    <svg width="16" height="5" viewBox="0 0 16 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 0C0.778772 0 1.16816 0 1.53321 0.0860943C1.85681 0.162413 2.16529 0.288211 2.44665 0.458594C2.76405 0.650801 3.03288 0.919222 3.57054 1.45606L5.61964 3.50204C6.449 4.33013 6.86368 4.74417 7.34626 4.89835C7.77048 5.03388 8.22952 5.03388 8.65374 4.89835C9.13632 4.74417 9.551 4.33013 10.3804 3.50203L12.4295 1.45606C12.9671 0.919222 13.236 0.650801 13.5533 0.458595C13.8347 0.288211 14.1432 0.162413 14.4668 0.0860943C14.8318 0 15.2212 0 16 0H0Z"
                        fill="#252D48"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="_buttonSecondary_1h2ox_135"></div>
              </div>

              {/* 75% Milestone Marker */}
              <div className="_tipWrapper_1h2ox_23 _tipWrapperPenultimate_1h2ox_82">
                <div className="_tip_2dkun_1">
                  <p type="caption" color="on-primary" className="sc-iGgWBj mZkjN">
                    {milestone75}
                  </p>
                  <p type="caption" color="on-primary" className="sc-iGgWBj mZkjN _unit_2dkun_21">
                    {weightUnit}
                  </p>
                  <div className="_substractWrapper_2dkun_10">
                    <svg width="16" height="5" viewBox="0 0 16 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 0C0.778772 0 1.16816 0 1.53321 0.0860943C1.85681 0.162413 2.16529 0.288211 2.44665 0.458594C2.76405 0.650801 3.03288 0.919222 3.57054 1.45606L5.61964 3.50204C6.449 4.33013 6.86368 4.74417 7.34626 4.89835C7.77048 5.03388 8.22952 5.03388 8.65374 4.89835C9.13632 4.74417 9.551 4.33013 10.3804 3.50203L12.4295 1.45606C12.9671 0.919222 13.236 0.650801 13.5533 0.458595C13.8347 0.288211 14.1432 0.162413 14.4668 0.0860943C14.8318 0 15.2212 0 16 0H0Z"
                        fill="#252D48"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="_buttonSecondary_1h2ox_135"></div>
              </div>

              {/* Goal Weight Marker */}
              <div className="_tipWrapper_1h2ox_23 _tipWrapperFinish_1h2ox_106">
                <div className="_tip_2dkun_1">
                  <p type="caption" color="on-primary" className="sc-iGgWBj mZkjN">
                    {perfectWeightInUnit}
                  </p>
                  <p type="caption" color="on-primary" className="sc-iGgWBj mZkjN _unit_2dkun_21">
                    {weightUnit}
                  </p>
                  <div className="_substractWrapper_2dkun_10">
                    <svg width="16" height="5" viewBox="0 0 16 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 0C0.778772 0 1.16816 0 1.53321 0.0860943C1.85681 0.162413 2.16529 0.288211 2.44665 0.458594C2.76405 0.650801 3.03288 0.919222 3.57054 1.45606L5.61964 3.50204C6.449 4.33013 6.86368 4.74417 7.34626 4.89835C7.77048 5.03388 8.22952 5.03388 8.65374 4.89835C9.13632 4.74417 9.551 4.33013 10.3804 3.50203L12.4295 1.45606C12.9671 0.919222 13.236 0.650801 13.5533 0.458595C13.8347 0.288211 14.1432 0.162413 14.4668 0.0860943C14.8318 0 15.2212 0 16 0H0Z"
                        fill="#252D48"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="_buttonMain_1h2ox_120 _buttonFinish_1h2ox_131"></div>
              </div>
            </div>

            {/* Timeline Months */}
            <div className="_monthsBox_113ff_16">
              <p type="caption" color="text-secondary-subdued" className="sc-iGgWBj huIcJP">Now</p>
              <p type="caption" color="text-secondary-subdued" className="sc-iGgWBj huIcJP">Phase 1</p>
              <p type="caption" color="text-secondary-subdued" className="sc-iGgWBj huIcJP">Phase 2</p>
              <p type="caption" color="text-secondary-subdued" className="sc-iGgWBj huIcJP">Phase 3</p>
            </div>
          </div>
        </div>

        {/* Continue Button */}
        <div className="_buttonWrapper_113ff_42">
          <button id="continueButton" className="sc-gsnTZi eRtgxg" onClick={handleNext} data-locator="obNextStep">
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}


// Old Results loading - Loading Results
function Step13() {
  const navigate = useNavigate();
  const location = useLocation();
  const { activityLevel, bmi } = location.state || { activityLevel: 'NA', bmi: 'Not Set' };

  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 3; // Replace with the actual number of slides you have

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(`/step/14${location.search}`);
    }, 16000); // 16000 milliseconds = 15 seconds

    return () => clearTimeout(timer); // Cleanup function to clear the timer
  }, []); // Empty dependency array ensures this runs once when the component mounts


  useEffect(() => {
    let startTime = Date.now();
    let duration = 15000; // 15 seconds in milliseconds

    const textElement = document.querySelector("._textComponent_1hhyz_11");

    const intervalId = setInterval(() => {
      let currentTime = Date.now();
      let elapsedTime = currentTime - startTime;

      let percentage = (elapsedTime / duration) * 100;

      if (percentage >= 100) {
        percentage = 100;
        clearInterval(intervalId);
      }

      textElement.textContent = `${Math.round(percentage)}%`;
    }, 100); // Update every 100ms

    return () => clearInterval(intervalId); // Cleanup if component unmounts
  }, []);

  // Animation for carousel slides
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % totalSlides);
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  const offset = -currentSlide * 300; // Assuming each slide is 300px wide


  return (
    <div>
      <div className="_animationWrapper_ppgpe_1">
        <div>
          <svg width="176" height="176" className="_svgComponent_1hhyz_1">
            <circle stroke="#f4f6f3" cx="88" cy="88" r="81" strokeWidth="14"></circle>
            <circle stroke="var(--primary-default)" cx="88" cy="88" r="71" strokeWidth="14" strokeDasharray="446.10615680975064" strokeDashoffset="0" className="_animatedCircle_1hhyz_5" strokeLinecap="round" style={{ stroke: "var(--primary-default)", transition: "strokeDashoffset 0.3s ease 0s" }}></circle>
            <text x="88" y="88" alignmentBaseline="middle" textAnchor="middle" className="_textComponent_1hhyz_11" style={{ fill: "var(--text-secondary)" }} >0%</text>
          </svg>
        </div>
        <div className="_textAnimation_ppgpe_13"><div className="_textAnimationItem_ppgpe_22" style={{ animationDelay: "0s" }}>
          <p type="small-text" color="text-main" className="sc-iGgWBj hGmRKm">Creating your personal plan...</p>
        </div>
          <div className="_textAnimationItem_ppgpe_22" style={{ animationDelay: "15s" }}>
            <p type="small-text" color="text-main" className="sc-iGgWBj hGmRKm">Your personal plan created</p>
          </div>
        </div>
        <p type="h1" color="success-default" className="sc-iGgWBj gzfFEq _title_ppgpe_23">35 million users<p type="large-text" color="success-default" className="sc-iGgWBj bIsBmN">have chosen our weight loss regimens</p></p>
        <div className="_sliderContainer_ppgpe_44">
          <div className="slick-slider _sliderWrapper_igrbr_1 slick-initialized" dir="ltr">
            <div className="slick-list" style={{ padding: "0px 39px" }}>
              <div className="slick-track" style={{ transform: `translateX(${offset}px)` }} >
                <div data-index="0" className="slick-slide" tabIndex="-1" aria-hidden="true" style={{ outline: "none", width: "300px" }}>
                  <img src={`${process.env.PUBLIC_URL}../assets/images/review-image-1.png`} style={{ width: 300 }} />
                  {/* <div>
                    <div className="_wrapper_fqbso_1"><div className="_author_fqbso_9">
                      <div className="_photo_fqbso_20"><div className="lazyload-wrapper ">
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAWlBMVEUAAAC+x9C/x8++xtC+x9C/y8++x9C+x9C+x9C/x8+9x8++yNC+x9C/yNDAydG/yc++yM++x8++x9D////4+frn6+7O1dzGztbw8vTZ3uTCy9Pi5+rK0dne4+c73eMjAAAAEnRSTlMAgCDv3xDPv5BgYO+vn19QUKBYMaMSAAABN0lEQVRIx5WV2ZKCMBBFm+wsLnNBAur8/28OE0sWQzB9nlrrnurcggoUoUvXKAlAWVcJ+oIuLDaY4KTjEjGnpBLiexS0hzBIonaWnCUOqC/RcfCFIsqzjCsyOK/6yhyhXporZGGiApk1BHKpdRBOyKbYLrh77+M5TOsV1Szc2rZ7z33btv3y73qF4Qg2nIghQFPFEypyPMGR5QkNKZ6gCDyh5grgC5IpZJUe1qWbfcFPwhimYSPY1INDN/3wAMZgzrjPV2N48QzB7vY7tEGcKUmvhZkeeLzn7okFQWQTAsYhxB8eC+b4Crj3vceGchK0RD6CwopsTkS8FYJ/kb0wyEIxL2MpaKbMES78Dwr/k7XmethDVhQhFJKYpW/OsWRBCcTPblxTGlEabLBLPO04+19HqsaVcfoP1G5/pg0nQ88AAAAASUVORK5CYII=" alt="photo" className="sc-kpDqfm gzDPPi" />
                      </div>
                      </div>
                      <p type="caption" color="text-main" className="sc-iGgWBj fMvoXk">Lucas</p>
                      <div className="_mark_fqbso_26"><div type="informational" size="14" name="star" className="sc-bbSZdi gePvOI">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_9078_100933)">
                            <path d="M7.67729 13.7709C7.87424 13.6448 8.12576 13.6448 8.32271 13.7709L11.5024 15.8071C12.4069 16.3862 13.5548 15.5751 13.3229 14.5207L12.4468 10.536C12.4001 10.3239 12.4696 10.1029 12.6288 9.95656L15.6057 7.22043C16.3797 6.50905 15.9452 5.2097 14.9018 5.11579L11.0727 4.77112C10.8474 4.75084 10.6525 4.60498 10.568 4.39352L9.11647 0.760001C8.71166 -0.253334 7.28834 -0.253333 6.88353 0.760002L5.43201 4.39352C5.34754 4.60498 5.15257 4.75084 4.92731 4.77112L1.09818 5.11579C0.0548482 5.2097 -0.379731 6.50905 0.39426 7.22043L3.3712 9.95656C3.53044 10.1029 3.59987 10.3239 3.55325 10.536L2.67708 14.5207C2.44524 15.5751 3.59315 16.3862 4.49756 15.8071L7.67729 13.7709Z"></path></g><defs><clipPath id="clip0_9078_100933"><rect width="16" height="16" fill="white">
                            </rect>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                        <div type="informational" size="14" name="star" className="sc-bbSZdi gePvOI"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_9078_100933)"><path d="M7.67729 13.7709C7.87424 13.6448 8.12576 13.6448 8.32271 13.7709L11.5024 15.8071C12.4069 16.3862 13.5548 15.5751 13.3229 14.5207L12.4468 10.536C12.4001 10.3239 12.4696 10.1029 12.6288 9.95656L15.6057 7.22043C16.3797 6.50905 15.9452 5.2097 14.9018 5.11579L11.0727 4.77112C10.8474 4.75084 10.6525 4.60498 10.568 4.39352L9.11647 0.760001C8.71166 -0.253334 7.28834 -0.253333 6.88353 0.760002L5.43201 4.39352C5.34754 4.60498 5.15257 4.75084 4.92731 4.77112L1.09818 5.11579C0.0548482 5.2097 -0.379731 6.50905 0.39426 7.22043L3.3712 9.95656C3.53044 10.1029 3.59987 10.3239 3.55325 10.536L2.67708 14.5207C2.44524 15.5751 3.59315 16.3862 4.49756 15.8071L7.67729 13.7709Z"></path>
                          </g>
                          <defs>
                            <clipPath id="clip0_9078_100933"><rect width="16" height="16" fill="white">
                            </rect>
                            </clipPath>
                          </defs>
                        </svg>
                        </div>
                        <div type="informational" size="14" name="star" className="sc-bbSZdi gePvOI">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_9078_100933)">
                              <path d="M7.67729 13.7709C7.87424 13.6448 8.12576 13.6448 8.32271 13.7709L11.5024 15.8071C12.4069 16.3862 13.5548 15.5751 13.3229 14.5207L12.4468 10.536C12.4001 10.3239 12.4696 10.1029 12.6288 9.95656L15.6057 7.22043C16.3797 6.50905 15.9452 5.2097 14.9018 5.11579L11.0727 4.77112C10.8474 4.75084 10.6525 4.60498 10.568 4.39352L9.11647 0.760001C8.71166 -0.253334 7.28834 -0.253333 6.88353 0.760002L5.43201 4.39352C5.34754 4.60498 5.15257 4.75084 4.92731 4.77112L1.09818 5.11579C0.0548482 5.2097 -0.379731 6.50905 0.39426 7.22043L3.3712 9.95656C3.53044 10.1029 3.59987 10.3239 3.55325 10.536L2.67708 14.5207C2.44524 15.5751 3.59315 16.3862 4.49756 15.8071L7.67729 13.7709Z">
                              </path>
                            </g>
                            <defs>
                              <clipPath id="clip0_9078_100933"><rect width="16" height="16" fill="white">
                              </rect>
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div type="informational" size="14" name="star" className="sc-bbSZdi gePvOI">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_9078_100933)">
                              <path d="M7.67729 13.7709C7.87424 13.6448 8.12576 13.6448 8.32271 13.7709L11.5024 15.8071C12.4069 16.3862 13.5548 15.5751 13.3229 14.5207L12.4468 10.536C12.4001 10.3239 12.4696 10.1029 12.6288 9.95656L15.6057 7.22043C16.3797 6.50905 15.9452 5.2097 14.9018 5.11579L11.0727 4.77112C10.8474 4.75084 10.6525 4.60498 10.568 4.39352L9.11647 0.760001C8.71166 -0.253334 7.28834 -0.253333 6.88353 0.760002L5.43201 4.39352C5.34754 4.60498 5.15257 4.75084 4.92731 4.77112L1.09818 5.11579C0.0548482 5.2097 -0.379731 6.50905 0.39426 7.22043L3.3712 9.95656C3.53044 10.1029 3.59987 10.3239 3.55325 10.536L2.67708 14.5207C2.44524 15.5751 3.59315 16.3862 4.49756 15.8071L7.67729 13.7709Z">
                              </path>
                            </g>
                            <defs>
                              <clipPath id="clip0_9078_100933">
                                <rect width="16" height="16" fill="white">
                                </rect>
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div type="informational" size="14" name="star" className="sc-bbSZdi gePvOI">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_9078_100933)">
                              <path d="M7.67729 13.7709C7.87424 13.6448 8.12576 13.6448 8.32271 13.7709L11.5024 15.8071C12.4069 16.3862 13.5548 15.5751 13.3229 14.5207L12.4468 10.536C12.4001 10.3239 12.4696 10.1029 12.6288 9.95656L15.6057 7.22043C16.3797 6.50905 15.9452 5.2097 14.9018 5.11579L11.0727 4.77112C10.8474 4.75084 10.6525 4.60498 10.568 4.39352L9.11647 0.760001C8.71166 -0.253334 7.28834 -0.253333 6.88353 0.760002L5.43201 4.39352C5.34754 4.60498 5.15257 4.75084 4.92731 4.77112L1.09818 5.11579C0.0548482 5.2097 -0.379731 6.50905 0.39426 7.22043L3.3712 9.95656C3.53044 10.1029 3.59987 10.3239 3.55325 10.536L2.67708 14.5207C2.44524 15.5751 3.59315 16.3862 4.49756 15.8071L7.67729 13.7709Z">
                              </path>
                            </g>
                            <defs>
                              <clipPath id="clip0_9078_100933"><rect width="16" height="16" fill="white">
                              </rect>
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </div>
                    </div>
                      <p type="medium-text" color="text-main" className="sc-iGgWBj eHtHFU">“I’m using the gummies, and I love them!! I’ve tried several home weight loss programs, but none was able to allow me to lose enough weight like I did now.”</p>
                    </div>
                  </div> */}
                </div>
                <div data-index="1" className="slick-slide" tabIndex="-1" aria-hidden="true" style={{ outline: "none", width: 300 }}>
                  <img src={`${process.env.PUBLIC_URL}../assets/images/review-image-2.png`} style={{ width: 300 }} />
                  {/* <div>
                    <div className="_wrapper_fqbso_1">
                  <div className="_author_fqbso_9">
                    <div className="_photo_fqbso_20">
                      <div className="lazyload-wrapper ">
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAZlBMVEUAAAD/yqf/yqj/y6f/z6v/yqf/x6f/z6f/yqf/yqj/yqb/zKb/yqj/yqf/y6j/y6b/yqb/yaf/yqj/yqf/////0rP/8un/3sj//Pr/6Nn/2L7/zaz/+fT/697/5dP/4c7/9e//7+RSWIzDAAAAE3RSTlMAgO9gEN8gIL/PkFCvn4/Pz6CfL4q5oQAAAbRJREFUSMedlduWgyAMRRVkqrXtXILFe+v//+QQ0aAr1mLPQwVyNkm0CyKuRN4uSgCASm/yFL1REqewUobMjl0A1/UlMtm54k37VwYvpTaSSAE7EjkrB94oZv5DRA4Bkot+RQggfOcKgpSxBgLb+IJQiWQErhCs2CcorBpwYpN1CjmuaqsKnBqc3KdJbcf9KsU3AeW0q1kCHY1RKVWkUbVbHZZA6QMorMgDdzZ22XS1AM5kKqeajB0ScNd6wGI9kBJQaW0mT7XMVli89oCigLEuN3z2M2DsBBD3APid7NbN6DEEtFo/xjfbbAE9RuFpR7gnLQOUGOBA3aCtwJ/OAfhs7QN5AoQHAGvC1glo7dMYU2F0o2l4aN23ugQkEai1VzUDlwXQlNru2REwLICSfziDNWNyB7jFwaB6XGZ/DeNqaGEGjHtHKPz0E5B4wAU6Ap5IO2HbjQOilAAXKGagoFYxtfsUGTsCAs6mRBwATtGxFH/oP5LidPggm/QT5lefH8aRDAHy4xfK51cWKt+/FOXGtat2rhLqN6gsQeWwJL+b9sQ7OCKztT3lds6cU4U7q8tZMvc/qtmIAwL5iAkAAAAASUVORK5CYII=" alt="photo" className="sc-kpDqfm gzDPPi" />
                      </div>
                    </div>
                    <p type="caption" color="text-main" className="sc-iGgWBj fMvoXk">Maria</p>
                    <div className="_mark_fqbso_26">
                      <div type="informational" size="14" name="star" className="sc-bbSZdi gePvOI">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_9078_100933)">
                            <path d="M7.67729 13.7709C7.87424 13.6448 8.12576 13.6448 8.32271 13.7709L11.5024 15.8071C12.4069 16.3862 13.5548 15.5751 13.3229 14.5207L12.4468 10.536C12.4001 10.3239 12.4696 10.1029 12.6288 9.95656L15.6057 7.22043C16.3797 6.50905 15.9452 5.2097 14.9018 5.11579L11.0727 4.77112C10.8474 4.75084 10.6525 4.60498 10.568 4.39352L9.11647 0.760001C8.71166 -0.253334 7.28834 -0.253333 6.88353 0.760002L5.43201 4.39352C5.34754 4.60498 5.15257 4.75084 4.92731 4.77112L1.09818 5.11579C0.0548482 5.2097 -0.379731 6.50905 0.39426 7.22043L3.3712 9.95656C3.53044 10.1029 3.59987 10.3239 3.55325 10.536L2.67708 14.5207C2.44524 15.5751 3.59315 16.3862 4.49756 15.8071L7.67729 13.7709Z">
                            </path>
                          </g>
                          <defs>
                            <clipPath id="clip0_9078_100933">
                              <rect width="16" height="16" fill="white">
                              </rect>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div type="informational" size="14" name="star" className="sc-bbSZdi gePvOI">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_9078_100933)">
                            <path d="M7.67729 13.7709C7.87424 13.6448 8.12576 13.6448 8.32271 13.7709L11.5024 15.8071C12.4069 16.3862 13.5548 15.5751 13.3229 14.5207L12.4468 10.536C12.4001 10.3239 12.4696 10.1029 12.6288 9.95656L15.6057 7.22043C16.3797 6.50905 15.9452 5.2097 14.9018 5.11579L11.0727 4.77112C10.8474 4.75084 10.6525 4.60498 10.568 4.39352L9.11647 0.760001C8.71166 -0.253334 7.28834 -0.253333 6.88353 0.760002L5.43201 4.39352C5.34754 4.60498 5.15257 4.75084 4.92731 4.77112L1.09818 5.11579C0.0548482 5.2097 -0.379731 6.50905 0.39426 7.22043L3.3712 9.95656C3.53044 10.1029 3.59987 10.3239 3.55325 10.536L2.67708 14.5207C2.44524 15.5751 3.59315 16.3862 4.49756 15.8071L7.67729 13.7709Z">
                            </path>
                          </g>
                          <defs>
                            <clipPath id="clip0_9078_100933">
                              <rect width="16" height="16" fill="white">
                              </rect>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div type="informational" size="14" name="star" className="sc-bbSZdi gePvOI">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_9078_100933)">
                            <path d="M7.67729 13.7709C7.87424 13.6448 8.12576 13.6448 8.32271 13.7709L11.5024 15.8071C12.4069 16.3862 13.5548 15.5751 13.3229 14.5207L12.4468 10.536C12.4001 10.3239 12.4696 10.1029 12.6288 9.95656L15.6057 7.22043C16.3797 6.50905 15.9452 5.2097 14.9018 5.11579L11.0727 4.77112C10.8474 4.75084 10.6525 4.60498 10.568 4.39352L9.11647 0.760001C8.71166 -0.253334 7.28834 -0.253333 6.88353 0.760002L5.43201 4.39352C5.34754 4.60498 5.15257 4.75084 4.92731 4.77112L1.09818 5.11579C0.0548482 5.2097 -0.379731 6.50905 0.39426 7.22043L3.3712 9.95656C3.53044 10.1029 3.59987 10.3239 3.55325 10.536L2.67708 14.5207C2.44524 15.5751 3.59315 16.3862 4.49756 15.8071L7.67729 13.7709Z">
                            </path>
                          </g>
                          <defs>
                            <clipPath id="clip0_9078_100933">
                              <rect width="16" height="16" fill="white"></rect></clipPath></defs></svg></div><div type="informational" size="14" name="star" className="sc-bbSZdi gePvOI"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_9078_100933)"><path d="M7.67729 13.7709C7.87424 13.6448 8.12576 13.6448 8.32271 13.7709L11.5024 15.8071C12.4069 16.3862 13.5548 15.5751 13.3229 14.5207L12.4468 10.536C12.4001 10.3239 12.4696 10.1029 12.6288 9.95656L15.6057 7.22043C16.3797 6.50905 15.9452 5.2097 14.9018 5.11579L11.0727 4.77112C10.8474 4.75084 10.6525 4.60498 10.568 4.39352L9.11647 0.760001C8.71166 -0.253334 7.28834 -0.253333 6.88353 0.760002L5.43201 4.39352C5.34754 4.60498 5.15257 4.75084 4.92731 4.77112L1.09818 5.11579C0.0548482 5.2097 -0.379731 6.50905 0.39426 7.22043L3.3712 9.95656C3.53044 10.1029 3.59987 10.3239 3.55325 10.536L2.67708 14.5207C2.44524 15.5751 3.59315 16.3862 4.49756 15.8071L7.67729 13.7709Z"></path></g><defs><clipPath id="clip0_9078_100933">
                                <rect width="16" height="16" fill="white"></rect></clipPath></defs></svg></div><div type="informational" size="14" name="star" className="sc-bbSZdi gePvOI"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_9078_100933)"><path d="M7.67729 13.7709C7.87424 13.6448 8.12576 13.6448 8.32271 13.7709L11.5024 15.8071C12.4069 16.3862 13.5548 15.5751 13.3229 14.5207L12.4468 10.536C12.4001 10.3239 12.4696 10.1029 12.6288 9.95656L15.6057 7.22043C16.3797 6.50905 15.9452 5.2097 14.9018 5.11579L11.0727 4.77112C10.8474 4.75084 10.6525 4.60498 10.568 4.39352L9.11647 0.760001C8.71166 -0.253334 7.28834 -0.253333 6.88353 0.760002L5.43201 4.39352C5.34754 4.60498 5.15257 4.75084 4.92731 4.77112L1.09818 5.11579C0.0548482 5.2097 -0.379731 6.50905 0.39426 7.22043L3.3712 9.95656C3.53044 10.1029 3.59987 10.3239 3.55325 10.536L2.67708 14.5207C2.44524 15.5751 3.59315 16.3862 4.49756 15.8071L7.67729 13.7709Z"></path></g><defs><clipPath id="clip0_9078_100933"><rect width="16" height="16" fill="white"></rect></clipPath>
                                </defs>
                                </svg>
                      </div>
                    </div>
                  </div>
                  <p type="medium-text" color="text-main" className="sc-iGgWBj eHtHFU">“I ACHIEVED MY GOAL!! I am very happy and grateful. With the tasty gummies, I lost 12lbs in my first month. Thank you very much!”</p>
                </div>
                </div> */}
                </div>
                <div data-index="2" className="slick-slide slick-active slick-center slick-current" tabIndex="-1" aria-hidden="false" style={{ outline: "none", width: 300 }}>
                  <img src={`${process.env.PUBLIC_URL}../assets/images/review-image-3.png`} style={{ width: 300 }} />
                  {/* <div>
                    <div className="_wrapper_fqbso_1">
                      <div className="_author_fqbso_9">
                        <div className="_photo_fqbso_20">
                          <div className="lazyload-wrapper ">
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAZlBMVEUAAACw6Lqv6Lqw6Lqw6buw6bqv57+v57ev37qw6bqw6Lqw57mw6buw6bqv5rmv77+v5rmv57mv6byw6Lr////E7su668Pc9eG16b/6/vvN8dTw+/Pr+e71/Pfj9+fV89rJ79C/7ceRKCN8AAAAE3RSTlMAgGDf7+8gIBDPv5Cvn1AQsKBQo4HWTwAAAa1JREFUSMeVleuWgjAMhEtbBIqX3U3lpoi8/0tumlOO1IC284NUmY90jKcIplLWR6UBQJlaHsQXlZmBQFXAcLsGrtMu4u1c2ab9UMGu1EYTqeGD8jPbDnxRxvxJxBkiJFd5dQyQv5IriFLFAkTGOECs8pKAE0QrCxp0TdPQYlU7+jZsIcFrsrYnn7WWPFgnuOL1GrSo/JpuzVifWAesM1lDwKwjd974wNpiHbB2bwCUtCOvmzNSsSPW1tobvANS1MuSHHdqRI+GO/IMqIV5fRgo9ZWAJ0CPVwb8LH+L18+DfTBFS5lnBigBK/Uu9R0pt7en68eAPADoyS7qiCEoEQMgACb0oOEBLZqw07QF5LCIbvaTizqguScjBzB0MLrRBe+o2g42Qh8BgtHRtGD0CwYYN7hgdBhhveCDk2tgoJkti2EDkOICEI7ONj6NnTeAQggTjo52TiF64EDFjoCIs+mSJwCFSGtxEiKtRZF8kHlVcX4lFhVRm9K4oUUyBjinvlDSX1mh/j7m0FIwFWrfXy1547alM7Gj4nfTXop9FfJtiIbbOVMbF0erYy25+x86GIgkE2jbFwAAAABJRU5ErkJggg==" alt="photo" className="sc-kpDqfm gzDPPi" />
                          </div>
                        </div>
                        <p type="caption" color="text-main" className="sc-iGgWBj fMvoXk">William</p>
                        <div className="_mark_fqbso_26">
                          <div type="informational" size="14" name="star" className="sc-bbSZdi gePvOI">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clipPath="url(#clip0_9078_100933)">
                                <path d="M7.67729 13.7709C7.87424 13.6448 8.12576 13.6448 8.32271 13.7709L11.5024 15.8071C12.4069 16.3862 13.5548 15.5751 13.3229 14.5207L12.4468 10.536C12.4001 10.3239 12.4696 10.1029 12.6288 9.95656L15.6057 7.22043C16.3797 6.50905 15.9452 5.2097 14.9018 5.11579L11.0727 4.77112C10.8474 4.75084 10.6525 4.60498 10.568 4.39352L9.11647 0.760001C8.71166 -0.253334 7.28834 -0.253333 6.88353 0.760002L5.43201 4.39352C5.34754 4.60498 5.15257 4.75084 4.92731 4.77112L1.09818 5.11579C0.0548482 5.2097 -0.379731 6.50905 0.39426 7.22043L3.3712 9.95656C3.53044 10.1029 3.59987 10.3239 3.55325 10.536L2.67708 14.5207C2.44524 15.5751 3.59315 16.3862 4.49756 15.8071L7.67729 13.7709Z"></path>
                              </g>
                              <defs>
                                <clipPath id="clip0_9078_100933">
                                  <rect width="16" height="16" fill="white"></rect>
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div type="informational" size="14" name="star" className="sc-bbSZdi gePvOI">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clipPath="url(#clip0_9078_100933)">
                                <path d="M7.67729 13.7709C7.87424 13.6448 8.12576 13.6448 8.32271 13.7709L11.5024 15.8071C12.4069 16.3862 13.5548 15.5751 13.3229 14.5207L12.4468 10.536C12.4001 10.3239 12.4696 10.1029 12.6288 9.95656L15.6057 7.22043C16.3797 6.50905 15.9452 5.2097 14.9018 5.11579L11.0727 4.77112C10.8474 4.75084 10.6525 4.60498 10.568 4.39352L9.11647 0.760001C8.71166 -0.253334 7.28834 -0.253333 6.88353 0.760002L5.43201 4.39352C5.34754 4.60498 5.15257 4.75084 4.92731 4.77112L1.09818 5.11579C0.0548482 5.2097 -0.379731 6.50905 0.39426 7.22043L3.3712 9.95656C3.53044 10.1029 3.59987 10.3239 3.55325 10.536L2.67708 14.5207C2.44524 15.5751 3.59315 16.3862 4.49756 15.8071L7.67729 13.7709Z"></path>
                              </g>
                              <defs>
                                <clipPath id="clip0_9078_100933">
                                  <rect width="16" height="16" fill="white"></rect>
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div type="informational" size="14" name="star" className="sc-bbSZdi gePvOI">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_9078_100933)"><path d="M7.67729 13.7709C7.87424 13.6448 8.12576 13.6448 8.32271 13.7709L11.5024 15.8071C12.4069 16.3862 13.5548 15.5751 13.3229 14.5207L12.4468 10.536C12.4001 10.3239 12.4696 10.1029 12.6288 9.95656L15.6057 7.22043C16.3797 6.50905 15.9452 5.2097 14.9018 5.11579L11.0727 4.77112C10.8474 4.75084 10.6525 4.60498 10.568 4.39352L9.11647 0.760001C8.71166 -0.253334 7.28834 -0.253333 6.88353 0.760002L5.43201 4.39352C5.34754 4.60498 5.15257 4.75084 4.92731 4.77112L1.09818 5.11579C0.0548482 5.2097 -0.379731 6.50905 0.39426 7.22043L3.3712 9.95656C3.53044 10.1029 3.59987 10.3239 3.55325 10.536L2.67708 14.5207C2.44524 15.5751 3.59315 16.3862 4.49756 15.8071L7.67729 13.7709Z"></path></g><defs><clipPath id="clip0_9078_100933"><rect width="16" height="16" fill="white"></rect></clipPath></defs></svg></div><div type="informational" size="14" name="star" className="sc-bbSZdi gePvOI">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_9078_100933)"><path d="M7.67729 13.7709C7.87424 13.6448 8.12576 13.6448 8.32271 13.7709L11.5024 15.8071C12.4069 16.3862 13.5548 15.5751 13.3229 14.5207L12.4468 10.536C12.4001 10.3239 12.4696 10.1029 12.6288 9.95656L15.6057 7.22043C16.3797 6.50905 15.9452 5.2097 14.9018 5.11579L11.0727 4.77112C10.8474 4.75084 10.6525 4.60498 10.568 4.39352L9.11647 0.760001C8.71166 -0.253334 7.28834 -0.253333 6.88353 0.760002L5.43201 4.39352C5.34754 4.60498 5.15257 4.75084 4.92731 4.77112L1.09818 5.11579C0.0548482 5.2097 -0.379731 6.50905 0.39426 7.22043L3.3712 9.95656C3.53044 10.1029 3.59987 10.3239 3.55325 10.536L2.67708 14.5207C2.44524 15.5751 3.59315 16.3862 4.49756 15.8071L7.67729 13.7709Z"></path></g><defs><clipPath id="clip0_9078_100933"><rect width="16" height="16" fill="white"></rect></clipPath></defs></svg></div><div type="informational" size="14" name="star" className="sc-bbSZdi gePvOI">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_9078_100933)"><path d="M7.67729 13.7709C7.87424 13.6448 8.12576 13.6448 8.32271 13.7709L11.5024 15.8071C12.4069 16.3862 13.5548 15.5751 13.3229 14.5207L12.4468 10.536C12.4001 10.3239 12.4696 10.1029 12.6288 9.95656L15.6057 7.22043C16.3797 6.50905 15.9452 5.2097 14.9018 5.11579L11.0727 4.77112C10.8474 4.75084 10.6525 4.60498 10.568 4.39352L9.11647 0.760001C8.71166 -0.253334 7.28834 -0.253333 6.88353 0.760002L5.43201 4.39352C5.34754 4.60498 5.15257 4.75084 4.92731 4.77112L1.09818 5.11579C0.0548482 5.2097 -0.379731 6.50905 0.39426 7.22043L3.3712 9.95656C3.53044 10.1029 3.59987 10.3239 3.55325 10.536L2.67708 14.5207C2.44524 15.5751 3.59315 16.3862 4.49756 15.8071L7.67729 13.7709Z"></path></g><defs><clipPath id="clip0_9078_100933"><rect width="16" height="16" fill="white"></rect></clipPath></defs></svg></div>
                        </div>
                      </div>
                      <p type="medium-text" color="text-main" className="sc-iGgWBj eHtHFU">“I lost over 30 pounds in the 3 months by following the supplement protocol you guys formulated for me. I wish I did this when I first ran into your ad”</p>
                      </div>
                      </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Email Capture
function Email() {
  const navigate = useNavigate();
  const location = useLocation();
  const { quizData } = useQuiz(); // Assuming you have a context or state hook that stores the quiz data
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleNext = async () => {
    setIsLoading(true);

    try {
      const response = await axios.post('https://us-central1-weight-loss-quiz.cloudfunctions.net/api/subscribe', {
        email,
        tags: ['Weight Loss Quiz'],
        quizData // Include the quiz data
      });

      if (response.data.success) {
        navigate(`/step/21${location.search}`, { state: { email } });
      } else {
        console.error('Error with subscription: ', response.data.message);
      }
    } catch (error) {
      console.error('Error with subscription: ', error);
    }

    setIsLoading(false);
  };

  return (
    <div>
      <form action="#" onSubmit={(e) => { e.preventDefault(); handleNext(); }}>
        <div className="sc-aXZVg jhnkTu _container_1mft2_1">
          <p type="h5" color="text-main" className="sc-iGgWBj dFJukc">
            Enter your email to get your personal <span className="_colorBrand_824fg_76">Weight-Loss</span> plan!
          </p>
          <div className="_inputContainer_1mft2_6">
            <svg
              width="18"
              height="14"
              viewBox="0 0 18 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="_emailIcon_1mft2_29"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.7394 1.14307L17.7172 1.10186C17.9017 1.45286 18 1.80101 18 2.76111V11.2389C18 12.199 17.9017 12.5471 17.7172 12.8981C17.5326 13.2491 17.2618 13.5246 16.9167 13.7123C16.5716 13.9 16.2293 14 15.2853 14H2.7147C1.77074 14 1.42844 13.9 1.08334 13.7123C0.738242 13.5246 0.467407 13.2491 0.282846 12.8981C0.0982859 12.5471 0 12.199 0 11.2389L0 2.76111C0 1.83941 0.0905803 1.48169 0.261114 1.144C0.282572 1.26125 0.342515 1.37189 0.438969 1.45495L8.52106 8.415C8.79747 8.65304 9.20253 8.65304 9.47893 8.41501L17.561 1.45495C17.5722 1.44534 17.583 1.43527 17.5933 1.42476C17.6718 1.34493 17.7205 1.24627 17.7394 1.14307ZM15.2853 0C16.0604 0 16.4299 0.0674065 16.7283 0.195455L16.6574 0.22265L16.5749 0.273184L9.4383 5.59616C9.17741 5.79075 8.82258 5.79075 8.56169 5.59616L1.42509 0.273184C1.37749 0.23768 1.32574 0.211355 1.27202 0.19404C1.57012 0.0674065 1.93956 0 2.7147 0L15.2853 0Z"
                fill="#8696A6"
              ></path>
            </svg>
            <input
              name="email"
              data-locator="emailInput"
              id="email_field"
              type="email"
              maxLength="60"
              placeholder="Your email"
              className="_input_1mft2_6"
              onChange={(e) => setEmail(e.target.value)}
            />
            <input type="hidden" name="tags" value="Weight Loss Quiz" />
            <div className="_inputIcon_1mft2_88">
              <span className="_errorIco_1mft2_61">!</span>
            </div>
            <div className="_inputIcon_1mft2_88">
              <span className="_successIco_1mft2_76">
                <svg
                  width="12"
                  height="13"
                  viewBox="0 0 12 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.73657 6.33935C2.38372 6.00143 1.81164 6.00143 1.4588 6.33935C1.10595 6.67727 1.10595 7.22514 1.4588 7.56306L4.50708 10.4824L10.4828 4.7595C10.8356 4.42158 10.8356 3.87371 10.4828 3.53579C10.13 3.19788 9.55787 3.19788 9.20503 3.53579L4.50708 8.03494L2.73657 6.33935Z"
                    fill="#49C95F"
                  ></path>
                </svg>
              </span>
            </div>
          </div>
          {error && (
            <div className="_errorWrapper_1mft2_94">
              <p type="caption" color="text-main" className="sc-iGgWBj jXxstt">
                {error}
              </p>
            </div>
          )}
          <div className="_disclaimerContainer_1mft2_101">
            <div className="_lockIco_1mft2_107">
              <div className="lazyload-wrapper ">
                <img
                  src="data:image/webp;base64,UklGRlABAABXRUJQVlA4WAoAAAAQAAAAKwAALwAAQUxQSM0AAAABgBUAaFwHCZGAhEpAQiXgYBJaCZGAhOcgEioBCUhgB7nY9RsREwDzVB9zt1YJtr+pDyrvwccnFTeQ+bTRssOXHotQO/YSadYxXCMeGhf4yhp4W4IePghdfAKnFRIowiBqUFdowDBMgS04/KvCpH1xnKPgNSPBOceBrOG/XCFmZgkaT7ZAmJnpC5sn1RPIE1PL1Px/qJqnFgCUJDeEdwqFrmWQnqSqGbSnGfyKLs95IUCpnvUGuP1PVVMZn5rnb2uZrGaSonkUAUVz2F0AAFZQOCBcAAAAcAMAnQEqLAAwAD6ROpdIJaMiIS4oALASCWUAyFwoD0rNQIJAAP7vOH/++13TyFZY43hdlYVZOtU/9AnN//vnGokmr4vYFg9OfkwscBCRniIEzSZOtGkOUNiAAAA="
                  alt="lockIco"
                  className="sc-kpDqfm kjlNE"
                />
              </div>
            </div>
            <p
              type="caption"
              color="text-secondary-subdued"
              className="sc-iGgWBj huIcJP"
            >
              We respect your privacy. Your email can make the advertising
              experience more relevant.{" "}
              <a
                href="https://leanformula.co/privacy-policy/"
                className="_underline_824fg_124"
                target="_blank"
                rel="noopener noreferrer"
                data-locator="privacyPolicyLink"
              >
                Privacy Policy
              </a>
              .
            </p>
          </div>
          <button
            id="continueButton"
            className="sc-gsnTZi eRtgxg"
            onClick={handleNext}
            data-locator="obNextStep"
            disabled={isLoading} // Set disabled attribute based on loading state
          >
            {isLoading ? 'SUBMITTING...' : 'Continue'}
          </button>
        </div>
      </form>
    </div>
  );
}

// Old - Results
function Step15() {
  const navigate = useNavigate();
  const location = useLocation();
  const { quizData } = useQuiz();
  const { perfectWeight, weightUnit, email } = { ...quizData, ...location.state };

  // Function to convert kg to lbs
  const convertToPounds = (weightInKg) => {
    return Math.round(weightInKg * 2.20462);
  };

  // Determine the weight to display
  const displayWeight = weightUnit === 'lb' ? convertToPounds(perfectWeight) : perfectWeight;
  const displayUnit = weightUnit === 'lb' ? 'lb' : 'kg';

  const openCTA = () => {
    const targetUrl = `https://leanformula.co/checkout-quarterly?${location.search}&email=${encodeURIComponent(email)}`;
    window.open(targetUrl, '_self');
  };

  // Timer state and logic
  const [timeLeft, setTimeLeft] = useState(10 * 60); // 10 minutes in seconds

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);

      return () => clearTimeout(timerId); // Clear the timer if the component is unmounted
    }
  }, [timeLeft]);

  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
  const seconds = String(timeLeft % 60).padStart(2, '0');

  useEffect(() => {
    // This will trigger the Lead conversion event when the Step15 component is mounted
    ReactPixel.track('Lead');
  }, []);  // Empty dependency array ensures this effect runs only once when the component mounts

  // Prefetch the external page
  useEffect(() => {
    const prefetchLink = document.createElement('link');
    prefetchLink.rel = 'prefetch';
    prefetchLink.href = 'https://leanformula.co/checkout-quarterly';
    prefetchLink.as = 'document';
    document.head.appendChild(prefetchLink);

    return () => {
      document.head.removeChild(prefetchLink);
    };
  }, []);

  return (
    <div>
      <div className="_rootTopBanner_1arkq_1">
        <div className="_contentContainer_1arkq_15">
          <div className="_logoWrapper_1arkq_80">
            <div className="_logo_fkrec_1">
              <img
                src={"https://leanformula.co/wp-content/uploads/2024/07/leanformula-logo-purple-dark.svg"}
                alt="logo"
                className="logo__img"
                width="150px"
              />
            </div>
          </div>
          <button onClick={openCTA} className="sc-gEvEer gyUCBj _button_1arkq_84">
            <p type="small-button" color="on-primary" className="sc-iGgWBj UsumM">get my plan</p>
          </button>
        </div>
      </div>
      <div className="_container_1u1wn_1">
        <div>
          <p type="h3" color="text-main" className="sc-iGgWBj hFvwKz">Your Personal Weight Loss Plan is Ready!</p>
          <div className="_userInfo_mf72k_1">
            <div className="_userInfoItem_mf72k_8">
              <p type="caption" color="text-secondary" className="sc-iGgWBj gWSVqW">Target weight</p>
              <div className="_userInfoData_mf72k_26">
                <div className="lazyload-wrapper ">
                  <img src="data:image/webp;base64,UklGRuQBAABXRUJQVlA4WAoAAAAQAAAALwAALwAAQUxQSLgAAAABgFZtb91GEAxBEAIhEMLAUCQIZhAzCIRCMARDMISv3XyRsvt+RcQE0C/2lirMy8kGAmdZErjLAuOG21xeKDmppqsspLky0a490DAceabOYdg00CLnEUweTIb8cFAyVjMl82TFa/uAreKSnINo1XhBEHvcrFDDlADcCRVmuGYEqNS94AAZCYCzI3DB0RMAiO8OOLX4TvCeiWhvXq7/G+odyly6wzm33YHnSP2UVtVLaZ1zsatpox87VlA4IAYBAADQBgCdASowADAAPpFAmEklo6IhKqlYsBIJbACxH71Rxuf8cGA2wHPK/2b1Abw7vJQFidWX2NPleYWLQzRHY2AA/t6r/++T//e93/++sj7S5iqGeoOkLiuq4wQ3d34rorJ0sSatZmdS7bYT1FnQ/J3+KEst5QjSwk8Eje107793xSXcWIkg/aeuSzl9yfM5+huLvKDg6bcUlODaINX3+4/+O5Zmf7q6ilKbuqRkejOyKul1ysVYIGXbf/lBFc15y/mJK5bM2Is4TenDumB2BL2CSP39BO4av/bUFaVFPgc4uZP9AXjW3M2ZE8b0C+Rxe1x+y2G/J+QebWMHd+QnQfr/P6/QgAAA" alt="weightIcon" className="sc-kpDqfm liyZAe _userInfoIcon_mf72k_30" />
                </div>
                <p type="large-text" color="text-main" className="sc-iGgWBj hIXbnm">{displayWeight}{displayUnit}</p>
              </div>
            </div>
            <div className="_userInfoItem_mf72k_8"><p type="caption" color="text-secondary" className="sc-iGgWBj gWSVqW">Starting level</p>
              <div className="_userInfoData_mf72k_26">
                <div className="lazyload-wrapper ">
                  <img src="data:image/webp;base64,UklGRkYBAABXRUJQVlA4WAoAAAAQAAAALwAALwAAQUxQSG0AAAABN0AQQJLypqM8QRoREbjegE0k221UqT8HALm3GRiCGGjMn8afp1xH9J9gksYdMOgMN/DFg+CT3MCfZAWeJABbMvql+1q6r6X7WrpvMvpn+2q2r2b7arrv0A6m5IMZ+ORBsP2TDuLK6xMOhjkHAFZQOCCyAAAAkAYAnQEqMAAwAD6JMpVHpSKiITx0CACgEQliAMtl0TSumA+SjkwdQDoAP9H7FfoAdKiEQpro0z0Bijp/gAD+/FzSd+uInz73HlDmybuMya+X4JpP2h3arYCPnmjI/bX5EZJqiBDzheBmBPrRWx89VKoZJhWx84xYNwFN5FxXjRY+DYWmebE/dH2F3EoqOBVEd2esCnvrsWpUuruGYwfgH1Fc37iUVHAqi6M/2P4/CpAAAA==" alt="weightIcon" className="sc-kpDqfm liyZAe _userInfoIcon_mf72k_30" />
                </div>
                <p type="large-text" color="text-main" className="sc-iGgWBj hIXbnm">Intermediate</p>
              </div>
            </div>
          </div>
          <div className="_timerContainer_mf72k_34">
            <div className="_root_14go4_1 _withBiggerPadding_14go4_24">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="_icon_14go4_20">
                <g clip-path="url(#clip0_2124_58499)">
                  <path d="M11.988 0C5.364 0 0 5.376 0 12C0 18.624 5.364 24 11.988 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 11.988 0ZM12 21.6C6.696 21.6 2.4 17.304 2.4 12C2.4 6.696 6.696 2.4 12 2.4C17.304 2.4 21.6 6.696 21.6 12C21.6 17.304 17.304 21.6 12 21.6Z" fill="white"></path><path d="M12.5998 6.9C12.5998 6.40294 12.1969 6 11.6998 6C11.2027 6 10.7998 6.40294 10.7998 6.9V9.54098V12.511C10.7998 12.8648 10.9868 13.1923 11.2916 13.3722L16.3821 16.3764C16.781 16.6118 17.2949 16.4853 17.5389 16.0917C17.7914 15.6843 17.6583 15.1489 17.2443 14.9073L12.5998 12.1967V6.9Z" fill="white"></path>
                </g>
                <defs>
                  <clipPath id="clip0_2124_58499">
                    <rect width="24" height="24" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
              <p type="medium-text" color="surface-main" className="sc-iGgWBj oTTWo">Your discount is secured for&nbsp;</p>
              {timeLeft > 0 ? (
                <div className="_timerBox_14go4_12">
                  <p type="medium-text" color="surface-main" className="sc-iGgWBj oTTWo">{`${minutes}:${seconds} min`}</p>
                </div>
              ) : null}
            </div>
          </div>
          <div className="_ratingWrapper_b3vu4_1">
            <div className="lazyload-wrapper ">
              {/* <img src={`${process.env.PUBLIC_URL}../assets/images/premier-keto-gummies.jpeg`} className="bottlesWrapper" /> */}
              <img src={`${process.env.PUBLIC_URL}../assets/images/5-stars.webp`} alt="5 starts amount" className="sc-kpDqfm hVmqZs _ratingImage_b3vu4_6" />
            </div>
            <p type="h1" color="primary-default" className="sc-iGgWBj fYPuyR">5,500+</p>
            <p type="h6" color="text-main" className="sc-iGgWBj bcMEAP">5-star ratings</p>
            <p type="caption" color="text-secondary-subdued" className="sc-iGgWBj jNAvYo">*Customer submitted reviews.</p>
            <button onClick={openCTA} className="sc-gEvEer brDyJQ" data-locator="startPaymentBtn">
              <p type="medium-button" color="on-primary" className="sc-iGgWBj iedPVB">Get my custom plan</p>
            </button>
          </div>
          <div>
            <p type="h4" color="text-main" className="sc-iGgWBj gXqlvo">What you get</p>
            <p type="large-text" color="text-main" className="sc-iGgWBj gLQPYe">According to your goals and personal data, our AI algorithm suggested a personalized weight loss plan that will enable you to achieve your weight goal.</p>
            <p type="large-text" color="text-main" className="sc-iGgWBj bvnrcB">To achieve your goal you get:</p>
            <ul className="_list_x5yh5_1">
              <li className="_item_x5yh5_5 _newTextStyle_x5yh5_15">A <b>50% off discount</b> for your order ONLY found on this page<svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.2975 10.2925C16.9072 9.89941 16.2717 9.89829 15.88 10.29L10 16.17L7.11549 13.2935C6.7257 12.9048 6.09474 12.9053 5.70549 13.2945V13.2945C5.31586 13.6841 5.31586 14.3159 5.70549 14.7055L9.29289 18.2929C9.68342 18.6834 10.3166 18.6834 10.7071 18.2929L17.295 11.705C17.6848 11.3152 17.6859 10.6836 17.2975 10.2925V10.2925ZM12 4C6.48 4 2 8.48 2 14C2 19.52 6.48 24 12 24C17.52 24 22 19.52 22 14C22 8.48 17.52 4 12 4ZM12 22C7.58 22 4 18.42 4 14C4 9.58 7.58 6 12 6C16.42 6 20 9.58 20 14C20 18.42 16.42 22 12 22Z" fill="#8696A6"></path></svg>
              </li>
              <li className="_item_x5yh5_5 _newTextStyle_x5yh5_15">30 Day <b>money-back guarantee</b> eliminating all risk of trying your customized plan<svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.2975 10.2925C16.9072 9.89941 16.2717 9.89829 15.88 10.29L10 16.17L7.11549 13.2935C6.7257 12.9048 6.09474 12.9053 5.70549 13.2945V13.2945C5.31586 13.6841 5.31586 14.3159 5.70549 14.7055L9.29289 18.2929C9.68342 18.6834 10.3166 18.6834 10.7071 18.2929L17.295 11.705C17.6848 11.3152 17.6859 10.6836 17.2975 10.2925V10.2925ZM12 4C6.48 4 2 8.48 2 14C2 19.52 6.48 24 12 24C17.52 24 22 19.52 22 14C22 8.48 17.52 4 12 4ZM12 22C7.58 22 4 18.42 4 14C4 9.58 7.58 6 12 6C16.42 6 20 9.58 20 14C20 18.42 16.42 22 12 22Z" fill="#8696A6"></path></svg>
              </li>
              <li className="_item_x5yh5_5 _newTextStyle_x5yh5_15">Free <b>coach support</b> during your weight loss journey<svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.2975 10.2925C16.9072 9.89941 16.2717 9.89829 15.88 10.29L10 16.17L7.11549 13.2935C6.7257 12.9048 6.09474 12.9053 5.70549 13.2945V13.2945C5.31586 13.6841 5.31586 14.3159 5.70549 14.7055L9.29289 18.2929C9.68342 18.6834 10.3166 18.6834 10.7071 18.2929L17.295 11.705C17.6848 11.3152 17.6859 10.6836 17.2975 10.2925V10.2925ZM12 4C6.48 4 2 8.48 2 14C2 19.52 6.48 24 12 24C17.52 24 22 19.52 22 14C22 8.48 17.52 4 12 4ZM12 22C7.58 22 4 18.42 4 14C4 9.58 7.58 6 12 6C16.42 6 20 9.58 20 14C20 18.42 16.42 22 12 22Z" fill="#8696A6"></path></svg></li>
            </ul>
            <p type="large-text" color="text-main" className="sc-iGgWBj hCLVRs">With hundreds of real customer submitted weight loss results!</p>
            <div className="lazyload-wrapper ">
              <img src={`${process.env.PUBLIC_URL}../assets/images/before-after-collage.jpeg`} alt="results image" className="resultsImg" />
            </div>
          </div>
          <div>
            <p type="h4" color="text-main" className="sc-iGgWBj bdhtoB">Hear success stories from Premier users</p>
            <ul className="_wrapper_1smw0_1">
              <li className="_commentListItem_1smw0_39">
                <div className="_commentTextBox_1smw0_21">
                  <p type="large-text" color="text-main" className="sc-iGgWBj lcIcsa">"I've been hearing about leanformula for a while now. My sister signed up and had some amazing success. I thought, if I could just lose
                    a few pounds I would feel better about myself. I was shocked to
                    say the least when I lost 20lbs in 30 days. Now I tell everyone
                    :)"</p>
                </div>
                <div className="_commentFooter_1smw0_5">
                  <div className="_rateBox_1smw0_11">
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#FEE14B"></path></svg>
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#FEE14B"></path></svg>
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#FEE14B"></path></svg>
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#FEE14B"></path></svg>
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#FEE14B"></path></svg>
                  </div>
                  <p type="large-text" color="text-main" className="sc-iGgWBj lcIcsa">Isabella N.</p>
                </div>
              </li>
              <li className="_commentListItem_1smw0_39">
                <div className="_commentTextBox_1smw0_21">
                  <p type="large-text" color="text-main" className="sc-iGgWBj lcIcsa">"Leanformula is by far the best weight loss service I've used. It
                    works and it works well. I am the leanest I have ever been in my
                    life. I had my body fat tested before and after and I went from
                    a whopping 26% body fat down to 16% in 4 months. I owe a big
                    thanks to them."</p>
                </div>
                <div className="_commentFooter_1smw0_5">
                  <div className="_rateBox_1smw0_11">
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#FEE14B"></path></svg>
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#FEE14B"></path></svg>
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#FEE14B"></path></svg>
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#FEE14B"></path></svg>
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#FEE14B"></path></svg>
                  </div>
                  <p type="large-text" color="text-main" className="sc-iGgWBj lcIcsa">Darin K.</p></div>
              </li>
              <li className="_commentListItem_1smw0_39">
                <div className="_commentTextBox_1smw0_21">
                  <p type="large-text" color="text-main" className="sc-iGgWBj lcIcsa">"After watching video after video of weight loss success stories, I felt hopeful that I
                    could actually start losing weight without anything too extreme. When I
                    found this custom plan online and thought I'd give it a shot. I started
                    losing weight, I though maybe it was a fluke at first. After my first 10 pounds, I
                    cried. If you need something to work like me, you won't be let down"</p>
                </div>
                <div className="_commentFooter_1smw0_5">
                  <div className="_rateBox_1smw0_11">
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#FEE14B"></path></svg>
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#FEE14B"></path></svg>
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#FEE14B"></path></svg>
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#FEE14B"></path></svg>
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#FEE14B"></path></svg>
                  </div>
                  <p type="large-text" color="text-main" className="sc-iGgWBj lcIcsa">Ashley R.</p>
                </div>
              </li>
            </ul>
            <p type="h4" color="text-main" className="sc-iGgWBj gXqlvo">Our users meet their goals!</p>
          </div>
        </div>
        <button onClick={openCTA} className="sc-gEvEer brDyJQ" data-locator="startPaymentBtn"><p type="medium-button" color="on-primary" className="sc-iGgWBj iedPVB">Get my custom plan</p></button>
        <p type="caption" color="text-secondary-subdued" className="sc-iGgWBj btcOML">The displayed results are not representative and depend on various factors such as gender, age, physical condition, adherence to meal and workout plan, etc. This is not an offer or promise of results. Consult your physician to receive any particular recommendations on your specific health conditions.</p>
      </div>
    </div>
  );
}

// Step 16 New Results Component - Results
function Results() {
  const navigate = useNavigate();
  const location = useLocation();
  const { quizData } = useQuiz();
  const { weightInKg, perfectWeight, weightUnit, gender, age, email } = { ...quizData, ...location.state };
  const [activeQuestion, setActiveQuestion] = useState(null);
  const [playingVideos, setPlayingVideos] = useState({});
  const [selectedPlan, setSelectedPlan] = useState('annual'); // Default plan

  // Convert current and perfect weights to the selected unit
  const currentWeight = weightUnit === 'lb' ? Math.round(weightInKg * 2.20462) : weightInKg;
  const perfectWeightInUnit = weightUnit === 'lb' ? Math.round(perfectWeight * 2.20462) : perfectWeight;

  // Calculate weight to lose
  const weightToLose = Math.abs(currentWeight - perfectWeightInUnit);

  const openCTA = () => {
    // Retrieve the sub2 from localStorage or fallback to location search
    const sub2 = localStorage.getItem('sub2') || getQueryParam('sub2');  // Get 'sub2' from either storage or the query
  
    // Append sub2 to the checkout URL along with other query params like email
    const targetUrl = selectedPlan === 'annual'
      ? `https://leanformula.co/checkout-annual?sub2=${sub2}&email=${encodeURIComponent(email)}`
      : `https://leanformula.co/checkout-quarterly?sub2=${sub2}&email=${encodeURIComponent(email)}`;
  
    // Navigate to the checkout page with the modified URL
    window.open(targetUrl, '_self');
  };
  
  // Helper function to get query params
  const getQueryParam = (param) => {
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get(param);
  };

  // Timer state and logic
  const [timeLeft, setTimeLeft] = useState(10 * 60); // 10 minutes in seconds

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);

      return () => clearTimeout(timerId); // Clear the timer if the component is unmounted
    }
  }, [timeLeft]);

  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
  const seconds = String(timeLeft % 60).padStart(2, '0');

  useEffect(() => {

          // This will trigger the Lead conversion event when the Step15 component is mounted
    ReactPixel.track('Lead');
      const sub2 = localStorage.getItem('sub2') || getQueryParam('sub2'); // Get 'sub2' from either storage or the query
  
      if (sub2) {
          // Send postback to proxy server
          fetch(`https://us-central1-weight-loss-quiz.cloudfunctions.net/api/postback?cid=${sub2}&et=partial`, {
              method: 'GET'
          })
          .then(response => response.json())
          .then(data => {
              if (data.success) {
                  console.log('Voluum partial lead postback successfully fired.');
              } else {
                  console.error('Failed to fire partial lead postback:', data.message);
              }
          })
          .catch(error => {
              console.error('Error firing partial lead postback:', error);
          });
      } else {
          console.error('sub2 is missing, unable to fire Voluum postback.');
      }
  }, []);

  // Prefetch the external page
  useEffect(() => {
    const prefetchLink = document.createElement('link');
    prefetchLink.rel = 'prefetch';
    prefetchLink.href = 'https://leanformula.co/checkout-quarterly';
    prefetchLink.as = 'document';
    document.head.appendChild(prefetchLink);

    return () => {
      document.head.removeChild(prefetchLink);
    };
  }, []);

  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan);
  };

  const toggleQuestion = (index) => {
    setActiveQuestion(activeQuestion === index ? null : index);
  };

  const handlePlayClick = (index) => {
    setPlayingVideos((prevState) => ({
      ...prevState,
      [index]: { playing: true, showButton: false },
    }));
    document.getElementById(`video-${index}`).play();
  };

  const handleVideoClick = (index) => {
    const video = document.getElementById(`video-${index}`);
    if (playingVideos[index]?.playing) {
      video.pause();
      setPlayingVideos((prevState) => ({
        ...prevState,
        [index]: { playing: false, showButton: true },
      }));
    } else {
      video.play();
      setPlayingVideos((prevState) => ({
        ...prevState,
        [index]: { playing: true, showButton: false },
      }));
    }
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true, // Enables centered view with partial prev/next slides visible
        },
      },
    ],
  };

  const videoTestimonials = [
    'https://futurhealth.com/new/_nuxt/videos/ShiftAmb.e2c04db.mp4',
    'https://g-plans.com/new/_nuxt/videos/ShiftReb.81ab906.mp4',
    'https://g-plans.com/new/_nuxt/videos/ShiftAly.69d7a2b.mp4'
  ];

  const faqData = [
    {
      question: "What is the LearnFormula Weight Loss Plan?",
      answer: "LearnFormula Weight Loss Plan is a weight loss plan that includes a personalized meal program, online dietician coaching and a biofeedback band to optimize and track your fat burning."
    },
    {
      question: "How does the meal program work?",
      answer: "The meal program is designed based on your unique needs and preferences. It includes a variety of nutritious and delicious meals that are easy to prepare and follow."
    },
    {
      question: "What kind of support will I receive?",
      answer: "You will receive 1:1 dietician guidance, access to a community of like-minded individuals, and continuous support from our team to ensure you stay on track with your weight loss journey."
    },
  ];

  const reviewsData = [
    {
      title: "“My weight loss journey with LeanFormula”",
      rating: 5,
      review: "I have been happy with my LeanFormula experience so far! It’s been the only real successful way I’ve been able to lose weight! And I've tried everything else on the market with no noticeable results.”",
      name: "Phyllis J.",
      image: "https://leanformula.co/wp-content/uploads/2024/07/verified-customer-badge.svg"
    },
    {
      title: "“Highly recommend LeanFormula”",
      rating: 5,
      review: "LeanFormula has changed my life. The personalized meal plans and support have helped me achieve my weight loss goals in a sustainable way.”",
      name: "John D.",
      image: "https://leanformula.co/wp-content/uploads/2024/07/verified-customer-badge.svg"
    },
    {
      title: "“The best weight loss plan”",
      rating: 5,
      review: "I've tried many weight loss plans, but LeanFormula is the best. The telehealth support and access to medications have been crucial in my journey.”",
      name: "Emily R.",
      image: "https://leanformula.co/wp-content/uploads/2024/07/verified-customer-badge.svg"
    },
  ];

  const renderStars = (count) => {
    return [...Array(count)].map((_, index) => (
      <svg key={index} width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#ffffff"></path>
      </svg>
    ));
  };


  return (
    <div>
      <div className="results__header">
        <div className="_contentContainer_1arkq_15">
          <div className="results__headerContainer">
            <div className="_logo_fkrec_1">
              <img
                src={"https://leanformula.co/wp-content/uploads/2024/07/leanformula-logo-purple-dark.svg"}
                alt="logo"
                className="logo__img"
                width="200px"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="results__timerBar">
        <div className="_root_14go4_1 _withBiggerPadding_14go4_24">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="_icon_14go4_20">
            <g clip-path="url(#clip0_2124_58499)">
              <path d="M11.988 0C5.364 0 0 5.376 0 12C0 18.624 5.364 24 11.988 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 11.988 0ZM12 21.6C6.696 21.6 2.4 17.304 2.4 12C2.4 6.696 6.696 2.4 12 2.4C17.304 2.4 21.6 6.696 21.6 12C21.6 17.304 17.304 21.6 12 21.6Z" fill="#00203e"></path><path d="M12.5998 6.9C12.5998 6.40294 12.1969 6 11.6998 6C11.2027 6 10.7998 6.40294 10.7998 6.9V9.54098V12.511C10.7998 12.8648 10.9868 13.1923 11.2916 13.3722L16.3821 16.3764C16.781 16.6118 17.2949 16.4853 17.5389 16.0917C17.7914 15.6843 17.6583 15.1489 17.2443 14.9073L12.5998 12.1967V6.9Z" fill="#00203e"></path>
            </g>
            <defs>
              <clipPath id="clip0_2124_58499">
                <rect width="24" height="24" fill="#00203e"></rect>
              </clipPath>
            </defs>
          </svg>
          <p type="medium-text" color="surface-main" className="sc-iGgWBj oTTWo">Your discount is secured for&nbsp;</p>
          {timeLeft > 0 ? (
            <div className="_timerBox_14go4_12">
              <p type="medium-text" color="surface-main" className="sc-iGgWBj oTTWo">{`${minutes}:${seconds} min`}</p>
            </div>
          ) : null}
        </div>
      </div>
      <div className="_container_1u1wn_1">
        <div>
          <div className="results__reviewBar">
            <div className="_rateBox_1smw0_11">
              <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#4441d9"></path></svg>
              <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#4441d9"></path></svg>
              <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#4441d9"></path></svg>
              <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#4441d9"></path></svg>
              <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#4441d9"></path></svg>
              <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.46534 11.2446C7.17402 11.0915 6.82598 11.0915 6.53466 11.2446L4.09119 12.5293C3.35756 12.9149 2.50013 12.292 2.64024 11.4751L3.1069 8.75423C3.16254 8.42984 3.05499 8.09884 2.81931 7.8691L0.842497 5.94219C0.248979 5.36365 0.576491 4.35568 1.39671 4.2365L4.12859 3.83953C4.4543 3.7922 4.73587 3.58763 4.88153 3.29249L6.10326 0.816985C6.47008 0.0737389 7.52992 0.0737404 7.89674 0.816986L9.11847 3.29249C9.26413 3.58763 9.5457 3.7922 9.87141 3.83953L12.6033 4.2365C13.4235 4.35568 13.751 5.36365 13.1575 5.94219L11.1807 7.8691C10.945 8.09884 10.8375 8.42984 10.8931 8.75423L11.3598 11.4751C11.4999 12.292 10.6424 12.9149 9.90881 12.5293L7.46534 11.2446Z" fill="#4441d9"></path></svg>
            </div>
            <h6>Based on <b>5.5K</b> Reviews!</h6>
          </div>
          <p type="h3" color="text-main" className="results__h3">Your Personal Weight Loss Plan is <i>Ready!</i></p>
          <div className="results__planSystem">
            <div className="planSystem__item">
              <h3>AGE</h3>
              <p>{age}</p>
            </div>
            <div className="planSystem__item">
              <h3>Metabolism</h3>
              <p>
                Dual Eff
              </p>
            </div>
            <div className="planSystem__item">
              <h3>Sex</h3>
              <p>{gender}</p>
            </div>
          </div>
          <p className="results__p">
            You’ll get personalized care for your unique biology with a <b>diet regimen</b>, <b>1:1 dietician guidance</b>, an <b>expert-designed weekly meal plan</b>, and <b>community support</b>.
          </p>
          <div className="results__weightGraph">
            <div className="weightGraph__graphImages">
              <div className="weightGraph__graphOverlay"></div>
              <div className="weightGraph__lines">
                <div className="weightGraph__line"></div>
                <div className="weightGraph__line"></div>
                <div className="weightGraph__line"></div>
              </div>
              <div className="weightGraph__goal--start">
                <div className="weightGraph__line"></div>
                <div className="weightGraph__pop--start">
                  <span className="weightGraph__popNumber--start">
                    <b>{Math.round(currentWeight)}</b> {weightUnit}
                  </span>
                </div>
              </div>
              <div className="weightGraph__goal--finish">
                <div className="weightGraph__line"></div>
                <div className="weightGraph__pop--finish">
                  <span className="weightGraph__icon">
                    🎉
                  </span> <span className="weightGraph__popNumber--finish">
                    <b>{Math.round(perfectWeightInUnit)}</b> {weightUnit}</span>
                  <span className="weightGraph__popInfo">Goal Weight</span>
                </div>
              </div>
              <img className="weightGraph__image--front" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgxIiBoZWlnaHQ9IjgxIiB2aWV3Qm94PSIwIDAgMjgxIDgxIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMiAyLjIyNDYxQzMzLjI5NDYgMzMuOTc4IDg5LjQ2NTggNDMuOTc4IDE0MSA1MC42MzczQzE5Mi41MzQgNTcuMjk2NyAyMzkuNTM3IDY2LjAwMDUgMjgwIDc5LjA1MDEiIHN0cm9rZT0iIzQ0NDFEOSIgc3Ryb2tlLXdpZHRoPSI0Ii8+Cjwvc3ZnPgo=" lazy="loaded" />
              <img className="weightGraph__image--back" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjY3IiBoZWlnaHQ9IjEyNiIgdmlld0JveD0iMCAwIDI2NyAxMjYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMS41IDEyNC41VjEuNUMxLjUgMS41IDI1LjA0ODEgMjUuMTA5MSA1NC40NDU5IDM0QzgzLjg0MzcgNDIuODkwOSAxMzEuNSA1MC41IDEzMS41IDUwLjVMMjY1LjUgNzAuNjYwN1YxMjQuNUgxLjVaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMTc0N18xMDYwKSIvPgo8cGF0aCBkPSJNMS41IDEuNVYxMjQuNSIgc3Ryb2tlPSIjMTgxODRBIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS1kYXNoYXJyYXk9IjEwIDEwIi8+CjxwYXRoIGQ9Ik0yNjUuNSA1OS41VjEyNC41IiBzdHJva2U9IiMxODE4NEEiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLWRhc2hhcnJheT0iMTAgMTAiLz4KPHBhdGggZD0iTTEzMS41IDUwLjVWMTI0LjUiIHN0cm9rZT0iIzE4MTg0QSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBzdHJva2UtZGFzaGFycmF5PSIxMCAxMCIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzE3NDdfMTA2MCIgeDE9Ijg0LjMwMyIgeTE9IjUyLjQ2OTIiIHgyPSI4Mi40MTgiIHkyPSIxMjIuNjY0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNDOUUzRkEiIHN0b3Atb3BhY2l0eT0iMC44Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0FEQzRGRiIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==" lazy="loaded" />
            </div>
            <div className="weightGraph__dates">
              <h5>Start</h5>
              <h5>Phase 2</h5>
              <span><b>Phase 3</b>
              </span>
            </div>
          </div>
          <div className="results__goals">
            <h4 className="results__h4">The goals <span>you will accomplish</span> with your plan:</h4>
            <ul className="goals__list">
              <li className="goals__listItem"><svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.20312 0.351562V0.328125L10.5156 5.39062C10.8203 5.74219 10.8203 6.25781 10.5156 6.60938L6.20312 11.6719C6.01562 11.8828 5.75781 12 5.5 12C5.21875 12 4.96094 11.8828 4.77344 11.6719L0.460938 6.60938C0.15625 6.25781 0.15625 5.74219 0.460938 5.41406L4.77344 0.351562C4.96094 0.140625 5.21875 0 5.5 0C5.75781 0 6.01562 0.140625 6.20312 0.351562Z" fill="#FFC1AD"></path></svg>
                Lose {Math.round(weightToLose)} {weightUnit}
              </li>
              <li className="goals__listItem"><svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.20312 0.351562V0.328125L10.5156 5.39062C10.8203 5.74219 10.8203 6.25781 10.5156 6.60938L6.20312 11.6719C6.01562 11.8828 5.75781 12 5.5 12C5.21875 12 4.96094 11.8828 4.77344 11.6719L0.460938 6.60938C0.15625 6.25781 0.15625 5.74219 0.460938 5.41406L4.77344 0.351562C4.96094 0.140625 5.21875 0 5.5 0C5.75781 0 6.01562 0.140625 6.20312 0.351562Z" fill="#FFC1AD"></path></svg>
                Reset your “metabolic equilibrium" so your body wants to naturally stay at {Math.round(perfectWeightInUnit)} {weightUnit}
              </li>
              <li className="goals__listItem"><svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.20312 0.351562V0.328125L10.5156 5.39062C10.8203 5.74219 10.8203 6.25781 10.5156 6.60938L6.20312 11.6719C6.01562 11.8828 5.75781 12 5.5 12C5.21875 12 4.96094 11.8828 4.77344 11.6719L0.460938 6.60938C0.15625 6.25781 0.15625 5.74219 0.460938 5.41406L4.77344 0.351562C4.96094 0.140625 5.21875 0 5.5 0C5.75781 0 6.01562 0.140625 6.20312 0.351562Z" fill="#FFC1AD"></path></svg>
                Look and feel healthier
              </li>
            </ul>
            <div className="goals__phone">
              <div><h3 >Your plan</h3> <p>
                You’ll get <i ><b>everything you need</b></i> <br className="d-none d-md-block" /> to drop those {Math.round(weightToLose)} {weightUnit} and keep <br /> them off.
              </p></div> <img className="goals__phoneImage" src="https://leanformula.co/wp-content/uploads/2024/07/leanformula-main-product-square-800x800-1.png" lazy="loaded" /></div>
          </div>
          <div className="results__included">
            <h3>What’s included?</h3>
            <div className="results__includedItem">
              <img src="https://futurhealth.com/new/_nuxt/img/included4.11d6e26.png" lazy="loaded" />
              <div>
                <h4 className="mb8">
                  Customized weight loss plan
                </h4>
              </div>
            </div>
            <div className="results__includedItem">
              <img src="https://futurhealth.com/new/_nuxt/img/included4.11d6e26.png" lazy="loaded" />
              <div>
                <h4>
                  Dietician guidance
                </h4>
              </div>
            </div>
            <div className="results__includedItem">
              <img src="https://futurhealth.com/new/_nuxt/img/included4.11d6e26.png" lazy="loaded" />
              <div>
                <h4>
                  Weekly updated diet plan based on metabolism
                </h4>
              </div>
            </div>
            <div className="results__includedItem">
              <img src="https://futurhealth.com/new/_nuxt/img/included4.11d6e26.png" lazy="loaded" />
              <div>
                <h4>Daily nutrition curriculum</h4>
              </div>
            </div>
            <div style={{ color: 'rgb(173, 196, 255)', textAlign: 'center' }}>
              + <i >community and more!</i>
            </div>
          </div>
          <div className="plans">
            <h3>Choose the best plan for you</h3>
            <h6>Your approval is reserved for <span style={{ color: 'rgb(217, 65, 65)', fontWeight: 600 }}>{timeLeft > 0 ? `${minutes}:${seconds} min` : null}</span></h6>
            <div className="plans__options">
              <div className={`plans__item ${selectedPlan === 'annual' ? 'active' : ''} plans__item--top`} onClick={() => handlePlanSelect('annual')}>
                {/* <div className="plans__bonus">
                  <img src="https://leanformula.co/wp-content/uploads/2024/07/health-tracker-band.png" />
                </div> */}
                <div className="plans__leftInfo">
                  <div className="plans__radio"></div>
                  <div>
                    <div className="plans__title">
                      <h4>
                        Year Plan
                      </h4>
                      <div className="plans__discountBanner">
                        SAVE $741 + Free Health Tracker
                      </div>
                    </div>
                    <p>
                      Pay $354 today
                    </p>
                  </div>
                </div>
                <div className="plans__rightInfo">
                  <s>$3.00</s>
                  <div className="plans__price">
                    $0.97
                  </div>
                  <div className="plans__pricePer">
                    Per <br />
                    Day
                  </div>
                </div>
              </div>
              <div className={`plans__item ${selectedPlan === 'quarterly' ? 'active' : ''}`} onClick={() => handlePlanSelect('quarterly')}>
                <div className="plans__leftInfo">
                  <div className="plans__radio"></div>
                  <div>
                    <h4>90 Day Plan</h4>
                    <p>
                      Pay $135 today
                      {/* <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none"><circle cx="2" cy="2" r="2" fill="#9CA3AF"></circle></svg>
                      $ 774 total */}
                    </p>
                  </div>
                </div>
                <div className="plans__rightInfo">
                  <s>$3.00</s>
                  <div className="plans__price">
                    $1.50
                  </div>
                  <div className="plans__pricePer">
                    Per <br />
                    Day
                  </div>
                </div>
              </div>
            </div>
            <button type="button" className="plans__button" onClick={openCTA}>
              Checkout
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19 12L13 6M19 12L13 18M19 12H5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </button>
            <div className="plans__guarantee">
              <img src="https://leanformula.co/wp-content/uploads/2024/05/retarget.745dd16.svg" lazy="loaded" />
              <div>
                <h4>
                  90 Day Weight Loss Guarantee
                </h4>
                <p>
                  If you don't lose body weight by the end of your program, we give you all of your money back. It’s
                  that simple.
                </p>
              </div>
            </div>
          </div>
        </div>
        <p type="caption" color="text-secondary-subdued" className="sc-iGgWBj btcOML">The displayed results are not representative and depend on various factors such as gender, age, physical condition, adherence to meal and workout plan, etc. This is not an offer or promise of results. Consult your physician to receive any particular recommendations on your specific health conditions.</p>
      </div>
      <div className="badges" style={{ backgroundColor: 'rgb(24, 24, 74)' }}>
        <div className="badges__container">
          <img src="https://leanformula.co/wp-content/uploads/2024/07/researchbadges.png" lazy="loaded" />
        </div>
      </div>
      <div className="videos">
        <div className="videos__container">
          <h3>Hear how LeanFormula changed their <i>lives</i></h3>
          <p>The top LeanFormula success stories are from clients who complete the 90 day program.</p>
          <div className="video-testimonials">
            <Slider {...sliderSettings}>
              {videoTestimonials.map((video, index) => (
                <div key={index} className="video-slide">
                  <div className="video-wrapper">
                    {(!playingVideos[index]?.playing || playingVideos[index]?.showButton) && (
                      <div
                        className="play-button"
                        onClick={() => handlePlayClick(index)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="64"
                          height="64"
                          viewBox="0 0 24 24"
                          fill="white"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    )}
                    <video
                      id={`video-${index}`}
                      width="100%"
                      onClick={() => handleVideoClick(index)}
                    >
                      <source src={video} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
      <div className="reviews">
        <div className="reviews__container">
          {reviewsData.map((review, index) => (
            <div key={index} className="reviews__item">
              <div className="reviews__title">
                <h3>{review.title}</h3>
                <div className="reviews__stars">
                  {renderStars(review.rating)}
                </div>
              </div>
              <p>{review.review}</p>
              <div className="reviews__name">
                <h4>{review.name}</h4>
                <img src={review.image} alt="Verified customer badge" />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="recap">
        <div className="recap__container">
          <div className="recap__mockup">
            <div className="recap__mockupHeader">
              <div className="recap__mockupTag">
                We’re ready!
              </div>
              <h3>Let’s get started now</h3>
              <h6>Your approval is reserved for <span style={{ color: 'rgb(217, 65, 65)', fontWeight: 600 }}>{timeLeft > 0 ? `${minutes}:${seconds} min` : null}</span></h6>
            </div>
            <div className="recap__mockupImage">
              <img src="https://leanformula.co/wp-content/uploads/2024/07/leanformula-coach-call-1000px.png" lazy="loaded" />
            </div>
          </div>
          <div className="recap__list">
            <div className="recap__listHeader">
              Start now for less than $1 a day - 100% risk free
            </div>
            <h3>The most powerful weight loss program - <i style={{ fontFamily: 'Charter' }} >is yours</i></h3>
            <h4>What’s included?</h4>
            <div className="recap__listBenefit">
              <div className="recap__listIcon">
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAxMyAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjI1IDAuNUMxMS42MTcyIDAuNSAxMi43NSAxLjYzMjgxIDEyLjc1IDNWMThDMTIuNzUgMTkuNDA2MiAxMS42MTcyIDIwLjUgMTAuMjUgMjAuNUgyLjc1QzEuMzQzNzUgMjAuNSAwLjI1IDE5LjQwNjIgMC4yNSAxOFYzQzAuMjUgMS42MzI4MSAxLjM0Mzc1IDAuNSAyLjc1IDAuNUgxMC4yNVpNNS4yNSAxLjc1VjIuMzc1SDcuNzVWMS43NUg1LjI1Wk0xMS41IDE4VjNDMTEuNSAyLjMzNTk0IDEwLjkxNDEgMS43NSAxMC4yNSAxLjc1SDlWMi4zNzVDOSAzLjA3ODEyIDguNDE0MDYgMy42MjUgNy43NSAzLjYyNUg1LjI1QzQuNTQ2ODggMy42MjUgNCAzLjA3ODEyIDQgMi4zNzVWMS43NUgyLjc1QzIuMDQ2ODggMS43NSAxLjUgMi4zMzU5NCAxLjUgM1YxOEMxLjUgMTguNzAzMSAyLjA0Njg4IDE5LjI1IDIuNzUgMTkuMjVIMTAuMjVDMTAuOTE0MSAxOS4yNSAxMS41IDE4LjcwMzEgMTEuNSAxOFpNNy43NSAxNi4xMjVDOC4wNjI1IDE2LjEyNSA4LjM3NSAxNi40Mzc1IDguMzc1IDE2Ljc1QzguMzc1IDE3LjEwMTYgOC4wNjI1IDE3LjM3NSA3Ljc1IDE3LjM3NUg1LjI1QzQuODk4NDQgMTcuMzc1IDQuNjI1IDE3LjEwMTYgNC42MjUgMTYuNzVDNC42MjUgMTYuNDM3NSA0Ljg5ODQ0IDE2LjEyNSA1LjI1IDE2LjEyNUg3Ljc1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==" lazy="loaded" />
              </div>
              <p>
                Online personal coach support
              </p>
            </div>
            <div className="recap__listBenefit">
              <div className="recap__listIcon">
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjI1IDhDMjAuMjUgOS4xNzE4OCAxOS40Mjk3IDEwLjE0ODQgMTguMzc1IDEwLjQyMTlWMTQuMjVDMTguMzc1IDE3LjY0ODQgMTUuNTYyNSAyMC40NjA5IDEyLjEyNSAyMC40NjA5QzguNjQ4NDQgMjAuNDYwOSA1Ljg3NSAxNy42ODc1IDUuODc1IDE0LjI1VjE0LjE3MTlDMi43MTA5NCAxMy44NTk0IDAuMjUgMTEuMjAzMSAwLjI1IDhWMi40MTQwNkMwLjI1IDIuMTQwNjIgMC4zNjcxODggMS45NDUzMSAwLjU2MjUgMS43ODkwNkwzLjA2MjUgMC41NzgxMjVDMy4zNzUgMC40MjE4NzUgMy43NjU2MiAwLjUzOTA2MiAzLjkyMTg4IDAuODUxNTYyQzQuMDc4MTIgMS4xNjQwNiAzLjk2MDk0IDEuNTU0NjkgMy42NDg0NCAxLjcxMDk0TDEuNSAyLjc2NTYyVjhDMS41IDEwLjc3MzQgMy43MjY1NiAxMyA2LjUgMTNDOS4yMzQzOCAxMyAxMS41IDEwLjc3MzQgMTEuNSA4VjIuNzY1NjJMOS4zMTI1IDEuNzEwOTRDOSAxLjU1NDY5IDguODgyODEgMS4xNjQwNiA5LjAzOTA2IDAuOTI5Njg4QzkuMTk1MzEgMC42MTcxODggOS41ODU5NCAwLjUgOS44OTg0NCAwLjY1NjI1TDEyLjM5ODQgMS44NjcxOUMxMi41OTM4IDEuOTg0MzggMTIuNzUgMi4xNzk2OSAxMi43NSAyLjQxNDA2VjhDMTIuNzUgMTEuMjQyMiAxMC4yNSAxMy44OTg0IDcuMTI1IDE0LjIxMDlWMTQuMjVDNy4xMjUgMTYuOTg0NCA5LjM1MTU2IDE5LjI1IDEyLjEyNSAxOS4yNUMxNC44NTk0IDE5LjI1IDE3LjEyNSAxNy4wMjM0IDE3LjEyNSAxNC4yNVYxMC40MjE5QzE2LjAzMTIgMTAuMTQ4NCAxNS4yNSA5LjE3MTg4IDE1LjI1IDhDMTUuMjUgNi42NzE4OCAxNi4zNDM4IDUuNTM5MDYgMTcuNzUgNS41MzkwNkMxOS4xMTcyIDUuNTM5MDYgMjAuMjUgNi42MzI4MSAyMC4yNSA4Wk0xNy43NSA5LjI1QzE4LjQxNDEgOS4yNSAxOSA4LjcwMzEyIDE5IDguMDM5MDZDMTkgNy40MTQwNiAxOC40MTQxIDYuODI4MTIgMTcuNzUgNi44MjgxMkMxNy4wNDY5IDYuODI4MTIgMTYuNSA3LjM3NSAxNi41IDguMDM5MDZDMTYuNSA4LjcwMzEyIDE3LjA0NjkgOS4yNSAxNy43NSA5LjI1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==" lazy="loaded" />
              </div>
              <p>
                Dietician guidance
              </p>
            </div>
            <div className="recap__listBenefit">
              <div className="recap__listIcon">
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAxNSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuMzc1IDUuNUM0LjAyMzQ0IDUuNSAzLjc1IDUuMjI2NTYgMy43NSA0Ljg3NUMzLjc1IDQuNTYyNSA0LjAyMzQ0IDQuMjUgNC4zNzUgNC4yNUg1LjMxMjVDNS4xMTcxOSAzLjg5ODQ0IDUgMy40Njg3NSA1IDNDNSAxLjYzMjgxIDYuMDkzNzUgMC41IDcuNSAwLjVDOC44NjcxOSAwLjUgMTAgMS42MzI4MSAxMCAzQzEwIDMuNDY4NzUgOS44NDM3NSAzLjg5ODQ0IDkuNjQ4NDQgNC4yNUgxMC42MjVDMTAuOTM3NSA0LjI1IDExLjI1IDQuNTYyNSAxMS4yNSA0Ljg3NUMxMS4yNSA1LjIyNjU2IDEwLjkzNzUgNS41IDEwLjYyNSA1LjVINC4zNzVaTTcuNSAxLjc1QzYuNzk2ODggMS43NSA2LjI1IDIuMzM1OTQgNi4yNSAzQzYuMjUgMy43MDMxMiA2Ljc5Njg4IDQuMjUgNy41IDQuMjVDOC4xNjQwNiA0LjI1IDguNzUgMy43MDMxMiA4Ljc1IDNDOC43NSAyLjMzNTk0IDguMTY0MDYgMS43NSA3LjUgMS43NVpNMTIuNSAzQzEzLjg2NzIgMyAxNSA0LjEzMjgxIDE1IDUuNVYxOEMxNSAxOS40MDYyIDEzLjg2NzIgMjAuNSAxMi41IDIwLjVIMi41QzEuMDkzNzUgMjAuNSAwIDE5LjQwNjIgMCAxOFY1LjVDMCA0LjEzMjgxIDEuMDkzNzUgMyAyLjUgM0MyLjgxMjUgMyAzLjEyNSAzLjMxMjUgMy4xMjUgMy42MjVDMy4xMjUgMy45NzY1NiAyLjgxMjUgNC4yNSAyLjUgNC4yNUMxLjc5Njg4IDQuMjUgMS4yNSA0LjgzNTk0IDEuMjUgNS41VjE4QzEuMjUgMTguNzAzMSAxLjc5Njg4IDE5LjI1IDIuNSAxOS4yNUgxMi41QzEzLjE2NDEgMTkuMjUgMTMuNzUgMTguNzAzMSAxMy43NSAxOFY1LjVDMTMuNzUgNC44MzU5NCAxMy4xNjQxIDQuMjUgMTIuNSA0LjI1QzEyLjE0ODQgNC4yNSAxMS44NzUgMy45NzY1NiAxMS44NzUgMy42MjVDMTEuODc1IDMuMzEyNSAxMi4xNDg0IDMgMTIuNSAzWk00LjM3NSAxMy42MjVDNC4wMjM0NCAxMy42MjUgMy43NSAxMy4zNTE2IDMuNzUgMTNWMTEuNzVDMy43NSAxMS40Mzc1IDQuMDIzNDQgMTEuMTI1IDQuMzc1IDExLjEyNUg2LjI1VjkuMjVDNi4yNSA4LjkzNzUgNi41MjM0NCA4LjYyNSA2Ljg3NSA4LjYyNUg4LjEyNUM4LjQzNzUgOC42MjUgOC43NSA4LjkzNzUgOC43NSA5LjI1VjExLjEyNUgxMC42MjVDMTAuOTM3NSAxMS4xMjUgMTEuMjUgMTEuNDM3NSAxMS4yNSAxMS43NVYxM0MxMS4yNSAxMy4zNTE2IDEwLjkzNzUgMTMuNjI1IDEwLjYyNSAxMy42MjVIOC43NVYxNS41QzguNzUgMTUuODUxNiA4LjQzNzUgMTYuMTI1IDguMTI1IDE2LjEyNUg2Ljg3NUM2LjUyMzQ0IDE2LjEyNSA2LjI1IDE1Ljg1MTYgNi4yNSAxNS41VjEzLjYyNUg0LjM3NVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=" lazy="loaded" />
              </div>
              <div>
                <p className="mb8">
                  Metabolic test
                </p>
                <i className="d-block text-700 fs12" style={{ color: 'rgb(10, 0, 33)' }}>Includes custom in-depth metabolic results</i>
              </div>
            </div>
            <div className="recap__listBenefit">
              <div className="recap__listIcon">
                <img src="data:image/svg+xml;base64,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" lazy="loaded" />
              </div>
              <p>
                Weekly program updates based on your progress
              </p>
            </div>
            <div className="recap__listBenefit">
              <div className="recap__listIcon">
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAxOCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjUgMTQuODc1QzE3LjUgMTUuNjk1MyAxNi45NTMxIDE2LjM5ODQgMTYuMjUgMTYuNjcxOVYxOS4yNUgxNi44NzVDMTcuMTg3NSAxOS4yNSAxNy41IDE5LjU2MjUgMTcuNSAxOS44NzVDMTcuNSAyMC4yMjY2IDE3LjE4NzUgMjAuNSAxNi44NzUgMjAuNUgyLjVDMS4wOTM3NSAyMC41IDAgMTkuNDA2MiAwIDE4VjMuNjI1QzAgMS45MDYyNSAxLjM2NzE5IDAuNSAzLjEyNSAwLjVIMTUuNjI1QzE2LjY0MDYgMC41IDE3LjUgMS4zNTkzOCAxNy41IDIuMzc1VjE0Ljg3NVpNMS4yNSAzLjYyNVYxNS44NTE2QzEuNjAxNTYgMTUuNjU2MiAyLjAzMTI1IDE1LjUgMi41IDE1LjVIMy43NVYxLjc1SDMuMTI1QzIuMDcwMzEgMS43NSAxLjI1IDIuNjA5MzggMS4yNSAzLjYyNVpNMTUgMTkuMjVWMTYuNzVIMi41QzEuNzk2ODggMTYuNzUgMS4yNSAxNy4zMzU5IDEuMjUgMThDMS4yNSAxOC43MDMxIDEuNzk2ODggMTkuMjUgMi41IDE5LjI1SDE1Wk0xNS42MjUgMTUuNUMxNS45Mzc1IDE1LjUgMTYuMjUgMTUuMjI2NiAxNi4yNSAxNC44NzVWMi4zNzVDMTYuMjUgMi4wNjI1IDE1LjkzNzUgMS43NSAxNS42MjUgMS43NUg1VjE1LjVIMTUuNjI1Wk0xMy43NSA1LjVDMTQuMDYyNSA1LjUgMTQuMzc1IDUuODEyNSAxNC4zNzUgNi4xMjVDMTQuMzc1IDYuNDc2NTYgMTQuMDYyNSA2Ljc1IDEzLjc1IDYuNzVINy41QzcuMTQ4NDQgNi43NSA2Ljg3NSA2LjQ3NjU2IDYuODc1IDYuMTI1QzYuODc1IDUuODEyNSA3LjE0ODQ0IDUuNSA3LjUgNS41SDEzLjc1Wk0xMy43NSA5LjI1QzE0LjA2MjUgOS4yNSAxNC4zNzUgOS41NjI1IDE0LjM3NSA5Ljg3NUMxNC4zNzUgMTAuMjI2NiAxNC4wNjI1IDEwLjUgMTMuNzUgMTAuNUg3LjVDNy4xNDg0NCAxMC41IDYuODc1IDEwLjIyNjYgNi44NzUgOS44NzVDNi44NzUgOS41NjI1IDcuMTQ4NDQgOS4yNSA3LjUgOS4yNUgxMy43NVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=" lazy="loaded" />
              </div>
              <p>
                Daily nutrition curriculum
              </p>
            </div>
          </div>
          <div className="plans">
            <h3>Choose the best plan for you</h3>
            <h6>Your approval is reserved for <span style={{ color: 'rgb(217, 65, 65)', fontWeight: 600 }}>{timeLeft > 0 ? `${minutes}:${seconds} min` : null}</span></h6>
            <div className="plans__options">
              <div className={`plans__item ${selectedPlan === 'annual' ? 'active' : ''} plans__item--top`} onClick={() => handlePlanSelect('annual')}>
                {/* <div className="plans__bonus">
                  <img src="https://leanformula.co/wp-content/uploads/2024/07/health-tracker-band.png" />
                </div> */}
                <div className="plans__leftInfo">
                  <div className="plans__radio"></div>
                  <div>
                    <div className="plans__title">
                      <h4>
                        Year Plan
                      </h4>
                      <div className="plans__discountBanner">
                        SAVE $741 + Free Health Tracker
                      </div>
                    </div>
                    <p>
                      Pay $354 today
                    </p>
                  </div>
                </div>
                <div className="plans__rightInfo">
                  <s>$3.00</s>
                  <div className="plans__price">
                    $0.97
                  </div>
                  <div className="plans__pricePer">
                    Per <br />
                    Day
                  </div>
                </div>
              </div>
              <div className={`plans__item ${selectedPlan === 'quarterly' ? 'active' : ''}`} onClick={() => handlePlanSelect('quarterly')}>
                <div className="plans__leftInfo">
                  <div className="plans__radio"></div>
                  <div>
                    <h4>90 Day Plan</h4>
                    <p>
                      Pay $135 today
                      {/* <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none"><circle cx="2" cy="2" r="2" fill="#9CA3AF"></circle></svg>
                      $ 774 total */}
                    </p>
                  </div>
                </div>
                <div className="plans__rightInfo">
                  <s>$3.00</s>
                  <div className="plans__price">
                    $1.50
                  </div>
                  <div className="plans__pricePer">
                    Per <br />
                    Day
                  </div>
                </div>
              </div>
            </div>
            <button type="button" className="plans__button" onClick={openCTA}>
              Checkout
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19 12L13 6M19 12L13 18M19 12H5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </button>
            <div className="plans__guarantee">
              <img src="https://leanformula.co/wp-content/uploads/2024/05/retarget.745dd16.svg" lazy="loaded" />
              <div>
                <h4>
                  90 Day Weight Loss Guarantee
                </h4>
                <p>
                  If you don't lose body weight by the end of your program, we give you all of your money back. It’s
                  that simple.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="faq">
        <div className="faq__container">
          <h3>Commonly asked questions about LeanFormula</h3>
          {faqData.map((faq, index) => (
            <div key={index} className="faq__item">
              <div
                className="faq__question"
                onClick={() => toggleQuestion(index)}
              >
                {faq.question}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  className={`arrow ${activeQuestion === index ? 'active' : ''}`}
                >
                  <path
                    d="M9.23077 1.23077V6.76923H14.7692C15.4231 6.76923 16 7.34615 16 8C16 8.69231 15.4231 9.23077 14.7692 9.23077H9.23077V14.7692C9.23077 15.4615 8.65385 16 8 16C7.30769 16 6.76923 15.4615 6.76923 14.7692V9.23077H1.23077C0.538462 9.23077 0 8.69231 0 8C0 7.34615 0.538462 6.76923 1.23077 6.76923H6.76923V1.23077C6.76923 0.576923 7.30769 0 8 0C8.65385 0 9.23077 0.576923 9.23077 1.23077Z"
                    fill="white"
                  />
                </svg>
              </div>
              <p
                className="faq__answer"
                style={{ display: activeQuestion === index ? 'block' : 'none' }}
              >
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="disclaimerFooter">
        <p type="caption" className="disclaimerFooter__text">The displayed results are not representative and depend on various factors such as gender, age, physical condition, adherence to meal and workout plan, etc. This is not an offer or promise of results. Consult your physician to receive any particular recommendations on your specific health conditions.</p>
      </div>
    </div>
  );
}

// Loading Results Component

function LoadingResults() {
  const navigate = useNavigate();
  const location = useLocation();
  const { activityLevel, bmi } = location.state || { activityLevel: 'NA', bmi: 'Not Set' };

  const [showScreen1, setShowScreen1] = useState(false);
  const [hideScreen1, setHideScreen1] = useState(false);
  const [showScreen2, setShowScreen2] = useState(false);
  const [hideScreen2, setHideScreen2] = useState(true);
  const [showScreen3, setShowScreen3] = useState(false);
  const [hideScreen3, setHideScreen3] = useState(true);

  const [showText1, setShowText1] = useState(false);
  const [hideText1, setHideText1] = useState(false);
  const [showText2, setShowText2] = useState(false);
  const [hideText2, setHideText2] = useState(true);
  const [showText3, setShowText3] = useState(false);
  const [hideText3, setHideText3] = useState(true);

  useEffect(() => {
    setShowScreen1(true);
    setShowText1(true);

    const timer1 = setTimeout(() => {
      setShowScreen1(false);
      setShowText1(false);
      setTimeout(() => {
        setHideScreen1(true);
        setHideText1(true);
      }, 1000); // Wait for the fade-out transition to complete
    }, 5000); // Start fading out screen 1 at 5 seconds

    const timer2 = setTimeout(() => {
      setHideScreen2(false); // Make screen 2 visible
      setHideText2(false);
      setTimeout(() => {
        setShowScreen2(true); // Start fading in screen 2
        setShowText2(true);
      }, 100); // Start fading in screen 2
    }, 6000); // Start showing screen 2 at 6 seconds

    const timer3 = setTimeout(() => {
      setShowScreen2(false);
      setShowText2(false);
      setTimeout(() => {
        setHideScreen2(true);
        setHideText2(true);
      }, 1000); // Wait for the fade-out transition to complete
    }, 11000); // Start fading out screen 2 at 11 seconds

    const timer4 = setTimeout(() => {
      setHideScreen3(false); // Make screen 3 visible
      setHideText3(false);
      setTimeout(() => {
        setShowScreen3(true); // Start fading in screen 3
        setShowText3(true);
      }, 100); // Start fading in screen 3
    }, 12000); // Start showing screen 3 at 12 seconds

    const textElement = document.querySelector(".loadingBar__percent");
    let startTime = Date.now();
    let duration = 18000; // 18 seconds in milliseconds

    const intervalId = setInterval(() => {
      let currentTime = Date.now();
      let elapsedTime = currentTime - startTime;

      let percentage = (elapsedTime / duration) * 100;

      if (percentage >= 100) {
        percentage = 100;
        clearInterval(intervalId);
        handleNext(); // Navigate to next step when loading is complete

      }

      textElement.textContent = `${Math.round(percentage)}%`;
      document.querySelector('.loadingBar__fill').style.width = `${percentage}%`; // Update the fill width
    }, 100); // Update every 100ms

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearTimeout(timer4);
      clearInterval(intervalId);
    };
  }, []);

  // Function to navigate to the next step (step/20)
  const handleNext = () => {
    navigate(`/step/20`);
  };

  return (
    <div>
      <div className="loadingBar">
        <div className="loadingBar__container">
          <div className={`loadingBar__screen ${showScreen1 ? 'fade-in' : 'fade-out'} ${hideScreen1 ? 'hidden' : ''}`} id="loadingBar__screen1">
            <h3>Ready to become the next amazing transformation?</h3>
            <div className="scrollingContainer">
              <img src="https://leanformula.co/wp-content/uploads/2024/07/fat-loss-transformations-roll.jpg" className="scrollingImage" />
            </div>
          </div>
          <div className={`loadingBar__screen ${showScreen2 ? 'fade-in' : 'fade-out'} ${hideScreen2 ? 'hidden' : ''}`} id="loadingBar__screen2">
            <h3>Lose up to 20% of your body weight in 1 LeanFormula cycle...</h3>
            <img src="https://leanformula.co/wp-content/uploads/2024/07/calculate6.c107171.png" id="screen2__img" />
          </div>
          <div className={`loadingBar__screen ${showScreen3 ? 'fade-in' : 'fade-out'} ${hideScreen3 ? 'hidden' : ''}`} id="loadingBar__screen3">
            <h3>LeanFormula customers lose 2x more body fat than on their own</h3>
            <img src="https://leanformula.co/wp-content/uploads/2024/07/weight-lost-chart-01.svg" alt="Weight Chart" />
          </div>
        </div>
        <div className="loadingBar__progress">
          <div className="loadingBar__text">
            <h5 className={`loadingBar__textItem ${showText1 ? 'fade-in' : 'fade-out'} ${hideText1 ? 'hidden' : ''}`}>Analyzing all of your data...</h5>
            <h5 className={`loadingBar__textItem ${showText2 ? 'fade-in' : 'fade-out'} ${hideText2 ? 'hidden' : ''}`}>Matching you to your personal coach...</h5>
            <h5 className={`loadingBar__textItem ${showText3 ? 'fade-in' : 'fade-out'} ${hideText3 ? 'hidden' : ''}`}>Creating your custom weight loss plan...</h5>
          </div>
          <div className="loadingBar__bar">
            <div className="loadingBar__fill"></div>
            <div className="loadingBar__percent">0%</div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Fat Burning Component

function FatBurning() {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0); // Start progress at 0%
  const targetProgress = 36; // The final percentage value
  const duration = 5000; // Total duration for the animation (5 seconds)

  useEffect(() => {
    const startTime = performance.now();

    const easeOutCubic = (t) => (--t) * t * t + 1; // Easing function for a natural curve

    const animateProgress = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const normalizedTime = Math.min(elapsedTime / duration, 1); // Normalized time [0, 1]
      const progressValue = easeOutCubic(normalizedTime) * targetProgress;

      setProgress(progressValue.toFixed(0)); // Update progress state

      if (normalizedTime < 1) {
        requestAnimationFrame(animateProgress); // Continue the animation until it reaches the target
      }
    };

    requestAnimationFrame(animateProgress); // Start the animation
  }, []);

  // Function to navigate to the next step (step/20)
  const handleNext = () => {
    navigate(`/step/18`);
  };

  return (
    <div>
      <div className="step">
        <div className="step__container">
          <h3>Here's how well your body is burning fat</h3>
          <span className="bigNumber">{progress}%</span> {/* Display the progress percentage */}
          <div className="body-level">
            <div className="level">
              <div className="progress-bar" style={{ width: `${progress}%` }}>
                {progress}% {/* Display the same progress inside the bar */}
                <div className="tip">You are here</div>
              </div>
            </div>
            <div className="titles">
              <span>Low</span>
              <span>High</span>
            </div>
          </div>
          <h4>Using LeanFormula, the average user increased their fat burning capacity by over 40%.</h4>
          <button class="continueButton" onClick={handleNext}>Continue</button>
        </div>
      </div>
    </div>
  );
}


// Challenges Component
function Challenges() {
  const navigate = useNavigate();
  const location = useLocation();
  const { bmi } = location.state || { bmi: 'Overweight' };
  const { updateQuizData } = useQuiz(); // Assuming useQuiz provides an update function for quiz data


  // State to hold selected challenges
  const [selectedChallenges, setSelectedChallenges] = useState([]);

  // Handle changes when a checkbox is selected or deselected
  const handleChallengeChange = (event) => {
    const selectedChallenge = event.target.value;

    // Toggle selection in the state array
    setSelectedChallenges((prevChallenges) => {
      if (prevChallenges.includes(selectedChallenge)) {
        // If the challenge is already selected, remove it from the array
        return prevChallenges.filter((challenge) => challenge !== selectedChallenge);
      } else {
        // If not selected, add it to the array
        return [...prevChallenges, selectedChallenge];
      }
    });
  };

  const handleNextStep = () => {
    // Update quiz data with selected challenges
    updateQuizData({ challenges: selectedChallenges });

    // Navigate to the next step and pass along the selected challenges
    navigate(`/step/7${location.search}`, {
      state: {
        bmi,
        selectedChallenges, // Pass selected challenges to the next step
      },
    });
  };

  return (
    <div>
      <div className="step__container">
        <h3 className="step__question">
          What has been your biggest challenge in achieving weight loss in the past?
        </h3>
        <div className="answers__container">
          {["Lack of motivation", "Difficulty sticking to a diet", "No time for exercise", "Health issues"].map((challenge) => (
            <div
              className={`answer ${selectedChallenges.includes(challenge) ? "selected" : ""}`}
              key={challenge}
            >
              <input
                type="checkbox"
                id={challenge}
                value={challenge}
                checked={selectedChallenges.includes(challenge)}
                onChange={handleChallengeChange}
                className="answer__hiddenCheckBox"
              />
              <div className="answer__container">
                <div className="answer__content">
                  <p className="answer__text">
                    {challenge}
                  </p>
                  {/* Checkmark appears if the challenge is selected */}
                  {selectedChallenges.includes(challenge) && (
                    <span className="answer__checkmark"></span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="fixedButton">
        <div className="fixedButton__container">
          <button id="continueButton" className="fixedButton__button" onClick={handleNextStep}>Continue</button>
        </div>
      </div>
    </div>
  );
}


// Step 20 Component
function Exercise() {
  const navigate = useNavigate();
  const location = useLocation();
  const { bmi } = location.state || { bmi: 'Overweight' };
  const { updateQuizData } = useQuiz(); // Assuming useQuiz provides an update function for quiz data

  // State to hold selected exercise types
  const [selectedExerciseType, setSelectedExerciseType] = useState([]);

  // Handle changes when a checkbox is selected or deselected
  const handleExerciseChange = (event) => {
    const selectedType = event.target.value;

    // Toggle selection in the state array
    setSelectedExerciseType((prevTypes) => {
      if (prevTypes.includes(selectedType)) {
        // If the type is already selected, remove it from the array
        return prevTypes.filter((type) => type !== selectedType);
      } else {
        // If not selected, add it to the array
        return [...prevTypes, selectedType];
      }
    });
  };

  const handleNextStep = () => {
    // Update quiz data with selected exercise type
    updateQuizData({ selectedExerciseType });

    // Navigate to the next step and pass along the selected exercise type
    navigate(`/step/8${location.search}`, {
      state: {
        bmi,
        selectedExerciseType, // Pass selected exercise type to the next step
      },
    });
  };

  return (
    <div>
      <div className="step__container">
        <h3 className="step__question">
          What type of exercise do you prefer?
        </h3>
        <div className="answers__container">
          {["Cardio", "Strength training", "Flexibility (yoga, stretching)", "No preference"].map((exercise) => (
            <div
              className={`answer ${selectedExerciseType.includes(exercise) ? "selected" : ""}`}
              key={exercise}
            >
              <input
                type="checkbox"
                id={exercise}
                value={exercise}
                checked={selectedExerciseType.includes(exercise)}
                onChange={handleExerciseChange}
                className="answer__hiddenCheckBox"
              />
              <div className="answer__container">
                <div className="answer__content">
                  <p className="answer__text">
                    {exercise}
                  </p>
                  {/* Checkmark appears if the exercise type is selected */}
                  {selectedExerciseType.includes(exercise) && (
                    <span className="answer__checkmark"></span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="fixedButton">
        <div className="fixedButton__container">
          <button id="continueButton" className="fixedButton__button" onClick={handleNextStep}>Continue</button>
        </div>
      </div>
    </div>
  );
}



// Quiz Form Component
function QuizForm() {
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here (e.g., calculate score)
    // ...
    // Redirect to the results page
    navigate('/results');
  };

  return (
    <div>
      <h2>Quiz</h2>
      <form onSubmit={handleSubmit}>
        <Routes>
          {steps.map((step) => (
            <Route key={step.id} path={`/step/${step.id}`} element={<step.component />} />
          ))}
          <Route path="/step" element={<Navigate to="/step/1" replace={true} />} />
        </Routes>
      </form>
    </div>
  );
}



// Header Component
function Header() {
  const location = useLocation();
  const stepId = location.pathname.split('/').pop();
  const currentStep = parseInt(stepId, 10);
  const totalSteps = steps.length;
  const navigate = useNavigate();

  // Hide the entire Header component for /step/15/ route
  if (location.pathname === '/step/13' || location.pathname === '/step/19' || location.pathname === '/step/21') {
    return null;
  }

  const handleBack = () => {
    const previousStep = currentStep - 1;
    const newPath = `/step/${previousStep}${location.search}`;
    navigate(newPath);
  };

  const backIconStyle = {
    visibility: (currentStep > 1 && currentStep !== 1) ? 'visible' : 'hidden',
  };

  const showProgressBox = location.pathname.startsWith('/step');

  const progressBoxStyle = {
    visibility: showProgressBox ? 'visible' : 'hidden',
  };

  return (
    <header className="header__headerModule">
      <div className="headerModule__container">
        <div className="headerModule__top">
          <div onClick={handleBack} style={backIconStyle}>
            <svg
              width="24"
              height="24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="headerModule__backIcon"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.355 5.284a.75.75 0 01-.002 1.042l-4.077 4.207H21.25a.75.75 0 01.75.75v1.447a.75.75 0 01-.75.75H7.277l4.076 4.207a.75.75 0 01.002 1.042l-1.027 1.066a.75.75 0 01-1.08.001l-7.03-7.268a.75.75 0 010-1.043l7.03-7.269a.75.75 0 011.08.001l1.027 1.067z"
                fill="#D4DAE0"
              ></path>
            </svg>
          </div>
          <div className="headerModule__logo">
            <img
              src={"https://leanformula.co/wp-content/uploads/2024/07/leanformula-logo-purple-dark.svg"}
              alt="logo"
              className="logo__img"
              width="150px"
            />
          </div>
          <div className="headerModule__pageCount" style={progressBoxStyle}>
            <span className="pageCount__start">{currentStep}</span>
            <span className="pageCount__separator">/</span>
            <span className="pageCount__end">{totalSteps}</span>
          </div>
        </div>
        <div className="headerModule__progressBox" style={progressBoxStyle}>
          <div
            className="headerModule__progressBar"
            style={{ width: `${(currentStep / totalSteps) * 100}%` }}
          ></div>
        </div>
      </div>
    </header>
  );
}

const StepComponent = ({ stepId, component: Component }) => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(() => {
    const savedStep = localStorage.getItem('currentStep');
    return savedStep ? parseInt(savedStep, 10) : stepId;
  });

  useEffect(() => {
    localStorage.setItem('currentStep', currentStep.toString());
  }, [currentStep]);

  const handleNext = () => {
    setCurrentStep((prevStep) => {
      const nextStep = prevStep + 1;
      navigate(`/step/${nextStep}`);
      return nextStep;
    });
  };

  const handleBack = () => {
    setCurrentStep((prevStep) => {
      const previousStep = prevStep - 1;
      navigate(`/step/${previousStep}`);
      return previousStep;
    });
  };

  useEffect(() => {
    if (currentStep !== stepId) {
      navigate(`/step/${currentStep}`);
    }
  }, [currentStep, navigate, stepId]);

  return <Component handleNext={handleNext} handleBack={handleBack} />;
};

const App = () => {
  return (
    <QuizProvider>
      <Router>
        <Header />
        <main style={{ marginTop: 60 }}>
          <Routes>
            <Route path="/" element={<Start />} />
            <Route path="/results" element={<Results />} />
            {steps.map((step) => (
              <Route
                key={step.id}
                path={`/step/${step.id}`}
                element={
                  <StepWrapper stepId={step.id}>
                    <step.component />
                  </StepWrapper>
                }
              />
            ))}
            <Route path="/step" element={<Redirector />} /> {/* Redirector to handle initial redirect */}
          </Routes>
        </main>
      </Router>
    </QuizProvider>
  );
}

export default App;